import { useEffect, useState } from 'react'
import Header from '../../Common/Header/Header';
import "./UnitIntro.css";
import Loader from '../../Common/FullscreenLoader/FullScreenLoader';
import { useLocation } from 'react-router-dom';
import { createQuestion, createUnitInfo, deleteIntroByIntroId, deleteQuestionByQuestionId, getAllQuestionByUnitIdAndType, getAllUnitInfo, updateIntro, updateQuestion, searchQuestion, updateCongratsData, createCongratsData, updateInstructionData, createInstructionData } from '../../../api/question';
import { BlankDataType, DifficultType, DragMatchPairDataType, OptionDataType, PairDataType, QuestionDataType } from './QuestionInterface';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import ConfirmationPopup from '../../Common/MessagePopup/ConfirmationPopup';
import { getUnitByUnitId } from '../../../api/unit';
import { Action, OptionWithImage, QuestionCategory, QuestionType } from './QuestionEnum';
import { getNewAccessToken } from '../../../api/auth';
import { setToken } from '../../../reducers/UserSplice';
import { LoadingDataType, MessageDataType } from '../../Common/Common/CommonInterface';
import { UnitDataType } from '../Challenge/ChallengeInterface';
import { CarrouselDataType, IntroductionSectionDataType, LearningPathDataType, updatedMVPIntroDataType } from '../Unit-Intro/UnitIntroInterface';
import { Gesture } from '../Unit-Intro/UnitIntroEnum';
import { setActiveType } from '../../../reducers/tabSplice';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CustomAlert from '../../Common/MessagePopup/CustomeAlert';
import React from 'react';
import SuccessPopup from '../../Common/MessagePopup/SuccessPopup';
import FailurePopup from '../../Common/MessagePopup/FailurePopup';
import FullScreenLottieAnimation from '../../Common/LottieAnimation/FullScreenLottieAnimation';
import FullScreenImagePreview from '../../Common/LottieAnimation/FullScreenImagePreview';


const UnitIntro = () => {

  const location = useLocation();
  const dispatch = useAppDispatch();

  const [loading, setLoading] = useState<LoadingDataType>({
    fetchingLoading: false,
    tableLoading: false,
    deleteLoading: false,
    submitLoading: false,
    validationLoading: false,

  });

  const [selected, setSelected] = useState<{ carrousel: boolean, learningPath: boolean }>({ carrousel: false, learningPath: false })
  const [showPreview, setShowPreview] = useState<{imageShow: boolean, animationShow: boolean}>({imageShow: false, animationShow: false})
  
  useEffect(() => {

    if (!selected.carrousel) {
      setEditIntroData(prevState => ({
        ...prevState,
        carrousel: prevState.carrousel.map((item) => ({
          ...item,
          selected: false
        })),
        newCarrousel: prevState.newCarrousel.map((item) => ({
          ...item,
          selected: false
        })),
      }));
    }

    if (!selected.learningPath) {
      setEditIntroData(prevState => ({
        ...prevState,
        learningPath: prevState.learningPath.map((item) => ({
          ...item,
          selected: false
        })),
        newLearningPath: prevState.newLearningPath.map((item) => ({
          ...item,
          selected: false
        })),
      }));
    }
  }, [selected]);



  function removeSpans(html: string): string {
    // Remove opening span tags with attributes
    let cleaned = html.replace(/<span[^>]*>/g, "");
    // Remove closing span tags
    cleaned = cleaned.replace(/<\/span>/g, "");
    return cleaned;
  }

  const checkFileLimit = (file: File): boolean => {

    switch (file.type) {
      case "video/mp4":
      case "video/webm":
        return file.size <= 250 * 1024 * 1024; // 250 MB

      case "audio/wav":
      case "audio/mpeg": // standard MIME for mp3
        return file.size <= 20 * 1024 * 1024; // 20 MB

      case "image/png":
      case "image/jpeg": // covers both jpg & jpeg
      case "application/json":
      case "image/svg+xml":
        return file.size <= 20 * 1024 * 1024; // 20 MB

      default:
        // fallback (100 MB limit)
        return file.size <= 100 * 1024 * 1024;
    }
  };



  const selectedContainer = (type: "carrousel" | "learningPath") => {
    setSelected(prev => ({
      ...prev,
      [type]: !prev[type],
      ...(prev[type] ? {} : { [type === "carrousel" ? "learningPath" : "carrousel"]: false })
    }));
  };




  const [questionFilter, setQuestionFilter] = useState<{ questionType: QuestionType }>({
    questionType: QuestionType.none
  })
  // const indexOfLastItem = useMemo(() => currentPage * itemsPerPage, [currentPage, itemsPerPage]);
  // const indexOfFirstItem = useMemo(() => indexOfLastItem - itemsPerPage, [indexOfLastItem, itemsPerPage]);

  const [activeDifficultyType, setActiveDifficultyType] = useState<string>("1");
  const [showAddQuestion, setShowAddQuestion] = useState<boolean>(false)


  const [message, setMessage] = useState<MessageDataType>({
    errorMessage: [],
    successMessage: "",
    failureMessage: ""
  })

  useEffect(() => {
    if (message.errorMessage.length > 0) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

  }, [message.errorMessage.length])


  const [previewSource, setPreviewSource] = useState<string>("");
  const [editQuestionData, setEditQuestionData] = useState<QuestionDataType>({
    id: "",
    level: "",
    category: QuestionCategory.random,
    action: Action.none,
    gradeId: "",
    unitId: "",
    difficultyType: { id: "", name: "" },
    type: QuestionType.none,
    deletedOption: [],
    hint: "",
    reward: 0,
    deleteS3Path: [],
    mediaFile: {
      image: {
        files: "",
        blobPath: "",
        fileExtension: ""
      },
      questionMediaFile: {
        files: "",
        blobPath: "",
        fileExtension: ""
      },
      audioFile: {
        files: "",
        blobPath: "",
        fileExtension: ""
      },
      completeAudioFile: {
        files: "",
        blobPath: "",
        fileExtension: ""
      }
    },
    question: "",
    answer: [],
    optionWithImage: OptionWithImage.none
  });

  const [editIntroData, setEditIntroData] = useState<updatedMVPIntroDataType>({
    introId: "",
    deletedS3Path: [],
    carrousel: [{
      caurrouselId: "",
      carrouselMedia: {
        image: {
          files: "",
          blobPath: "",
          fileExtension: ""

        },
        audio: {
          files: "",
          blobPath: "",
          fileExtension: ""

        }
      },
      carrouselIntroText: "",
      selected: false
    }],
    newCarrousel: [],
    introduction: {
      introductionSectionMedia: {
        files: "",
        blobPath: "",
        fileExtension: ""
      },
      introductionSectionIntroText: ""
    },
    introS3Path: [],
    learningPath: [
      {
        learningPathId: "",
        gesture: Gesture.Empty,
        learningPathMedia: {
          gestureAnimation: {
            files: "",
            blobPath: "",
            fileExtension: ""
          },
          gestureAudio: {
            files: "",
            blobPath: "",
            fileExtension: ""
          }
        },
        description: "",
        reward: 0,
        selected: false
      }
    ],
    newLearningPath: [],
    congratulation: {
      congratulationId: "",
      congratulationBadgeIcon: {
        files: "",
        blobPath: "",
        fileExtension: ""

      },
      congratulationAudio: {
        files: "",
        blobPath: "",
        fileExtension: ""

      },
      congratulationText: "",
      congratulationCoins: 0,
      deletedS3Path: []
    },
    instruction: {
      id: "",
      instruction_image: {
        files: "",
        blobPath: "",
        fileExtension: ""
      },

      audio: {
        files: "",
        blobPath: "",
        fileExtension: ""
      },
      text: "",
      scientific_hypothesis: "",
      deletedS3Path: []
    },
    removeFiles: []
  })

  const handlePreview = () => {
    // alert("Lesson Id <React.Fragment> "+lessonId)
    // Open the child window — must be triggered by a direct user interaction
    const win = window.open(process.env.REACT_APP_REDIRECT_WINDOW, "_blank");

    if (!win) {
      alert("Popup blocked! Please allow popups for this site.");
      return;
    }

    // Add the message listener immediately
    const handleMessage = (event: MessageEvent) => {
      if (event.origin === process.env.REACT_APP_REDIRECT_WINDOW) {
        window.removeEventListener("message", handleMessage); // Clean up
      } else {
        console.warn("Message blocked from unknown origin:", event.origin);
      }
    };

    window.addEventListener("message", handleMessage);

    // Function to send message when the child window is ready
    const sendMessage = () => {
      try {
        if (win && typeof process.env.REACT_APP_REDIRECT_WINDOW === 'string') {
          win.postMessage({ accessToken: access_token, refreshToken: refresh_token, lessonId: unitData.unitLesson.id, unitId: unitData.id, gradeId: unitData.grade.gradeId, category: activeDifficultyType }, process.env.REACT_APP_REDIRECT_WINDOW);
        } else {
          console.error("Invalid window reference or redirect window URL is not set");
        }

      } catch (error) {
        console.error("Error sending message:", error);
      }
    };

    // Try sending the message a few times to ensure it reaches
    let tries = 0;
    const interval = setInterval(() => {
      if (win.closed) {
        clearInterval(interval);
        return;
      }

      sendMessage();
      tries++;

      if (tries >= 3) {
        clearInterval(interval);
      }
    }, 1000);
  };

  const [unitData, setUnitData] = useState<UnitDataType>({
    id: "",
    unitName: "",
    unitTribe: { id: "", name: "" },
    unitSubject: { id: "", name: "" },
    grade: { gradeId: "", gradeName: "" },
    unitLesson: { id: "", name: "" },
    unitLevel: 0,
    unitReward: 0,
    unitStatus: "0"

  });
  const [allQuestionData, setAllQuestionData] = useState<QuestionDataType[]>([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [itemsPerPage] = useState(10);
  const { access_token, refresh_token } = useAppSelector((state) => state.user.token);
  const [questionCount, setQuestionCount] = useState<number>(0)
  const [confirmationPopupData, setConfirmationPopupData] = useState({
    title: "",
    message: "",
    descriptions: "",
    acceptText: "",
    cancelText: "",
    onAccept: () => { },
    onCancel: () => { },
  });


  const [show, setShow] = useState(false);


  const getUnits = async () => {
    try {
      await getUnitByUnitId(location.state.id, access_token).then((allUnitResponse) => {
        const { data, statusCode } = allUnitResponse;
        if (statusCode === 200) {
          setUnitData({
            id: data.id,
            unitName: data.name,
            unitTribe: { id: data.lesson.tribe_id.id, name: data.lesson.tribe_id.name },
            unitSubject: { id: data.lesson.subject_id.id, name: data.lesson.subject_id.name },
            grade: { gradeId: data.lesson.grade_id.id, gradeName: data.lesson.grade_id.name },
            unitLesson: { id: data.lesson.id, name: data.lesson.name },
            unitLevel: data.level,
            unitReward: Number(data.reward),
            unitStatus: String(data.isActive)
          })
        } else if (statusCode === 401) {
          getAuthorizedToken();
          setMessage({
            ...message,
            failureMessage: "Authorization token expired. Try again!"
          })
        }
      })
    } catch (error: any) {
      console.error("Add Question Error :: ", error)
    }
  }



  useEffect(() => {
    getUnits();
  }, [])



  const handleTableQuestionData = (questionData: any) => {
    try {
      setLoading(prev => ({ ...prev, fetchingLoading: true, tableLoading: true, deleteLoading: false, submitLoading: false, validationLoading: false, }))

      const { congratulationData, questions, count, instructionData } = questionData;

      setQuestionCount(count);

      const getFileExtension = (path: string) => path ? path.split('.').pop() : "";

      const getMediaObject = (path: string) => ({
        files: path ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : "",
        blobPath: path ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : "",
        fileExtension: getFileExtension(path),
      });

      if (congratulationData) {
        setEditIntroData((prevData) => ({
          ...prevData,
          congratulation: {
            congratulationId: congratulationData.id,
            congratulationBadgeIcon: getMediaObject(congratulationData.image_path),
            congratulationAudio: getMediaObject(congratulationData.audio_file_path),
            congratulationText: congratulationData.text,
            congratulationCoins: congratulationData.reward,
            deletedS3Path: []
          },
          removeFiles: []
        }));
      } else {
        setEditIntroData((prevData) => ({
          ...prevData,
          congratulation: {
            congratulationId: "",
            congratulationBadgeIcon: getMediaObject(""),
            congratulationAudio: getMediaObject(""),
            congratulationText: "",
            congratulationCoins: 0,
            deletedS3Path: []
          },
          removeFiles: []
        }));
      }

      if (instructionData) {
        setEditIntroData((prevData) => ({
          ...prevData,
          instruction: {
            id: instructionData.id,
            instruction_image: getMediaObject(instructionData.image_path),
            audio: getMediaObject(instructionData.audio_path),
            text: instructionData.text,
            scientific_hypothesis: instructionData.hypothesis,
            deletedS3Path: []
          },

          removeFiles: []
        }));
      } else {
        setEditIntroData((prevData) => ({
          ...prevData,
          instruction: {
            id: "",
            instruction_image: getMediaObject(""),

            audio: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
            text: "",
            scientific_hypothesis: "",
            deletedS3Path: []
          },

          removeFiles: []
        }));
      }

      let formattedData: QuestionDataType[] = questions.map((question: any) => {

        return {
          id: question.id,
          level: question.level,
          difficultyType: { id: "1", name: "Warmup" },
          deleteS3Path: [],
          mediaFile: {
            questionMediaFile: getMediaObject(question.image_path || question.animation_file_path),
            audioFile: getMediaObject(question.audio_file_path),
            completeAudioFile: getMediaObject(question.complete_audio_file_path),
          },
          unitId: location.state.id,
          gradeId: location.state.grade,
          category: QuestionCategory.random,
          action: question.action === "CLICK" ? Action.click : Action.drag,
          type:
            question.type === "MATCH" && question.action === "DRAG"
              ? QuestionType.dragMatch
              : question.type === "MATCH"
                ? QuestionType.match
                : question.type === "MCQ"
                  ? QuestionType.mcq
                  : question.type === "DRAGMATCH"
                    ? QuestionType.dragMatch
                    : QuestionType.fill,
          optionWithImage: (() => {
            switch (question.type) {
              case QuestionType.mcq:
                return question.options?.[0]?.image_path ? OptionWithImage.yes : OptionWithImage.no;
              case QuestionType.fill:
                return question.blanks?.[0]?.image_path ? OptionWithImage.yes : OptionWithImage.no;
              case QuestionType.match:
                return question.pairs?.[0]?.image_path ? OptionWithImage.yes : OptionWithImage.no;
              default:
                return OptionWithImage.no;
            }
          })(),
          isActive: question.isActive ? "ACTIVE" : "INACTIVE",
          question: question.question,
          answer: question.answer || null,
          instruction: question.instruction,
          hint: question.hint,
          reward: question.reward ? Number(question.reward) : 0,
          pairs: (question.pairs || []).map((pair: any) => ({
            id: pair.id,
            rightItem: pair.rightItem,
            leftItem: pair.leftItem,
            media: {
              imagePath: getMediaObject(pair.image_path ? pair.image_path : ""),
              audioPath: getMediaObject(pair.audio_path)
            }
          })),
          dragMatchPair: (question.matchDrag || []).map((matchDrag: any) => ({
            id: matchDrag.id,
            item: matchDrag.item,
            answer: matchDrag.answer,
            media: {
              audioPath: getMediaObject(matchDrag.audio_path)
            }
          })),
          blanks: (question.blanks || []).map((blank: any, index: number) => ({
            id: blank.id,
            blankText: blank.blankText,
            isAnswer: (question.answer || []).includes(blank.blankText),
            media: {
              audioPath: getMediaObject(blank.audio_path),
              imagePath: getMediaObject(blank.image_path ? blank.image_path : ""),
            },
            blankPosition: index + 1,
          })),
          options: (question.options || []).map((option: any) => ({
            id: option.id,
            optionText: option.optionText,
            media: {
              audioPath: getMediaObject(option.audio_path),
              imagePath: getMediaObject(option.image_path ? option.image_path : ""),
            },
            isAnswer: (question.answer || []).includes(option.optionText),
          })),
        };
      });

      setAllQuestionData(formattedData);
    } catch (error) {
      console.error("1055 ", error);
    } finally {
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
    }
  };



  const handleOpenAnimation = (file: any) => {
    console.log("Handle Open Animation ><> ",file)
    if (file instanceof File) {
            const objectURL = URL.createObjectURL(file);
        setPreviewSource(objectURL);
      
    } else {
      setPreviewSource(file);
    }

        setShowPreview(prev => ({
      ...prev,
      imageShow: false,
      animationShow: true
    }))
  };

  const handleOpenImage = (file: any) => {

    if (file instanceof File) {
      const objectURL = URL.createObjectURL(file);
        setPreviewSource(objectURL);
      
    } else {

      setPreviewSource(file);
    }
    setShowPreview(prev => ({
      ...prev,
      imageShow: true,
      animationShow: false
    }))
  };


  const isLottieJson = (json: any): boolean => {
    return (
      typeof json === 'object' &&
      json !== null &&
      'v' in json &&
      'fr' in json &&
      'ip' in json &&
      'op' in json &&
      'layers' in json
    );
  };


  const handleWarmupMedia = (e: React.ChangeEvent<HTMLInputElement>, value: string, index: number, audio: boolean) => {
    const { files } = e.target;

    if (!files || files.length === 0) return;

    const file = files[0];

    if (value === "Carrousel") {
      if (audio) {

        if (file && (file.name.toLowerCase().endsWith('.mp3') || file.name.toLowerCase().endsWith('.wav'))) {
          if (checkFileLimit(file)) {
            setEditIntroData((prevData) => {
              const updatedCarrouselMedia = [...prevData.carrousel];
              const oldFile = updatedCarrouselMedia[index]?.carrouselMedia?.audio?.files;

              const updatedIntroS3Path = [
                ...prevData.introS3Path,
                ...(oldFile && !(oldFile instanceof File) ? [oldFile] : []),
              ];

              if (updatedCarrouselMedia[index]) {
                updatedCarrouselMedia[index] = {
                  ...updatedCarrouselMedia[index],
                  carrouselMedia: {
                    ...updatedCarrouselMedia[index].carrouselMedia,
                    audio: {
                      files: file,
                      blobPath: URL.createObjectURL(file),
                      fileExtension: file.name.toLowerCase().split(".").pop() || "",
                    },
                  },
                };
              }

              return {
                ...prevData,
                carrousel: updatedCarrouselMedia,
                introS3Path: updatedIntroS3Path,
              };
            });

          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }

        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported audio format. Please upload MP3, or WAV']
          })
          return;
        }

      } else {
        if (file && file.name.toLowerCase().endsWith('.json')) {
          if (checkFileLimit(file)) {
            const reader = new FileReader();
            reader.onload = (event) => {
              try {
                const json = JSON.parse(event.target?.result as string);
                if (!isLottieJson(json)) {
                  setMessage({
                    ...message,
                    errorMessage: ['Uploaded JSON is not a valid Lottie JSON animation.']
                  })
                  return;
                }

                setEditIntroData((prevData) => {
                  const updatedCarrouselMedia = [...prevData.carrousel];
                  let introS3Path = [...prevData.introS3Path];

                  if (updatedCarrouselMedia[index]) {
                    const prevImageFile = updatedCarrouselMedia[index].carrouselMedia.image?.files;

                    if (prevImageFile && !(prevImageFile instanceof File)) {
                      introS3Path.push(prevImageFile);
                    }

                    updatedCarrouselMedia[index] = {
                      ...updatedCarrouselMedia[index],
                      carrouselMedia: {
                        ...updatedCarrouselMedia[index].carrouselMedia,
                        image: {
                          files: file,
                          blobPath: URL.createObjectURL(file),
                          fileExtension: file.name.toLowerCase().split(".").pop() || "",
                        },
                      },
                    };
                  }

                  return {
                    ...prevData,
                    carrousel: updatedCarrouselMedia,
                    introS3Path,
                  };
                });

              } catch (err) {
                setMessage({
                  ...message,
                  errorMessage: ['Failed to parse JSON file.']
                })
              }
            };
            reader.readAsText(file);
            return;
          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }

        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported JSON format. Please upload Lottiee JSON.']
          })
          return;
        }

      }



    } else if (value === "NewCarrousel") {


      if (audio) {
        if (file && (file.name.toLowerCase().endsWith('.mp3') || file.name.toLowerCase().endsWith('.wav'))) {
          if (checkFileLimit(file)) {
            setEditIntroData((prevData) => {
              const updatedNewCarrouselMedia = [...prevData.newCarrousel];
              let introS3Path = [...prevData.introS3Path];

              const targetIndex = editIntroData.carrousel.length > index ? editIntroData.carrousel.length - index : index - editIntroData.carrousel.length;

              if (updatedNewCarrouselMedia[targetIndex]) {
                const prevAudioFile = updatedNewCarrouselMedia[targetIndex].carrouselMedia.audio?.files;

                if (prevAudioFile && !(prevAudioFile instanceof File)) {
                  introS3Path.push(prevAudioFile);
                }

                updatedNewCarrouselMedia[targetIndex] = {
                  ...updatedNewCarrouselMedia[targetIndex],
                  carrouselMedia: {
                    ...updatedNewCarrouselMedia[targetIndex].carrouselMedia,
                    audio: {
                      files: file,
                      blobPath: URL.createObjectURL(file),
                      fileExtension: file.name.toLowerCase().split(".").pop() || "",
                    },
                  },
                };
              }

              return {
                ...prevData,
                newCarrousel: updatedNewCarrouselMedia,
                introS3Path,
              };
            });

          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }

        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported audio format. Please upload MP3, or WAV']
          })
          return;
        }

      } else {
        if (file && file.name.toLowerCase().endsWith('.json')) {
          if (checkFileLimit(file)) {
            const reader = new FileReader();
            reader.onload = (event) => {
              try {
                const json = JSON.parse(event.target?.result as string);
                if (!isLottieJson(json)) {
                  setMessage({
                    ...message,
                    errorMessage: ['Uploaded JSON is not a valid Lottie JSON animation.']
                  })
                  return;
                }

                // Proceed to set state if valid
                setEditIntroData((prevData) => {
                  const updatedNewCarrouselMedia = [...prevData.newCarrousel];
                  let introS3Path = [...prevData.introS3Path];

                  const targetIndex = editIntroData.carrousel.length > index ? editIntroData.carrousel.length - index : index - editIntroData.carrousel.length;

                  if (updatedNewCarrouselMedia[targetIndex]) {
                    const prevImageFile = updatedNewCarrouselMedia[targetIndex].carrouselMedia.image?.files;

                    if (prevImageFile && !(prevImageFile instanceof File)) {
                      introS3Path.push(prevImageFile);
                    }

                    updatedNewCarrouselMedia[targetIndex] = {
                      ...updatedNewCarrouselMedia[targetIndex],
                      carrouselMedia: {
                        ...updatedNewCarrouselMedia[targetIndex].carrouselMedia,
                        image: {
                          files: file,
                          blobPath: URL.createObjectURL(file),
                          fileExtension: file.name.toLowerCase().split(".").pop() || "",
                        },
                      },
                    };
                  }

                  return {
                    ...prevData,
                    newCarrousel: updatedNewCarrouselMedia,
                    introS3Path,
                  };
                });

              } catch (err) {
                setMessage({
                  ...message,
                  errorMessage: ['Failed to parse JSON file.']
                })
              }
            };
            reader.readAsText(file);
            return;
          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }

        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported json format. Please upload Lottiee JSON.']
          });
        }

      }
    } else if (value === "Introduction") {
      // .png, .jpg, jpeg, .svg
      if (file && (file.name.toLowerCase().endsWith('.png') || file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg') || file.name.toLowerCase().endsWith('.svg'))) {
        if (checkFileLimit(file)) {
          setEditIntroData((prevData) => {
            let introS3Path = [...prevData.introS3Path];

            const prevIntroFile = prevData.introduction?.introductionSectionMedia?.files;

            if (prevIntroFile && !(prevIntroFile instanceof File)) {
              introS3Path.push(prevIntroFile);
            }

            return {
              ...prevData,
              introduction: {
                ...prevData.introduction,
                introductionSectionMedia: {
                  files: file,
                  blobPath: URL.createObjectURL(file),
                  fileExtension: file.name.toLowerCase().split(".").pop() || "",
                },
              },
              introS3Path,
            };
          });


        } else {
          setMessage({
            ...message,
            errorMessage: ['File Size Exceed. Try to upload within the size limit.']
          });
          return;
        }

      } else {
        setMessage({
          ...message,
          errorMessage: ['Unsupported image format. Please upload PNG, JPG, JPEG or SVG files.']
        });
        return;
      }


    } else if (value === "LearningPath") {
      const fileType = file.type;
      const isAnimation = fileType.startsWith("application/");
      const isAudio = fileType.startsWith("audio/");

      if (isAnimation) {
        if (file && (file.name.toLowerCase().endsWith('.json'))) {
          if (checkFileLimit(file)) {
            const reader = new FileReader();
            reader.onload = (event) => {
              try {
                const json = JSON.parse(event.target?.result as string);
                if (!isLottieJson(json)) {
                  setMessage({
                    ...message,
                    errorMessage: ['Uploaded JSON is not a valid Lottie JSON animation.']
                  });
                  return;
                }

                // Proceed to set state if valid
                setEditIntroData((prevData) => {
                  const updatedLearningPath = [...prevData.learningPath];
                  let introS3Path = [...prevData.introS3Path];

                  if (updatedLearningPath[index]) {
                    const prevGestureFile =
                      updatedLearningPath[index].learningPathMedia?.gestureAnimation?.files;

                    if (prevGestureFile && !(prevGestureFile instanceof File)) {
                      introS3Path.push(prevGestureFile);
                    }

                    updatedLearningPath[index].learningPathMedia = {
                      ...updatedLearningPath[index].learningPathMedia,
                      gestureAnimation: {
                        files: file,
                        blobPath: URL.createObjectURL(file),
                        fileExtension: file.name.toLowerCase().split(".").pop() || "",
                      },
                    };
                  }

                  return {
                    ...prevData,
                    learningPath: updatedLearningPath,
                    introS3Path,
                  };
                });

              } catch (err) {
                setMessage({
                  ...message,
                  errorMessage: ['Failed to parse JSON file.']
                });
              }
            };
            reader.readAsText(file);
            return;
          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }


        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported JSON format. PPlease upload valid Lottie JSON files.']
          });
          return;
        }

      } else if (isAudio) {
        if (file && (file.name.toLowerCase().endsWith('.mp3') || file.name.toLowerCase().endsWith('.wav'))) {
          if (checkFileLimit(file)) {

            setEditIntroData((prevData) => {
              const updatedLearningPath = [...prevData.learningPath];
              let introS3Path = [...prevData.introS3Path];

              if (updatedLearningPath[index]) {
                const prevGestureAudioFile =
                  updatedLearningPath[index].learningPathMedia?.gestureAudio?.files;

                if (prevGestureAudioFile && !(prevGestureAudioFile instanceof File)) {
                  introS3Path.push(prevGestureAudioFile);
                }

                updatedLearningPath[index].learningPathMedia = {
                  ...updatedLearningPath[index].learningPathMedia,
                  gestureAudio: {
                    files: file,
                    blobPath: URL.createObjectURL(file),
                    fileExtension: file.name.toLowerCase().split(".").pop() || "",
                  },
                };
              }

              return {
                ...prevData,
                learningPath: updatedLearningPath,
                introS3Path,
              };
            });

          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }

        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported image format. Please upload MP3 or WAV files.']
          });
          return;
        }

      }





    } else if (value === "NewLearningPath") {

      const fileType = file.type;
      const isAnimation = fileType.startsWith("application/");
      const isAudio = fileType.startsWith("audio/");

      if (isAnimation) {

        if (file && (file.name.toLowerCase().endsWith('.json'))) {
          if (checkFileLimit(file)) {

            const reader = new FileReader();
            reader.onload = (event) => {
              try {
                const json = JSON.parse(event.target?.result as string);
                if (!isLottieJson(json)) {
                  setMessage({
                    ...message,
                    errorMessage: ['Uploaded JSON is not a valid Lottie JSON animation.']
                  });
                  return;
                }

                // Proceed to set state if valid
                setEditIntroData((prevData) => {
                  const updatedNewLearningPath = [...prevData.newLearningPath];
                  let introS3Path = [...prevData.introS3Path];

                  if (updatedNewLearningPath[index]) {
                    const prevGestureFile =
                      updatedNewLearningPath[index].learningPathMedia?.gestureAnimation?.files;

                    if (prevGestureFile && !(prevGestureFile instanceof File)) {
                      introS3Path.push(prevGestureFile);
                    }

                    updatedNewLearningPath[index].learningPathMedia = {
                      ...updatedNewLearningPath[index].learningPathMedia,
                      gestureAnimation: {
                        files: file,
                        blobPath: URL.createObjectURL(file),
                        fileExtension: file.name.toLowerCase().split(".").pop() || "",
                      },
                    };
                  }

                  return {
                    ...prevData,
                    newLearningPath: updatedNewLearningPath,
                    introS3Path,
                  };
                });

              } catch (err) {
                setMessage({
                  ...message,
                  errorMessage: ['Failed to parse JSON file.']
                });
              }
            };
            reader.readAsText(file);
            return;
          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }

        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported JSON format. PPlease upload valid Lottie JSON files.']
          });
          return;
        }

      } else if (isAudio) {
        if (file && (file.name.toLowerCase().endsWith('.mp3') || file.name.toLowerCase().endsWith('.wav'))) {
          if (checkFileLimit(file)) {

            setEditIntroData((prevData) => {
              const updatedNewLearningPath = [...prevData.newLearningPath];
              let introS3Path = [...prevData.introS3Path];

              if (updatedNewLearningPath[index]) {
                const prevGestureAudioFile =
                  updatedNewLearningPath[index].learningPathMedia?.gestureAudio?.files;

                if (prevGestureAudioFile && !(prevGestureAudioFile instanceof File)) {
                  introS3Path.push(prevGestureAudioFile);
                }

                updatedNewLearningPath[index].learningPathMedia = {
                  ...updatedNewLearningPath[index].learningPathMedia,
                  gestureAudio: {
                    files: file,
                    blobPath: URL.createObjectURL(file),
                    fileExtension: file.name.toLowerCase().split(".").pop() || "",
                  },
                };
              }

              return {
                ...prevData,
                newLearningPath: updatedNewLearningPath,
                introS3Path,
              };
            });

          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }

        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported image format. Please upload MP3 or WAV files.']
          });
          return;
        }

      }



    }
  };

  const handleCongratsInput = (e: React.ChangeEvent<HTMLInputElement> | null, name: string, value: string) => {
    console.log("Handle Congrats Input ><React.Fragment> ", e, name, value)
    if (e) {
      const { files } = e.target;
      if (name === "congratulations-audio") {

        if (!files || files.length === 0) return;

        const file = files[0];

        const fileType = file.type;
        const isAudio = fileType.startsWith("audio/");

        if (isAudio) {
          if (file && (file.name.toLowerCase().endsWith('.mp3') || file.name.toLowerCase().endsWith('.wav'))) {
            if (checkFileLimit(file)) {

              setEditIntroData((prevData) => {
                const updatedCongrats = { ...prevData.congratulation };

                const prevAudioFile = updatedCongrats.congratulationAudio?.files;

                if (prevAudioFile && !(prevAudioFile instanceof File)) {
                  updatedCongrats.deletedS3Path.push(prevAudioFile);
                }



                updatedCongrats.congratulationAudio = {
                  files: file,
                  blobPath: URL.createObjectURL(file),
                  fileExtension: file.name.toLowerCase().split(".").pop() || "",
                };

                return {
                  ...prevData,
                  congratulation: updatedCongrats,
                };
              });

            } else {
              setMessage({
                ...message,
                errorMessage: ['File Size Exceed. Try to upload within the size limit.']
              });
              return;
            }

          } else {
            setMessage({
              ...message,
              errorMessage: ['Unsupported audio format. Please upload MP3 or WAV files.']
            });
            return;
          }
        }


      } else if (name === "congratulations-badge") {

        if (!files || files.length === 0) return;

        const file = files[0];

        const fileType = file.type;
        const isImage = fileType.startsWith("image/");
        const isJSON = fileType.startsWith("application/json")

        if (isImage || isJSON) {
          if (file && (file.name.toLowerCase().endsWith('.png') || file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg') || file.name.toLowerCase().endsWith('.svg'))) {
            if (checkFileLimit(file)) {
              setEditIntroData((prevData) => {
                const updatedCongrats = { ...prevData.congratulation };

                const prevBadgeFile = updatedCongrats.congratulationBadgeIcon?.files;

                if (prevBadgeFile && !(prevBadgeFile instanceof File)) {
                  updatedCongrats.deletedS3Path.push(prevBadgeFile);
                }



                updatedCongrats.congratulationBadgeIcon = {
                  files: file,
                  blobPath: URL.createObjectURL(file),
                  fileExtension: file.name.toLowerCase().split(".").pop() || "",
                };

                return {
                  ...prevData,
                  congratulation: updatedCongrats
                };
              });

            } else {
              setMessage({
                ...message,
                errorMessage: ['File Size Exceed. Try to upload within the size limit.']
              });
              return;
            }

          } else if (file && file.name.toLowerCase().endsWith('.json')) {
            if (checkFileLimit(file)) {
              const reader = new FileReader();
              reader.onload = (event) => {
                try {
                  const json = JSON.parse(event.target?.result as string);
                  if (!isLottieJson(json)) {
                    setMessage({
                      ...message,
                      errorMessage: ['Uploaded JSON is not a valid Lottie JSON animation.']
                    })
                    return;
                  }

                  setEditIntroData((prevData) => {
                    const updatedCongrats = { ...prevData.congratulation };

                    const prevBadgeFile = updatedCongrats.congratulationBadgeIcon?.files;

                    if (prevBadgeFile && !(prevBadgeFile instanceof File)) {
                      updatedCongrats.deletedS3Path.push(prevBadgeFile);
                    }

                    updatedCongrats.congratulationBadgeIcon = {
                      files: file,
                      blobPath: URL.createObjectURL(file),
                      fileExtension: file.name.toLowerCase().split(".").pop() || "",
                    };

                    return {
                      ...prevData,
                      congratulation: updatedCongrats
                    };
                  });

                } catch (err) {
                  setMessage({
                    ...message,
                    errorMessage: ['Failed to parse JSON file.']
                  })
                }
              };
              reader.readAsText(file);
              return;
            } else {
              setMessage({
                ...message,
                errorMessage: ['File Size Exceed. Try to upload within the size limit.']
              });
              return;
            }

          }
          else {
            setMessage({
              ...message,
              errorMessage: ['Unsupported image format. Please upload JPG, PNG, , SVG or JPEG files.']
            });
            return;
          }

        }

      } else if (name === "congratulation-coins") {
        setEditIntroData((prevData) => ({
          ...prevData,
          congratulation: {
            ...prevData.congratulation,
            congratulationCoins: Number(value)
          }
        }))
      }
    } else {
      if (name === "congratulation-text") {
        setEditIntroData((prevData) => ({
          ...prevData,
          congratulation: {
            ...prevData.congratulation,
            congratulationText: removeSpans(value)
          }
        }))
      }
    }


  }

  const validateCongratsData = () => {
    let errorMessage: string[] = [];
    const isMediaValid = (media: any) => media && media.files;
    const { congratulation } = editIntroData;

    if (activeDifficultyType === "3") {
      if (congratulation.congratulationCoins < 1) errorMessage.push("Reward for completion all level should be greater than 0");
    }

    if (!congratulation.congratulationText || congratulation.congratulationText.replace(/<[^>]*>/g, "").trim() === "") errorMessage.push("Please enter a valid congratulation text");
    if (!isMediaValid(congratulation.congratulationBadgeIcon)) errorMessage.push("Please upload a valid badge icon");
    if (!isMediaValid(congratulation.congratulationAudio)) errorMessage.push("Please upload a valid congratulation audio");
    if (errorMessage.length > 0) {
      setMessage({
        ...message,
        errorMessage: errorMessage,
      });
      return false;
    } else {
      handleSubmitCongratsData();
    }

  }

  const handleInstructionInput = (e: React.ChangeEvent<HTMLInputElement> | null, name: string, value: string, isReplace: boolean) => {

    if (e) {
      const { files } = e.target;
      if (name === "instruction-image") {

        if (!files || files.length === 0) return;

        const file = files[0];

        if (file && (file.name.toLowerCase().endsWith('.png') || file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg') || file.name.toLowerCase().endsWith('.svg'))) {
          if (checkFileLimit(file)) {
            setEditIntroData((prevData) => {
              const updatedInstruction = { ...prevData.instruction };
              let removeFiles = [...prevData.removeFiles];

              const prevInstructionFile = updatedInstruction.instruction_image?.files;

              // ✅ Push old file to removeFiles if not a File instance
              if (prevInstructionFile && !(prevInstructionFile instanceof File)) {
                removeFiles.push(prevInstructionFile);
              }

              updatedInstruction.instruction_image = {
                files: file,
                blobPath: URL.createObjectURL(file),
                fileExtension: file.name.toLowerCase().split(".").pop() || "",
              };

              return {
                ...prevData,
                instruction: updatedInstruction,
                removeFiles,
              };
            });

          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }

        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported image format. Please upload PNG, JPG, JPEG or SVG files.']
          });
          return;
        }
      } else if (name === "audio") {
        if (!files || files.length === 0) return;

        const file = files[0];

        if (file && (file.name.toLowerCase().endsWith('.mp3') || file.name.toLowerCase().endsWith('.wav'))) {
          if (checkFileLimit(file)) {
            setEditIntroData((prevData) => {
              const updatedInstruction = { ...prevData.instruction };
              let removeFiles = [...prevData.removeFiles];

              const prevAudioFile = updatedInstruction.audio?.files;

              // ✅ Only push if it's NOT a File instance
              if (prevAudioFile && !(prevAudioFile instanceof File)) {
                removeFiles.push(prevAudioFile);
              }


              updatedInstruction.audio = {
                files: file,
                blobPath: URL.createObjectURL(file),
                fileExtension: file.name.toLowerCase().split(".").pop() || "",
              };

              return {
                ...prevData,
                instruction: updatedInstruction,
                removeFiles,
              };
            });

          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }

        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported audio format. Please upload MP3 or WAV files.']
          });
          return;
        }
      }
    } else {
      if (name === "instruction-text") {
        setEditIntroData((prevData) => ({
          ...prevData,
          instruction: {
            ...prevData.instruction,
            text: removeSpans(value)
          }
        }))
      } else if (name === "scientific-hypothesis") {
        console.log("Scietific Hypo ><React.Fragment> ", removeSpans(value))
        setEditIntroData((prevData) => ({
          ...prevData,
          instruction: {
            ...prevData.instruction,
            scientific_hypothesis: removeSpans(value)
          }
        }))
      }
    }


  }



  const validateInstructionData = () => {
    const { instruction } = editIntroData;

    let errorMessage: string[] = [];
    const isMediaValid = (media: any) => media && media.files;
    if (!isMediaValid(instruction.instruction_image)) errorMessage.push("Please upload a valid instruction image");

    if (!instruction.text || instruction.text.replace(/<[^>]*>/g, "").trim() === "") errorMessage.push("Please enter a valid instruction image text");

    if (activeDifficultyType === "3") {
      if (!instruction.scientific_hypothesis || instruction.scientific_hypothesis.replace(/<[^>]*>/g, "").trim() === "") errorMessage.push("Please enter a valid scientific hypothesis text");
      if (!isMediaValid(instruction.audio)) errorMessage.push("Please upload the VO.")
    }


    if (errorMessage.length > 0) {
      setMessage({
        ...message,
        errorMessage: errorMessage,
      });
      return false;
    } else {
      handleSubmitInstructionData()
    }


  }

  useEffect(() => {
    console.log("Edit Intro Data Updated: ", editIntroData, editQuestionData);
  }, [editIntroData, editQuestionData]);
  const handleSubmitInstructionData = async () => {
    setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: true, validationLoading: false, }))
    try {
      const formdata = new FormData();

      formdata.append("grade_id", unitData.grade.gradeId);
      formdata.append("unit_id", unitData.id);
      formdata.append("text", editIntroData.instruction.text);
      formdata.append("hypothesis", editIntroData.instruction.scientific_hypothesis)
      formdata.append("difficulty_level_id", activeDifficultyType)
      if (editIntroData.instruction.instruction_image.files instanceof File) {
        formdata.append("image_path", editIntroData.instruction.instruction_image.files);
      }
      if (editIntroData.instruction.audio.files instanceof File) {
        formdata.append("audio_path", editIntroData.instruction.audio.files)
      }


      if (editIntroData.removeFiles.length > 0) {
        formdata.append("removeFiles", JSON.stringify(editIntroData.removeFiles.filter((s3path: string) => s3path.trim() !== "").map((s3path: string) => ({
          path: s3path.replace(`${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}`, ""),
        }))
        )
        );
      }


      const getFileExtension = (path: string) => path ? path.split('.').pop() : "";

      const getMediaObject = (path: string) => ({
        files: path ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : "",
        blobPath: path ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : "",
        fileExtension: getFileExtension(path),
      });

      if (editIntroData.instruction.id) {
        await updateInstructionData(formdata, access_token).then((updateResponse) => {
          const { data, statusCode } = updateResponse;
          if (statusCode === 200) {

            setEditIntroData((prevData) => ({
              ...prevData,
              instruction: {
                id: data[0].id,
                instruction_image: getMediaObject(data[0].image_path),
                audio: getMediaObject(data[0].audio_path),
                text: data[0].text,
                scientific_hypothesis: data[0].hypothesis,
                deletedS3Path: []
              },
              removeFiles: []
            }));
            let messageText = "";
            if (activeDifficultyType === "2") {
              messageText = "Instructions updated successfully!"
            } else if (activeDifficultyType === "3") {
              messageText = "Objective and Scientific Hypothesis updated successfully!"
            } else {
              messageText = "Changes updated successfully!"
            }
            setMessage({
              ...message,
              successMessage: messageText
            });
          } else if (statusCode === 401) {
            getAuthorizedToken();
            setMessage({
              ...message,
              failureMessage: "Authorization token expired. Try again!"
            })
          }

        });
      } else {
        await createInstructionData(formdata, access_token).then((createResponse) => {
          const { data, statusCode } = createResponse;
          if (statusCode === 200) {
            setEditIntroData((prevData) => ({
              ...prevData,
              instruction: {
                id: data.id,
                instruction_image: getMediaObject(data.image_path),
                audio: getMediaObject(data.audio_path),
                text: data.text,
                scientific_hypothesis: data.hypothesis,
                deletedS3Path: []
              },
              removeFiles: []
            }));

            let messageText = "";
            if (activeDifficultyType === "2") {
              messageText = "Instructions added successfully!"
            } else if (activeDifficultyType === "3") {
              messageText = "Objective and Scientific Hypothesis added successfully!"
            } else {
              messageText = "Changes updated successfully!"
            }
            setMessage({
              ...message,
              successMessage: messageText
            });
          } else if (statusCode === 401) {
            getAuthorizedToken();
            setMessage({
              ...message,
              failureMessage: "Authorization token expired. Try again!"
            })
          }
        });
      }
    } catch (error: any) {
      if (error.response && error.response.data && typeof error.response.data === "string") {
        setMessage({
          ...message,
          failureMessage: error.response.data.message
        })
      } else {
        setMessage({
          ...message,
          failureMessage: "Something went wrong. Please try again"
        })
      }
      setEditIntroData((prevData) => ({
        ...prevData,
        congratulation: {
          congratulationId: "",
          congratulationBadgeIcon: {
            files: "",
            blobPath: "",
            fileExtension: ""
          },
          congratulationAudio: {
            files: "",
            blobPath: "",
            fileExtension: ""
          },
          congratulationText: "",
          congratulationCoins: 0,
          deletedS3Path: []
        },

        removeFiles: []
      }));
    } finally {
      setTimeout(() => {
        setMessage(((prev: MessageDataType) => {
          const updatedData = { ...prev };
          updatedData.errorMessage = prev.errorMessage;
          updatedData.failureMessage = "";
          updatedData.successMessage = ""
          return updatedData
        }))

      }, 2500)
      setLoading(prev => ({ ...prev, fetchingLoading: true, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
      getAllIntro()
    }

  }


  const handleSubmitCongratsData = async () => {
    setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: true, validationLoading: false, }))
    try {
      const formdata = new FormData();

      formdata.append("grade_id", unitData.grade.gradeId);
      formdata.append("unit_id", unitData.id);
      formdata.append("text", editIntroData.congratulation.congratulationText);
      formdata.append("reward", editIntroData.congratulation.congratulationCoins.toString());
      formdata.append("difficulty_level_id", activeDifficultyType)
      if (editIntroData.congratulation.congratulationBadgeIcon.files instanceof File) {
        formdata.append("image_path", editIntroData.congratulation.congratulationBadgeIcon.files);
      }

      if (editIntroData.congratulation.congratulationAudio.files instanceof File) {
        formdata.append("audio_file_path", editIntroData.congratulation.congratulationAudio.files);
      }

      if (editIntroData.congratulation.deletedS3Path.length > 0) {
        formdata.append("removeFiles", JSON.stringify(editIntroData.congratulation.deletedS3Path.filter((s3path: string) => s3path.trim() !== "").map((s3path: string) => ({ path: s3path }))));
      }

      const getFileExtension = (path: string) => path ? path.split('.').pop() : "";

      const getMediaObject = (path: string) => ({
        files: path ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : "",
        blobPath: path ? `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${path}` : "",
        fileExtension: getFileExtension(path),
      });

      if (editIntroData.congratulation.congratulationId) {
        formdata.append("id", editIntroData.congratulation.congratulationId);
        await updateCongratsData(formdata, access_token).then((updateResponse) => {
          const { data, statusCode } = updateResponse;
          if (statusCode === 200) {

            setEditIntroData((prevData) => ({
              ...prevData,
              congratulation: {
                congratulationId: data.id,
                congratulationBadgeIcon: getMediaObject(data.image_path),
                congratulationAudio: getMediaObject(data.audio_file_path),
                congratulationText: data.text,
                congratulationCoins: data.reward,
                deletedS3Path: []
              },
              removeFiles: []
            }));
            setMessage({
              ...message,
              successMessage: "Congratulations updated successfully!"
            });
          } else if (statusCode === 401) {
            getAuthorizedToken();
            setMessage({
              ...message,
              failureMessage: "Authorization token expired. Try again!"
            })
          }

        });
      } else {
        await createCongratsData(formdata, access_token).then((createResponse) => {
          const { data, statusCode } = createResponse;
          if (statusCode === 200) {
            setEditIntroData((prevData) => ({
              ...prevData,
              congratulation: {
                congratulationId: data.id,
                congratulationBadgeIcon: getMediaObject(data.image_path),
                congratulationAudio: getMediaObject(data.audio_file_path),
                congratulationText: data.text,
                congratulationCoins: data.reward,
                deletedS3Path: []
              },

              removeFiles: []
            }));
            setMessage({
              ...message,
              successMessage: "Congratulations added successfully!"
            });
          } else if (statusCode === 401) {
            getAuthorizedToken();
            setMessage({
              ...message,
              failureMessage: "Authorization token expired. Try again!"
            })
          }
        });
      }
    } catch (error: any) {
      if (error.response && error.response.data && typeof error.response.data === "string") {
        setMessage({
          ...message,
          failureMessage: error.response.data.message
        })
      } else {
        setMessage({
          ...message,
          failureMessage: "Something went wrong. Please try again"
        })
      }
      setEditIntroData((prevData) => ({
        ...prevData,
        congratulation: {
          congratulationId: "",
          congratulationBadgeIcon: {
            files: "",
            blobPath: "",
            fileExtension: ""
          },
          congratulationAudio: {
            files: "",
            blobPath: "",
            fileExtension: ""
          },
          congratulationText: "",
          congratulationCoins: 0,
          deletedS3Path: []
        },
        removeFiles: []
      }));
    } finally {
      setTimeout(() => {
        setMessage(((prev: MessageDataType) => {
          const updatedData = { ...prev };
          updatedData.errorMessage = prev.errorMessage;
          updatedData.failureMessage = "";
          updatedData.successMessage = ""
          return updatedData
        }))

      }, 2500)
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
      getAllIntro()
    }

  }



  const handleWarmupInput = (name: string, value: string | Gesture, index: number, gesture: boolean, inputField?: string) => {
    const carrouselLength = editIntroData.carrousel.length;

    if (name === "Carrousel") {
      setEditIntroData((prevData) => {
        const updatedCarrouselMedia = [...prevData.carrousel];
        if (updatedCarrouselMedia[index]) {
          updatedCarrouselMedia[index] = {
            ...updatedCarrouselMedia[index],
            carrouselIntroText: removeSpans(value),
          };
        }
        return {
          ...prevData,
          carrousel: updatedCarrouselMedia,
        };
      });
    } else if (name === "NewCarrousel") {
      const adjustedIndex = index - carrouselLength;
      setEditIntroData((prevData) => {
        const updatedNewCarrouselMedia = [...prevData.newCarrousel];
        if (updatedNewCarrouselMedia[adjustedIndex]) {
          updatedNewCarrouselMedia[adjustedIndex] = {
            ...updatedNewCarrouselMedia[adjustedIndex],
            carrouselIntroText: removeSpans(value),
          };
        }
        return {
          ...prevData,
          newCarrousel: updatedNewCarrouselMedia,
        };
      });
    } else if (name === "Introduction") {
      setEditIntroData((prevData) => ({
        ...prevData,
        introduction: {
          ...prevData.introduction,
          introductionSectionIntroText: removeSpans(value),
        },
      }));
    } else if (name === "LearningPath") {
      if (inputField === "reward") {
        setEditIntroData((prevData) => {
          const updatedLearningPath = [...prevData.learningPath];
          if (updatedLearningPath[index]) {
            updatedLearningPath[index] = {
              ...updatedLearningPath[index],
              reward: Number(value),
            };
          }
          return {
            ...prevData,
            learningPath: updatedLearningPath,
          };
        });
      } else {
        setEditIntroData((prevData) => {
          const updatedLearningPath = [...prevData.learningPath];
          if (updatedLearningPath[index]) {
            updatedLearningPath[index] = {
              ...updatedLearningPath[index],
              ...(gesture ? { gesture: value as Gesture } : { description: removeSpans(value) }),
            };
          }
          return {
            ...prevData,
            learningPath: updatedLearningPath,
          };
        });
      }

    } else if (name === "NewLearningPath") {
      if (inputField === "reward") {
        setEditIntroData((prevData) => {
          const updatedNewLearningPath = [...prevData.newLearningPath];
          if (updatedNewLearningPath[index]) {
            updatedNewLearningPath[index] = {
              ...updatedNewLearningPath[index],
              reward: Number(value),
            };
          }

          return {
            ...prevData,
            newLearningPath: updatedNewLearningPath,
          };
        });
      } else {
        setEditIntroData((prevData) => {
          const updatedNewLearningPath = [...prevData.newLearningPath];
          if (updatedNewLearningPath[index]) {
            updatedNewLearningPath[index] = {
              ...updatedNewLearningPath[index],
              ...(gesture ? { gesture: value as Gesture } : { description: removeSpans(value) }),
            };
          }


          return {
            ...prevData,
            newLearningPath: updatedNewLearningPath,
          };

        });
      }
    }
  };



  const handleAddCarrousel = (type: string) => {

    const isCarrousel = type === "carrousel";

    if (isCarrousel && !selected.carrousel) {
      const list = editIntroData.introId ? editIntroData.newCarrousel : editIntroData.carrousel;
      const lastEntry = list[list.length - 1];

      // Validate previous entry
      if (lastEntry) {
        const isImageEmpty = !lastEntry.carrouselMedia.image.files;
        const isAudioEmpty = !lastEntry.carrouselMedia.audio.files;
        const isIntroTextEmpty = !lastEntry.carrouselIntroText || lastEntry.carrouselIntroText.replace(/<[^>]*>/g, "").trim() === "";

        const errors: string[] = [];

        if (isImageEmpty) {
          errors.push("Please upload an image for the previous carrousel.");
        }

        if (isIntroTextEmpty) {
          errors.push("Please enter a description for the previous carrousel.");
        }

        if (isAudioEmpty) {
          errors.push("Please upload an audio file for the previous carrousel.");
        }



        if (errors.length > 0) {
          setMessage({
            ...message,
            errorMessage: errors,
          });
          return;
        }
      }


      const newEntry = {
        caurrouselId: "",
        carrouselMedia: {
          image: {
            files: "",
            blobPath: "",
            fileExtension: ""
          },
          audio: {
            files: "",
            blobPath: "",
            fileExtension: ""
          }
        },
        carrouselIntroText: "",
        selected: false
      };

      if (editIntroData.introId) {
        setEditIntroData({
          ...editIntroData,
          newCarrousel: [...editIntroData.newCarrousel, newEntry]
        });
      } else {
        setEditIntroData({
          ...editIntroData,
          carrousel: [...editIntroData.carrousel, newEntry]
        });
      }

    } else if (type === "gesture" && !selected.learningPath) {
      const list = editIntroData.introId ? editIntroData.newLearningPath : editIntroData.learningPath;
      const lastEntry = list[list.length - 1];

      // Validate previous gesture entry
      if (lastEntry) {
        const isMediaEmpty = !lastEntry.learningPathMedia.gestureAnimation.files;
        const isDescriptionEmpty = !lastEntry.description || lastEntry.description.replace(/<[^>]*>/g, "").trim() === "";
        const isGestureEmpty = !lastEntry.gesture;

        if (isMediaEmpty || isDescriptionEmpty || isGestureEmpty) {
          const errors: string[] = [];
          if (isGestureEmpty) {
            errors.push("Please select a valid gesture.");
          }

          if (isMediaEmpty) {
            errors.push("Please upload a media file for the previous gesture.");
          }

          if (isDescriptionEmpty) {
            errors.push("Please enter a description for the previous gesture.");
          }

          setMessage({
            ...message,
            errorMessage: errors,
          });

          return;
        }
      }


      const newGestureEntry = {
        learningPathId: "",
        gesture: Gesture.Empty,
        learningPathMedia: {
          gestureAnimation: {
            files: "",
            blobPath: "",
            fileExtension: ""
          },
          gestureAudio: {
            files: "",
            blobPath: "",
            fileExtension: ""
          }
        },
        description: "",
        reward: 0,
        selected: false
      };

      if (editIntroData.introId) {
        setEditIntroData({
          ...editIntroData,
          newLearningPath: [...editIntroData.newLearningPath, newGestureEntry]
        });
      } else {
        setEditIntroData({
          ...editIntroData,
          learningPath: [...editIntroData.learningPath, newGestureEntry]
        });
      }
    }
  };


  const handleDeleteWarmupIntro = (type: string) => {
    let selectedItemsCount = 0;
    let unselectedItemsCount = 0;

    if (type === "Carrousel") {
      const selectedCarrousel = editIntroData.carrousel.filter(item => item.selected);
      const selectedNewCarrousel = editIntroData.newCarrousel.filter(item => item.selected);
      selectedItemsCount = selectedCarrousel.length + selectedNewCarrousel.length;

      const unselectedCarrousel = editIntroData.carrousel.length - selectedCarrousel.length;
      const unselectedNewCarrousel = editIntroData.newCarrousel.length - selectedNewCarrousel.length;
      unselectedItemsCount = unselectedCarrousel + unselectedNewCarrousel;

      if (selectedItemsCount === 0) return;
    }

    if (type === "LearningPath") {
      const selectedLearningPath = editIntroData.learningPath.filter(item => item.selected);
      const selectedNewLearningPath = editIntroData.newLearningPath.filter(item => item.selected);
      selectedItemsCount = selectedLearningPath.length + selectedNewLearningPath.length;

      const unselectedLearningPath = editIntroData.learningPath.length - selectedLearningPath.length;
      const unselectedNewLearningPath = editIntroData.newLearningPath.length - selectedNewLearningPath.length;
      unselectedItemsCount = unselectedLearningPath + unselectedNewLearningPath;

      if (selectedItemsCount === 0) return;
    }

    setShow(true);
    setConfirmationPopupData({
      title: "Are you sure you want to delete?",
      message: "This action cannot be undone.",
      descriptions: selectedItemsCount && unselectedItemsCount
        ? `${selectedItemsCount} selected, ${unselectedItemsCount} will remain.`
        : selectedItemsCount
          ? `You're deleting ${selectedItemsCount} item(s).`
          : "",
      acceptText: "Yes",
      cancelText: "Cancel",
      onAccept: async () => {
        setShow(false);
        setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: true, submitLoading: false, validationLoading: false, }))

        const introId: string[] = [];
        let updatedCarrouselLength = 0;

        if (type === "Carrousel") {
          editIntroData.carrousel.forEach(item => {
            if (item.selected && item.caurrouselId) introId.push(item.caurrouselId);
          });

          const updatedCarrousel = editIntroData.carrousel.filter(item => !item.selected);
          const updatedNewCarrousel = editIntroData.newCarrousel.filter(item => !item.selected);

          setEditIntroData(prev => ({
            ...prev,
            carrousel: updatedCarrousel,
            newCarrousel: updatedNewCarrousel,
          }));

          updatedCarrouselLength = updatedCarrousel.length + updatedNewCarrousel.length;
        }

        if (type === "LearningPath") {
          editIntroData.learningPath.forEach(item => {
            if (item.selected && item.learningPathId) introId.push(item.learningPathId);
          });

          const updatedLearningPath = editIntroData.learningPath.filter(item => !item.selected);
          const updatedNewLearningPath = editIntroData.newLearningPath.filter(item => !item.selected);

          setEditIntroData(prev => ({
            ...prev,
            learningPath: updatedLearningPath,
            newLearningPath: updatedNewLearningPath,
          }));
        }

        try {
          if (introId.length > 0) {
            const { statusCode } = await deleteIntroByIntroId({ ids: introId }, access_token);
            if (statusCode === 200) {
              setMessage(prev => ({
                ...prev,
                successMessage: "Intro deleted successfully.",
              }));
            }
          }
        } catch (error) {
          console.error("Delete error:", error);
        } finally {
          if (type === "Carrousel") {
            setSelected(prev => ({ ...prev, carrousel: false }));

            if (updatedCarrouselLength < 1) {
              setEditIntroData(prev => ({
                ...prev,
                introId: "",
                carrousel: [{
                  caurrouselId: "",
                  carrouselMedia: {
                    image: { files: "", blobPath: "", fileExtension: "" },
                    audio: { files: "", blobPath: "", fileExtension: "" },
                  },
                  carrouselIntroText: "",
                  selected: false,
                }],
                newCarrousel: [],
              }));
            }
          } else if (type === "LearningPath") {
            setSelected(prev => ({ ...prev, learningPath: false }));
          }

          setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
        }
      },
      onCancel: handleClose,
    });
  };



  const validateIntroData = () => {
    let errorMessage: string[] = [];
    const isMediaValid = (media: any) => media && media.files;

    // ---------------- Carrousel ----------------
    const allCarrousel = [...editIntroData.carrousel, ...editIntroData.newCarrousel];
    let carrouselErrors: string[] = [];

    if (allCarrousel.length < 1) {
      carrouselErrors.push("At least 1 carousel is required in Introduction.");
    } else {
      allCarrousel.forEach((item, index) => {
        const image = item.carrouselMedia?.image;
        const audio = item.carrouselMedia?.audio;

        if (!isMediaValid(image)) carrouselErrors.push(`Lottiee Animation is missing at carousel ${index + 1} in Introduction.`);
        if (!item.carrouselIntroText || !item.carrouselIntroText.replace(/<[^>]*>/g, '').trim()) {
          carrouselErrors.push(`Intro text missing at carousel ${index + 1} in Introduction.`);
        }
        if (!isMediaValid(audio)) carrouselErrors.push(`Audio missing at carousel ${index + 1} in Introduction.`);

      });
    }

    // ---------------- Introduction Section ----------------
    let introErrors: string[] = [];
    const intro = editIntroData.introduction;

    if (!isMediaValid(intro.introductionSectionMedia)) {
      introErrors.push("Introduction media file is missing in Introduction.");
    }
    if (!intro.introductionSectionIntroText || !intro.introductionSectionIntroText.replace(/<[^>]*>/g, '').trim()) {
      introErrors.push("Introduction intro text is missing in Introduction.");
    }

    // ---------------- Learning Path ----------------
    const allLearningPath = [...editIntroData.learningPath, ...editIntroData.newLearningPath];
    let learningPathErrors: string[] = [];

    if (allLearningPath.length < 1) {
      learningPathErrors.push("At least 1 gesture is required in Learning Path.");
    } else {
      allLearningPath.forEach((item, index) => {
        const media = item.learningPathMedia || {};
        if (!item.gesture) learningPathErrors.push(`Gesture ${index + 1} is missing in Learning Path.`);
        if (!item.description || !item.description.replace(/<[^>]*>/g, '').trim()) {
          learningPathErrors.push(`Description is missing at gesture ${index + 1} in Learning Path.`);
        }
        if (!isMediaValid(media.gestureAnimation)) {
          learningPathErrors.push(`Animation file is missing at gesture ${index + 1} in Learning Path.`);
        }
        if (!item.reward || item.reward <= 0) {
          learningPathErrors.push(`Please enter a valid reward at gesture ${index + 1} in Learning Path.`);
        }
        if (!isMediaValid(media.gestureAudio)) {
          learningPathErrors.push(`VO file is missing at gesture ${index + 1} in Learning Path.`);
        }
      });
    }
    // ---------------- Collect All Errors ----------------
    errorMessage = [
      ...carrouselErrors,
      ...introErrors,
      ...learningPathErrors
    ];

    if (errorMessage.length > 0) {
      setMessage({
        ...message,
        errorMessage
      });
    } else {
      handleSubmit();
    }
  };




  const handleSubmit = async () => {

    setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: true, validationLoading: false, }))
    try {
      const formdata = new FormData();
      const introArray: any[] = [];
      const newIntroArray: any[] = [];

      formdata.append("gradeId", unitData.grade.gradeId);
      formdata.append("unitId", unitData.id);
      editIntroData.carrousel.forEach((item, index) => {
        // Push intro content to array
        introArray.push({
          ...(item.caurrouselId && { id: item.caurrouselId }),
          content: item.carrouselIntroText,
          isStatic: 1,
          rightContent: editIntroData.introduction.introductionSectionIntroText
        });

        const image = item.carrouselMedia.image;
        const audio = item.carrouselMedia.audio;
        const rightMedia = editIntroData.introduction.introductionSectionMedia;

        // Append image file
        if (image.files instanceof File) {
          formdata.append("files", image.files, `intro_image_animation_${index}.${image.fileExtension}`);
        }

        // Append audio file
        if (audio.files instanceof File) {
          formdata.append("files", audio.files, `intro_audio_${index}.${audio.fileExtension}`);
        }

        // Append right image file
        if (rightMedia.files instanceof File) {
          formdata.append("files", rightMedia.files, `intro_right_image_${index}.${rightMedia.fileExtension}`);
        }
      });


      editIntroData.newCarrousel.forEach((item, index) => {
        newIntroArray.push({ content: item.carrouselIntroText, isStatic: 1, rightContent: editIntroData.introduction.introductionSectionIntroText, rightImagePath: editIntroData.introduction.introductionSectionMedia.blobPath })
        if (item.carrouselMedia.image.files instanceof File) {
          formdata.append("files", item.carrouselMedia.image.files, `intro_new_image_animation_${index}.${item.carrouselMedia.image.fileExtension}`);
        }
        if (item.carrouselMedia.audio.files instanceof File) {
          formdata.append("files", item.carrouselMedia.image.files, `intro_new_audio_${index}.${item.carrouselMedia.audio.fileExtension}`);
        }
        if (editIntroData.introduction.introductionSectionMedia.files instanceof File) {
          formdata.append("files", editIntroData.introduction.introductionSectionMedia.files, `intro_new_right_image_${index}.${editIntroData.introduction.introductionSectionMedia.fileExtension}`);
        }


      })

      editIntroData.learningPath.forEach((item, index) => {
        const media = item.learningPathMedia;

        // Push learning path content to array
        introArray.push({
          ...(item.learningPathId && { id: item.learningPathId }),
          content: item.description,
          isStatic: 0,
          action_direction: item.gesture,
          reward: String(item.reward)
        });


        // Append media file
        if (media.gestureAnimation.files instanceof File) {
          formdata.append("files", media.gestureAnimation.files, `intro_image_animation_${editIntroData.carrousel.length + index}.${media.gestureAnimation.fileExtension}`);
        }
        if (media.gestureAudio.files instanceof File) {
          formdata.append("files", media.gestureAudio.files, `learning_path_audio_${editIntroData.carrousel.length + index}.${media.gestureAudio.fileExtension}`);
        }
      });


      editIntroData.newLearningPath.forEach((item, index) => {
        newIntroArray.push({ content: item.description, isStatic: 0, action_direction: item.gesture })
        if (item.learningPathMedia.gestureAnimation.files instanceof File) {
          formdata.append("files", item.learningPathMedia.gestureAnimation.files, `intro_new_image_animation_${editIntroData.newCarrousel.length + index}.${item.learningPathMedia.gestureAnimation.fileExtension}`);
        }
        if (item.learningPathMedia.gestureAudio.files instanceof File) {
          formdata.append("files", item.learningPathMedia.gestureAudio.files, `learning_path_new_audio_${editIntroData.newCarrousel.length + index}.${item.learningPathMedia.gestureAudio.fileExtension}`);
        }


      })


      if (editIntroData.introS3Path.length > 0) {
        formdata.append("removeFiles", JSON.stringify(editIntroData.introS3Path.filter((s3path: string) => s3path.trim() !== "").map((s3path: string) => ({ path: s3path.replace(`${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}`, "") }))));
      }

      formdata.append("introData", JSON.stringify(introArray));

      if (newIntroArray.length > 0) {
        formdata.append("newIntroData", JSON.stringify(newIntroArray));
      }

      if (editIntroData.introId) {
        await updateIntro(formdata, access_token).then((updateResponse) => {
          const { data, statusCode } = updateResponse;
          if (statusCode === 200) {
            setMessage({
              ...message,
              successMessage: "Intro updated successfully!"
            });
          } else if (statusCode === 401) {
            getAuthorizedToken();
            setMessage({
              ...message,
              failureMessage: "Authorization token expired. Try again!"
            })
          }

        });
      } else {
        await createUnitInfo(formdata, access_token).then((createResponse) => {
          const { data, statusCode } = createResponse;
          if (statusCode === 200) {
            setMessage({
              ...message,
              successMessage: "Intro added successfully!"
            });
          } else if (statusCode === 401) {
            getAuthorizedToken();
            setMessage({
              ...message,
              failureMessage: "Authorization token expired. Try again!"
            })
          }
        });
      }
    } catch (error: any) {
      if (error.response && error.response.data && typeof error.response.data === "string") {
        setMessage({
          ...message,
          failureMessage: error.response.data.message
        })
      } else {
        setMessage({
          ...message,
          failureMessage: "Something went wrong. Please try again"
        })
      }
    } finally {
      setTimeout(() => {
        setMessage(((prev: MessageDataType) => {
          const updatedData = { ...prev };
          updatedData.errorMessage = prev.errorMessage;
          updatedData.failureMessage = "";
          updatedData.successMessage = ""
          return updatedData
        }))

      }, 2500)
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
      getAllIntro()
    }

  };


  const handleCancel = () => {
    setShow(true)
    setConfirmationPopupData({
      title: `Are you sure you want to cancel?`,
      message: "This action cannot be undone.",
      descriptions: "",
      acceptText: "Yes",
      cancelText: "Cancel",
      onAccept: async () => {
        setShow(false);
        setCurrentPage(1);
        if (activeDifficultyType === "1" || activeDifficultyType === "2" || activeDifficultyType === "3") {
          getAllQuestion(activeDifficultyType, indexOfFirstItem)
        }

        if (activeDifficultyType === "1") {
          getAllIntro()
        }
        setEditQuestionData({
          id: "",
          level: "",
          category: QuestionCategory.random,
          action: Action.none,
          type: QuestionType.none,
          difficultyType: { id: "", name: "" },
          gradeId: "",
          unitId: "",
          hint: "",
          reward: 0,
          mediaFile: {
            image: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
            questionMediaFile: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
            audioFile: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
            completeAudioFile: {
              files: "",
              blobPath: "",
              fileExtension: ""
            }
          },

          question: "",
          answer: [],
          optionWithImage: OptionWithImage.none,
          deleteS3Path: []
        })
        getAllQuestion(activeDifficultyType, indexOfFirstItem)

      },
      onCancel: handleClose,
    })
  }

  const handleIntroSelect = (type: string, index: number, checked: boolean) => {
    if (type === "Carrousel") {
      const updated = [...editIntroData.carrousel];
      updated[index].selected = checked;
      setEditIntroData({ ...editIntroData, carrousel: updated });
    } else if (type === "NewCarrousel") {
      const updated = [...editIntroData.newCarrousel];
      updated[editIntroData.carrousel.length > index ? editIntroData.carrousel.length - index : index - editIntroData.carrousel.length].selected = checked;
      setEditIntroData({ ...editIntroData, newCarrousel: updated });
    } else if (type === "LearningPath") {
      const updated = [...editIntroData.learningPath];
      updated[index].selected = checked;
      setEditIntroData({ ...editIntroData, learningPath: updated });
    } else if (type === "NewLearningPath") {
      const updated = [...editIntroData.newLearningPath];
      updated[index].selected = checked;
      setEditIntroData({ ...editIntroData, newLearningPath: updated });
    }


  };


  const handleClosePreview = () => {
    setPreviewSource("");
    setShowPreview(prev => ({
      ...prev,
      animationShow: false,
      imageShow: false
    }))
  };

  const getAllQuestion = async (difficultyId: string, FirstItemIndex: number) => {
    try {
      setLoading(prev => ({ ...prev, fetchingLoading: true, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))

      if (questionFilter.questionType === QuestionType.none) {
        await getAllQuestionByUnitIdAndType(location.state.id, location.state.grade, difficultyId, String(FirstItemIndex), String(itemsPerPage), access_token).then((getAllQuestionResponse) => {
          const { data, statusCode } = getAllQuestionResponse;
          if (statusCode === 200) {
            handleTableQuestionData(data)
          }
        })
      } else {
        await searchQuestion(unitData.id, "", "", questionFilter.questionType, activeDifficultyType, null, null, String(indexOfFirstItem), String(itemsPerPage), access_token).then((searchResponse) => {
          const { data, statusCode } = searchResponse;
          if (statusCode === 200) {
            handleTableQuestionData(data)
          } else if (statusCode === 401) {
            getAuthorizedToken();
            setMessage({
              ...message,
              failureMessage: "Authorization token expired. Try again!"
            })
          }
        })
      }

    } catch (error: any) {
      console.error("Question :: ", error);
    }

  }

  const handleIntroData = (IntroTableData: any) => {
    try {
      const { questions, count } = IntroTableData;
      setQuestionCount(count);

      const carrousel: CarrouselDataType[] = [];
      const newCarrousel: CarrouselDataType[] = [];
      const learningPath: LearningPathDataType[] = [];

      let introduction: IntroductionSectionDataType = {
        introductionSectionMedia: {
          files: null,
          blobPath: '',
          fileExtension: '',
        },
        introductionSectionIntroText: '',
      };

      questions.forEach((q: any) => {

        if (q.isStatic === 1) {
          // Push to carrousel array
          carrousel.push({
            caurrouselId: q.id,
            carrouselMedia: {
              image: {
                files: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${q.imageAnimationPath}`,
                blobPath: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${q.imageAnimationPath}`,
                fileExtension: q.imageAnimationPath?.split('.').pop() || '',
              },
              audio: {
                files: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${q.audioPath}`,
                blobPath: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${q.audioPath}`,
                fileExtension: q.audioPath?.split('.').pop() || '',
              },
            },
            carrouselIntroText: q.content || '',
            selected: false

          });

          // Assign introduction only once if not already set
          if (!introduction.introductionSectionMedia.blobPath && q.rightImagePath) {
            introduction = {
              introductionSectionMedia: {
                files: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${q.rightImagePath}`,
                blobPath: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${q.rightImagePath}`,
                fileExtension: q.rightImagePath?.split('.').pop() || '',
              },
              introductionSectionIntroText: q.rightContent || '',
            };
          }
        } else {
          learningPath.push({
            learningPathId: q.id,
            gesture: q.action_direction === 'RIGHT' ? Gesture.Right : q.action_direction === 'LEFT' ? Gesture.Left : q.action_direction === 'UP' ? Gesture.Up : q.action_direction === 'DOWN' ? Gesture.Down : q.action_direction === 'TAP' ? Gesture.Tap : q.action_direction === 'DRAGLEFTANDRIGHT' ? Gesture.DragLeftAndRight : q.action_direction === 'DRAGUPANDOWN' ? Gesture.DragUpAndDown : q.action_direction === 'NONE' ? Gesture.None : Gesture.Empty,
            learningPathMedia: {
              gestureAnimation: {
                files: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${q.imageAnimationPath}`,
                blobPath: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${q.imageAnimationPath}`,
                fileExtension: q.imageAnimationPath?.split('.').pop() || '',
              },
              gestureAudio: {
                files: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${q.learningPathAudio}`,
                blobPath: `${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}${q.learningPathAudio}`,
                fileExtension: q.learningPathAudio?.split('.').pop() || '',
              }
            },
            description: q.content || '',
            reward: q.reward ? Number(q.reward) : 0,
            selected: false
          });
        }
      });

      // Add default empty carrousel if none found
      if (learningPath.length > 0 && carrousel.length === 0) {
        // for (let i = 0; i < 3; i++) {
        newCarrousel.push({
          caurrouselId: "",
          carrouselMedia: {
            image: { files: null, blobPath: '', fileExtension: '' },
            audio: { files: null, blobPath: '', fileExtension: '' },
          },
          carrouselIntroText: '',
          selected: false
        });
        // }
      } else if (learningPath.length === 0 && carrousel.length === 0) {
        carrousel.push({
          caurrouselId: "",
          carrouselMedia: {
            image: { files: null, blobPath: '', fileExtension: '' },
            audio: { files: null, blobPath: '', fileExtension: '' },
          },
          carrouselIntroText: '',
          selected: false
        });
      }


      setEditIntroData(prev => ({
        ...prev, // preserve top-level keys
        introId:
          carrousel.length > 0 && carrousel[0].caurrouselId ? carrousel[0].caurrouselId : learningPath.length > 0 && learningPath[0].learningPathId ? learningPath[0].learningPathId : "",
        deletedS3Path: [],
        carrousel,
        newCarrousel,
        introduction,
        learningPath,
        newLearningPath: [],
      }));

    } finally {
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
    }
  };



  const getAllIntro = async () => {
    try {
      setLoading(prev => ({ ...prev, fetchingLoading: true, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
      await getAllUnitInfo(location.state.id, access_token).then((getAllIntroResponse: any) => {
        const { data, statusCode } = getAllIntroResponse;
        if (statusCode === 200) {
          handleIntroData(data)
        }
      })
    } catch (error: any) {
      console.error("Question :: ", error);
    } finally {
      setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
    }
  }

  useEffect(() => {
    setLoading(prev => ({ ...prev, fetchingLoading: true, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
    setEditIntroData({
      introId: "",
      deletedS3Path: [],
      introS3Path: [],
      carrousel: [{
        caurrouselId: "",
        carrouselMedia: {
          image: {
            files: "",
            blobPath: "",
            fileExtension: ""

          },
          audio: {
            files: "",
            blobPath: "",
            fileExtension: ""

          }
        },
        carrouselIntroText: "",
        selected: false
      }],
      newCarrousel: [],
      introduction: {
        introductionSectionMedia: {
          files: "",
          blobPath: "",
          fileExtension: ""
        },
        introductionSectionIntroText: ""
      },
      learningPath: [
        {
          learningPathId: "",
          gesture: Gesture.Empty,
          learningPathMedia: {
            gestureAnimation: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
            gestureAudio: {
              files: "",
              blobPath: "",
              fileExtension: ""
            }
          },
          description: "",
          reward: 0,
          selected: false
        }
      ],
      newLearningPath: [],
      congratulation: {
        congratulationId: "",
        congratulationBadgeIcon: {
          files: "",
          blobPath: "",
          fileExtension: ""

        },
        congratulationAudio: {
          files: "",
          blobPath: "",
          fileExtension: ""

        },
        congratulationText: "",
        congratulationCoins: 0,
        deletedS3Path: []
      },
      instruction: {
        id: "",
        instruction_image: {
          files: "",
          blobPath: "",
          fileExtension: ""
        },

        audio: {
          files: "",
          blobPath: "",
          fileExtension: ""
        },
        text: "",
        scientific_hypothesis: "",
        deletedS3Path: []
      },
      removeFiles: []
    })

    if (activeDifficultyType === "1" || activeDifficultyType === "2" || activeDifficultyType === "3") {
      setEditQuestionData({
        id: "",
        level: "",
        category: QuestionCategory.random,
        action: Action.none,
        gradeId: "",
        unitId: "",
        difficultyType: { id: "", name: "" },
        type: QuestionType.none,
        deletedOption: [],
        hint: "",
        reward: 0,
        deleteS3Path: [],
        mediaFile: {
          image: {
            files: "",
            blobPath: "",
            fileExtension: ""
          },
          questionMediaFile: {
            files: "",
            blobPath: "",
            fileExtension: ""
          },
          audioFile: {
            files: "",
            blobPath: "",
            fileExtension: ""
          },
          completeAudioFile: {
            files: "",
            blobPath: "",
            fileExtension: ""
          }
        },
        question: "",
        answer: [],
        optionWithImage: OptionWithImage.none
      });
      getAllQuestion(activeDifficultyType, indexOfFirstItem);
      setShowAddQuestion(false)
      dispatch(setActiveType(activeDifficultyType))
    }

    if (activeDifficultyType === "1") {
      getAllIntro()
    }



  }, [activeDifficultyType, currentPage, currentPage, questionFilter.questionType])

  const handleClose = () => setShow(false);

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const getAuthorizedToken = async () => {
    try {
      await getNewAccessToken({ refreshToken: refresh_token }).then((newTokenResponse) => {
        const { data, statusCode } = newTokenResponse;
        if (statusCode === 200) {
          dispatch(setToken({
            access_token: data.accessToken,
            refresh_token: data.refreshToken
          }))
        }
      })
    } catch (error: any) {
      console.error("Something went wrong in getting new access Token :: ", error)
    }
  }



  const handleInput = (name: string, value: string | OptionWithImage | DifficultType | QuestionType) => {
    setEditQuestionData((prevData: any) => {
      const updatedData: QuestionDataType = { ...prevData };
      if (name === "instruction") {
        updatedData.instruction = value as string;
      } else if (name === "hint") {
        updatedData.hint = value as string;
      } else if (name === "question") {
        updatedData.question = value;
      } else if (name === "optionWithImage") {
        if (value === OptionWithImage.yes) {
          if (updatedData.mediaFile.questionMediaFile.files) {
            setMessage({
              ...message,
              errorMessage: ["Before adding the option image delete the question media."]
            });
            return updatedData;
          } else {
            updatedData.optionWithImage = value as OptionWithImage;
            updatedData.mediaFile.questionMediaFile = { files: "", blobPath: "", fileExtension: "" };
          }
        } else {
          const imageExist = updatedData.options?.some((option) => option.media.imagePath.files);
          if (!imageExist) {
            updatedData.optionWithImage = value as OptionWithImage;
            updatedData.mediaFile.questionMediaFile = { files: "", blobPath: "", fileExtension: "" };
          } else {
            setMessage({
              ...message,
              errorMessage: ["Please remove all the option images."]
            });
            // alert("Please remove all the option images.")
            return updatedData;
          }
        }
        if (updatedData.mediaFile.questionMediaFile.files) {
          alert("Before adding the option image delete the question media.")
        } else {
          const imageExist = updatedData.options?.some((option) => option.media.imagePath.files);
          if (!imageExist) {
            updatedData.optionWithImage = value as OptionWithImage;
            updatedData.mediaFile.questionMediaFile = { files: "", blobPath: "", fileExtension: "" };
          }
        }
      } else if (name === "reward") {
        updatedData.reward = Number(value);
      } else if (name === "type") {
        if (value === QuestionType.fill) {
          delete updatedData.dragMatchPair;
          delete updatedData.pairs;
          delete updatedData.options;
          updatedData.optionWithImage = OptionWithImage.yes;
          updatedData.mediaFile.questionMediaFile = { files: "", blobPath: "", fileExtension: "" };
          updatedData.type = QuestionType.fill;
          updatedData.blanks = [{ id: "", blankText: "", blankPosition: 0, media: { audioPath: { files: "", blobPath: "", fileExtension: "" }, imagePath: { files: "", blobPath: "", fileExtension: "" } }, isAnswer: false }];
        } else if (value === QuestionType.match) {
          delete updatedData.blanks;
          delete updatedData.dragMatchPair;
          delete updatedData.options;
          updatedData.optionWithImage = OptionWithImage.yes;
          updatedData.type = value;
          updatedData.pairs = [{ id: "", media: { imagePath: { files: "", fileExtension: "", blobPath: "" }, audioPath: { files: "", fileExtension: "", blobPath: "" } }, leftItem: "", rightItem: "" }];
        } else if (value === QuestionType.mcq) {
          delete updatedData.pairs;
          delete updatedData.blanks;
          delete updatedData.dragMatchPair;
          updatedData.optionWithImage = OptionWithImage.none;
          updatedData.type = value;
          updatedData.options = [{ id: "", optionText: "", media: { audioPath: { files: "", blobPath: "", fileExtension: "" }, imagePath: { files: "", blobPath: "", fileExtension: "" } }, isAnswer: false }];
        } else if (value === QuestionType.dragMatch) {
          delete updatedData.blanks;
          delete updatedData.pairs;
          delete updatedData.options;
          updatedData.optionWithImage = OptionWithImage.none;
          updatedData.type = value;
          updatedData.dragMatchPair = [{ id: "", item: "", answer: "", media: { audioPath: { files: "", blobPath: "", fileExtension: "" } } }];
        }
      }
      return updatedData;
    });
  };

  const handleOptionMedia = (questionType: QuestionType, e: any, OptionIndex: number, type: string) => {
    const { name, files } = e.target;
    if (!files || files.length === 0) return;

    const file = files?.[0];

    const fileType = file.type;
    const isImage = fileType.startsWith("image/");
    const isAnimation = fileType.startsWith("application/")
    const isAudio = fileType.startsWith("audio/");
    if (name === `question-media`) {

      if (isImage || isAnimation) {
        if (file && (file.name.toLowerCase().endsWith('.png') || file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg') || file.name.toLowerCase().endsWith('.svg'))) {
          if (checkFileLimit(file)) {
            setEditQuestionData((prevData: any) => {
              const updatedData: QuestionDataType = { ...prevData };
              updatedData.mediaFile.questionMediaFile = {
                files: file,
                blobPath: file ? URL.createObjectURL(file) : undefined,
                fileExtension: file.name.toLowerCase().split('.').pop() || '',
              }

              return updatedData; // Return the updated state
            });
          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }

        } else if (file && file.name.toLowerCase().endsWith('.json')) {
          if (checkFileLimit(file)) {
            const reader = new FileReader();
            reader.onload = (event) => {
              try {
                const json = JSON.parse(event.target?.result as string);
                if (!isLottieJson(json)) {
                  setMessage({
                    ...message,
                    errorMessage: ['Uploaded JSON is not a valid Lottie JSON animation.']
                  });
                  return;
                }

                // Proceed to set state if valid
                setEditQuestionData((prevData: any) => {
                  const updatedData: QuestionDataType = { ...prevData };
                  updatedData.mediaFile.questionMediaFile = {
                    files: file ? file : "",
                    blobPath: file ? URL.createObjectURL(file) : "",
                    fileExtension: file.name.toLowerCase().split('.').pop() || '',
                  }

                  return updatedData; // Return the updated state
                });
              } catch (err) {
                setMessage({
                  ...message,
                  errorMessage: ['Failed to parse JSON file.']
                });
              }
            };
            reader.readAsText(file);
            return;
          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }

        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported format. Please upload valid JSON, PNG, JPG, or JPEG.']
          });
          return;
        }

      } else {
        setMessage({
          ...message,
          errorMessage: ['Unsupported format. Please upload valid JSON, PNG, JPG, or JPEG.']
        });
        return;
      }

    } else if (name === "voice-over-audio") {
      if (isAudio) {
        if (file && (file.name.toLowerCase().endsWith('.mp3') || file.name.toLowerCase().endsWith('.wav'))) {
          if (checkFileLimit(file)) {
            setEditQuestionData((prevData: any) => {
              const updatedData: QuestionDataType = { ...prevData };
              updatedData.mediaFile.audioFile = {
                files: file,
                blobPath: URL.createObjectURL(file),
                fileExtension: file.name.toLowerCase().split('.').pop() || '',
              }

              return updatedData; // Return the updated state
            });
          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }

        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported format. Please upload valid MP3 or WAV.']
          });
          return;
        }
      } else {
        setMessage({
          ...message,
          errorMessage: ['Unsupported format. Please upload valid MP3 or WAV.']
        });
        return;
      }


    } else if (name === "complete-voice-over-audio") {
      if (isAudio) {
        if (file && (file.name.toLowerCase().endsWith('.mp3') || file.name.toLowerCase().endsWith('.wav'))) {
          if (checkFileLimit(file)) {
            setEditQuestionData((prevData: any) => {
              const updatedData: QuestionDataType = { ...prevData };
              updatedData.mediaFile.completeAudioFile = {
                files: file,
                blobPath: file ? URL.createObjectURL(file) : undefined,
                fileExtension: file.name.toLowerCase().split('.').pop() || '',
              }

              return updatedData; // Return the updated state
            });
          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }

        } else {
          setMessage({
            ...message,
            errorMessage: ['Unsupported format. Please upload valid MP3 or WAV.']
          });
          return;
        }
      } else {
        setMessage({
          ...message,
          errorMessage: ['Unsupported format. Please upload valid MP3 or WAV.']
        });
        return;
      }


    } else {
      if (type === "image") {
        const supportedExtensions = ['png', 'jpg', 'jpeg', 'svg', 'json'];
        const extension = file?.name.split('.').pop()?.toLowerCase();

        if (!file || !supportedExtensions.includes(extension || '')) {
          setMessage({
            ...message,
            errorMessage: ['Unsupported image format. Please upload MP3 or WAV files.']
          });
          return;
        }

        if (file && (file.name.toLowerCase().endsWith('.png') || file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg') || file.name.toLowerCase().endsWith('.svg'))) {
          if (checkFileLimit(file)) {
            const imagePath = {
              files: file,
              blobPath: URL.createObjectURL(file),
              fileExtension: extension || '',
            };

            setEditQuestionData((prevData: any) => {
              const updatedData: QuestionDataType = { ...prevData };

              switch (questionType) {
                case QuestionType.mcq:
                  if (updatedData.options) {
                    updatedData.options[OptionIndex].media = {
                      ...updatedData.options[OptionIndex].media,
                      imagePath,
                    };
                  }
                  break;

                case QuestionType.fill:
                  if (updatedData.blanks) {
                    updatedData.blanks[OptionIndex].media = {
                      ...updatedData.blanks[OptionIndex].media,
                      imagePath,
                    };
                  }
                  break;

                case QuestionType.match:
                  if (updatedData.pairs) {
                    updatedData.pairs[OptionIndex].media = {
                      ...updatedData.pairs[OptionIndex].media,
                      imagePath,
                    };
                  }
                  break;



                default:
                  break;
              }

              return updatedData;
            });
          } else {
            setMessage({
              ...message,
              errorMessage: ['File Size Exceed. Try to upload within the size limit.']
            });
            return;
          }

        } else if (file && file.name.toLowerCase().endsWith('.json')) {
          if (checkFileLimit(file)) {
            const reader = new FileReader();
            reader.onload = (event) => {
              try {
                const json = JSON.parse(event.target?.result as string);
                if (!isLottieJson(json)) {
                  setMessage({
                    ...message,
                    errorMessage: ['Uploaded JSON is not a valid Lottie JSON animation.']
                  });
                  return;
                }

                const imagePath = {
                  files: file,
                  blobPath: URL.createObjectURL(file),
                  fileExtension: extension || '',
                };

                setEditQuestionData((prevData: any) => {
                  const updatedData: QuestionDataType = { ...prevData };

                  switch (questionType) {
                    case QuestionType.mcq:
                      if (updatedData.options) {
                        updatedData.options[OptionIndex].media = {
                          ...updatedData.options[OptionIndex].media,
                          imagePath,
                        };
                      }
                      break;

                    case QuestionType.fill:
                      if (updatedData.blanks) {
                        updatedData.blanks[OptionIndex].media = {
                          ...updatedData.blanks[OptionIndex].media,
                          imagePath,
                        };
                      }
                      break;

                    case QuestionType.match:
                      if (updatedData.pairs) {
                        updatedData.pairs[OptionIndex].media = {
                          ...updatedData.pairs[OptionIndex].media,
                          imagePath,
                        };
                      }
                      break;



                    default:
                      break;
                  }

                  return updatedData;
                });

              } catch (err) {
                setMessage({
                  ...message,
                  errorMessage: ['Failed to parse JSON file.']
                });
              }
            };
            reader.readAsText(file);
            return;
          }
        } else {
          setMessage({
            ...message,
            errorMessage: ['File Size Exceed. Try to upload within the size limit.']
          });
          return;
        }



      } else if (type === "audio") {
        const supportedExtensions = ['mp3', 'wav'];
        const extension = file?.name.split('.').pop()?.toLowerCase();

        if (!file || !supportedExtensions.includes(extension || '')) {
          setMessage({
            ...message,
            errorMessage: ['Unsupported image format. Please upload MP3 or WAV files.']
          });
          return;
        }

        if (checkFileLimit(file)) {
          const audioPath = {
            files: file,
            blobPath: URL.createObjectURL(file),
            fileExtension: extension || '',
          };

          setEditQuestionData((prevData: any) => {
            const updatedData: QuestionDataType = { ...prevData };

            switch (questionType) {
              case QuestionType.mcq:
                if (updatedData.options) {
                  updatedData.options[OptionIndex].media = {
                    ...updatedData.options[OptionIndex].media,
                    audioPath,
                  };
                }
                break;

              case QuestionType.fill:
                if (updatedData.blanks) {
                  updatedData.blanks[OptionIndex].media = {
                    ...updatedData.blanks[OptionIndex].media,
                    audioPath,
                  };
                }
                break;

              case QuestionType.match:
                if (updatedData.pairs) {
                  updatedData.pairs[OptionIndex].media = {
                    ...updatedData.pairs[OptionIndex].media,
                    audioPath
                  }
                }
                break;

              case QuestionType.dragMatch:
                if (updatedData.dragMatchPair) {
                  updatedData.dragMatchPair[OptionIndex].media = {
                    ...updatedData.dragMatchPair[OptionIndex].media,
                    audioPath
                  }
                }
                break;

              default:
                break;
            }

            return updatedData;
          });
        } else {
          setMessage({
            ...message,
            errorMessage: ['File Size Exceed. Try to upload within the size limit.']
          });
          return;
        }


      }

    }

  };

  const handleOptionDelete = (questionType: QuestionType, filePath: any, optionIndex: number, name: string, type: string) => {

    setShow(true)
    setConfirmationPopupData({
      title: `Are you sure you want to delete?`,
      message: "This action cannot be undone.",
      descriptions: "",
      acceptText: "Delete",
      cancelText: "Cancel",
      onAccept: async () => {
        setShow(false)

        if (typeof filePath === "string") {
          // editQuestionData.deleteS3Path.push(filePath)
          setEditQuestionData((prevData: any) => {
            if (!prevData) return prevData;
            const updatedData: QuestionDataType = { ...prevData }; // Shallow copy of the state

            if (optionIndex > -1) {
              if (questionType === QuestionType.mcq) {

                if (type === "audio") {
                  const options = updatedData.options;
                  if (options && options[optionIndex]) {
                    options[optionIndex].media = {
                      ...options[optionIndex].media, // Shallow copy of the specific option
                      audioPath: {
                        files: "",
                        blobPath: "",
                        fileExtension: "",
                      },
                    };
                  }
                } else if (type === "image") {
                  const options = updatedData.options;
                  if (options && options[optionIndex]) {
                    options[optionIndex].media = {
                      ...options[optionIndex].media, // Shallow copy of the specific option
                      imagePath: {
                        files: "",
                        blobPath: "",
                        fileExtension: "",
                      },
                    };
                  }
                }

              } else if (questionType === QuestionType.fill) {
                if (type === "audio") {
                  const blanks = updatedData.blanks;
                  if (blanks && blanks[optionIndex]) {
                    updatedData.deleteS3Path.push(blanks[optionIndex].media.audioPath.files)
                    blanks[optionIndex].media = {
                      ...blanks[optionIndex].media, // Shallow copy of the specific blank
                      audioPath: {
                        files: "",
                        blobPath: "",
                        fileExtension: "",
                      },
                    };
                  }
                } else if (type === "image") {
                  const blanks = updatedData.blanks;
                  if (blanks && blanks[optionIndex]) {
                    updatedData.deleteS3Path.push(blanks[optionIndex].media.imagePath.files)
                    blanks[optionIndex].media = {
                      ...blanks[optionIndex].media, // Shallow copy of the specific blank
                      imagePath: {
                        files: "",
                        blobPath: "",
                        fileExtension: "",
                      },
                    };
                  }
                }
              } else if (questionType === QuestionType.match) {
                if (type === "audio") {
                  const pairs = updatedData.pairs;
                  if (pairs && pairs[optionIndex]) {
                    updatedData.deleteS3Path.push(pairs[optionIndex].media.audioPath.files)
                    pairs[optionIndex].media = {
                      ...pairs[optionIndex].media, // Shallow copy of the specific blank
                      audioPath: {
                        files: "",
                        blobPath: "",
                        fileExtension: "",
                      },
                    };
                  }
                } else if (type === "image") {
                  const pairs = updatedData.pairs;
                  if (pairs && pairs[optionIndex]) {
                    updatedData.deleteS3Path.push(pairs[optionIndex].media.imagePath.files)
                    pairs[optionIndex].media = {
                      ...pairs[optionIndex].media, // Shallow copy of the specific blank
                      imagePath: {
                        files: "",
                        blobPath: "",
                        fileExtension: "",
                      },
                    };
                  }
                }
              } else if (questionType === QuestionType.dragMatch) {
                if (type === "audio") {
                  const dragMatchPair = updatedData.dragMatchPair;
                  if (dragMatchPair && dragMatchPair[optionIndex]) {
                    updatedData.deleteS3Path.push(dragMatchPair[optionIndex].media.audioPath.files)
                    dragMatchPair[optionIndex].media = {
                      ...dragMatchPair[optionIndex].media, // Shallow copy of the specific blank
                      audioPath: {
                        files: "",
                        blobPath: "",
                        fileExtension: "",
                      },
                    };
                  }
                }
              }

            } else {
              const updatedData: QuestionDataType = { ...prevData };

              if (name === "question-media") {
                const questionMediaFile = updatedData.mediaFile.questionMediaFile;

                if (questionMediaFile) {
                  questionMediaFile.files = ""
                  questionMediaFile.blobPath = ""
                  questionMediaFile.fileExtension = ""
                }
              } else if (name === "voice-over-audio") {
                const voiceOverAudio = updatedData.mediaFile.audioFile;

                if (voiceOverAudio) {
                  voiceOverAudio.files = ""
                  voiceOverAudio.blobPath = ""
                  voiceOverAudio.fileExtension = ""
                }
              } else if (name === "complete-voice-over-audio") {
                const completevoiceOverAudio = updatedData.mediaFile.completeAudioFile;

                if (completevoiceOverAudio) {
                  completevoiceOverAudio.files = ""
                  completevoiceOverAudio.blobPath = ""
                  completevoiceOverAudio.fileExtension = ""
                }
              }



            }

            return {
              ...updatedData,
              deleteS3Path: [
                ...updatedData.deleteS3Path,
                filePath
              ]
            }; // Return the updated state
          });

        } else {
          setEditQuestionData((prevData: any) => {
            if (!prevData) return prevData;
            const updatedData: QuestionDataType = { ...prevData }; // Shallow copy of the state

            if (optionIndex > -1) {
              if (questionType === QuestionType.mcq) {

                if (type === "audio") {
                  const options = updatedData.options;
                  if (options && options[optionIndex]) {
                    options[optionIndex].media = {
                      ...options[optionIndex].media, // Shallow copy of the specific option
                      audioPath: {
                        files: "",
                        blobPath: "",
                        fileExtension: "",
                      },
                    };
                  }
                } else if (type === "image") {
                  const options = updatedData.options;
                  if (options && options[optionIndex]) {
                    options[optionIndex].media = {
                      ...options[optionIndex].media, // Shallow copy of the specific option
                      imagePath: {
                        files: "",
                        blobPath: "",
                        fileExtension: "",
                      },
                    };
                  }
                }

              } else if (questionType === QuestionType.fill) {
                if (type === "audio") {
                  const blanks = updatedData.blanks;
                  if (blanks && blanks[optionIndex]) {
                    blanks[optionIndex].media = {
                      ...blanks[optionIndex].media, // Shallow copy of the specific blank
                      audioPath: {
                        files: "",
                        blobPath: "",
                        fileExtension: "",
                      },
                    };
                  }
                } else if (type === "image") {
                  const blanks = updatedData.blanks;
                  if (blanks && blanks[optionIndex]) {
                    blanks[optionIndex].media = {
                      ...blanks[optionIndex].media, // Shallow copy of the specific blank
                      imagePath: {
                        files: "",
                        blobPath: "",
                        fileExtension: "",
                      },
                    };
                  }
                }
              } else if (questionType === QuestionType.match) {
                if (type === "audio") {
                  const pairs = updatedData.pairs;
                  if (pairs && pairs[optionIndex]) {
                    pairs[optionIndex].media = {
                      ...pairs[optionIndex].media, // Shallow copy of the specific blank
                      audioPath: {
                        files: "",
                        blobPath: "",
                        fileExtension: "",
                      },
                    };
                  }
                } else if (type === "image") {
                  const pairs = updatedData.pairs;
                  if (pairs && pairs[optionIndex]) {
                    pairs[optionIndex].media = {
                      ...pairs[optionIndex].media, // Shallow copy of the specific blank
                      imagePath: {
                        files: "",
                        blobPath: "",
                        fileExtension: "",
                      },
                    };
                  }
                }
              } else if (questionType === QuestionType.dragMatch) {
                if (type === "audio") {
                  const dragMatchPair = updatedData.dragMatchPair;
                  if (dragMatchPair && dragMatchPair[optionIndex]) {
                    dragMatchPair[optionIndex].media = {
                      ...dragMatchPair[optionIndex].media, // Shallow copy of the specific blank
                      audioPath: {
                        files: "",
                        blobPath: "",
                        fileExtension: "",
                      },
                    };
                  }
                }
              }

            } else {
              const updatedData: QuestionDataType = { ...prevData };

              if (name === "question-media") {
                const questionMediaFile = updatedData.mediaFile.questionMediaFile;

                if (questionMediaFile) {
                  questionMediaFile.files = ""
                  questionMediaFile.blobPath = ""
                  questionMediaFile.fileExtension = ""
                }
              } else if (name === "voice-over-audio") {
                const voiceOverAudio = updatedData.mediaFile.audioFile;

                if (voiceOverAudio) {
                  voiceOverAudio.files = ""
                  voiceOverAudio.blobPath = ""
                  voiceOverAudio.fileExtension = ""
                }
              } else if (name === "complete-voice-over-audio") {
                const completevoiceOverAudio = updatedData.mediaFile.completeAudioFile;

                if (completevoiceOverAudio) {
                  completevoiceOverAudio.files = ""
                  completevoiceOverAudio.blobPath = ""
                  completevoiceOverAudio.fileExtension = ""
                }
              }



            }

            return {
              ...updatedData,
            }; // Return the updated state
          });
        }
      },
      onCancel: handleClose,
    })

  };


  const handleQuestionInput = (questionType: QuestionType, value: string, OptionIndex: number, label: string) => {
    if (label === "delete") {
      setShow(true)
      setConfirmationPopupData({
        title: `Are you sure you want to delete?`,
        message: "This action cannot be undone.",
        descriptions: "",
        acceptText: "Delete",
        cancelText: "Cancel",
        onAccept: async () => {
          setShow(false)
          if (questionType === QuestionType.mcq) {

            setEditQuestionData((prevData: any) => {
              const updatedData: QuestionDataType = { ...prevData };

              // Ensure `deletedOption` exists
              if (!updatedData.deletedOption) {
                updatedData.deletedOption = [];
              }

              // Check if `options` exists and `OptionIndex` is valid before accessing it
              if (updatedData.options && updatedData.options[OptionIndex] && updatedData.options[OptionIndex].id) {
                updatedData.deletedOption = [
                  ...updatedData.deletedOption,
                  updatedData.options[OptionIndex].id
                ];
              }

              // Filter out the option at `OptionIndex`
              if (updatedData.options) {
                updatedData.options = updatedData.options.filter((_, index) => index !== OptionIndex);
              }

              return updatedData;
            });


          } else if (questionType === QuestionType.dragMatch) {

            setEditQuestionData((prevData: any) => {
              const updatedData: QuestionDataType = { ...prevData };


              // Ensure `deletedOption` exists
              if (!updatedData.deletedOption) {
                updatedData.deletedOption = [];
              }

              // Check if `options` exists and `OptionIndex` is valid before accessing it
              if (updatedData.dragMatchPair && updatedData.dragMatchPair[OptionIndex] && updatedData.dragMatchPair[OptionIndex].id) {
                updatedData.deletedOption = [
                  ...updatedData.deletedOption,
                  updatedData.dragMatchPair[OptionIndex].id
                ];
              }

              if (updatedData.dragMatchPair) {
                updatedData.dragMatchPair = updatedData.dragMatchPair.filter((_: any, index: number) => index !== OptionIndex);
              }



              return { ...updatedData };
            });

          } else if (questionType === QuestionType.fill) {

            setEditQuestionData((prevData: any) => {
              const updatedData: QuestionDataType = { ...prevData };


              // Ensure `deletedOption` exists
              if (!updatedData.deletedOption) {
                updatedData.deletedOption = [];
              }

              // Check if `options` exists and `OptionIndex` is valid before accessing it
              if (updatedData.blanks && updatedData.blanks[OptionIndex] && updatedData.blanks[OptionIndex].id) {
                updatedData.deletedOption = [
                  ...updatedData.deletedOption,
                  updatedData.blanks[OptionIndex].id
                ];
              }


              if (updatedData.blanks) {
                updatedData.blanks = updatedData.blanks.filter((_: any, index: number) => index !== OptionIndex);
              }


              return { ...updatedData };
            });


          } else if (questionType === QuestionType.match) {

            setEditQuestionData((prevData: any) => {
              const updatedData: QuestionDataType = { ...prevData };


              // Ensure `deletedOption` exists
              if (!updatedData.deletedOption) {
                updatedData.deletedOption = [];
              }

              // Check if `options` exists and `OptionIndex` is valid before accessing it
              if (updatedData.pairs && updatedData.pairs[OptionIndex] && updatedData.pairs[OptionIndex].id) {
                updatedData.deletedOption = [
                  ...updatedData.deletedOption,
                  updatedData.pairs[OptionIndex].id
                ];
              }

              if (updatedData.pairs) {
                updatedData.pairs = updatedData.pairs.filter((_: any, index: number) => index !== OptionIndex);
              }


              return { ...updatedData };
            });

          }
        },
        onCancel: handleClose,
      })
    } else if (label === "add") {
      setEditQuestionData((prevData: any) => {
        let updatedData: QuestionDataType = { ...prevData };
        let errorList: string[] = [];

        if (questionType === QuestionType.mcq) {
          const options = updatedData.options ?? [];
          const lastOption = options[options.length - 1];

          if (updatedData.optionWithImage === OptionWithImage.yes) {
            if (!lastOption?.media.imagePath.files) {
              errorList.push("Option must have an image.");
            }
            if (!lastOption?.media.audioPath.files) {
              errorList.push("Option must have an audio.");
            }
            if (!lastOption || lastOption.optionText.trim() === "") {
              errorList.push("Option text cannot be empty.");
            }
          } else if (updatedData.optionWithImage === OptionWithImage.no) {
            if (!lastOption?.media.audioPath.files) {
              errorList.push("Option must have an audio.");
            }
            if (!lastOption || lastOption.optionText.trim() === "") {
              errorList.push("Option text cannot be empty.");
            }
          }

          // Check for duplicate option
          const isDuplicate = options.some((option, index) => {
            return index !== options.length - 1 && option.optionText.trim() === lastOption?.optionText.trim();
          });

          if (isDuplicate) {
            errorList.push("Duplicate option text is not allowed.");
          }

          if (errorList.length === 0) {
            updatedData.options = [
              ...options,
              { id: "", optionText: "", isAnswer: false, media: { audioPath: { files: "", blobPath: "", fileExtension: "" }, imagePath: { files: "", blobPath: "", fileExtension: "" } } }
            ];
          }
        } else if (questionType === QuestionType.match) {
          const pairs = updatedData.pairs ?? [];
          const lastPair = pairs[pairs.length - 1];


          if (!lastPair || lastPair.rightItem.trim() === "") {
            errorList.push("Answer cannot be empty.");
            // errorList.push("Both left and right match items must be filled.");
          }

          if (errorList.length === 0) {
            updatedData.pairs = [
              ...pairs,
              { id: "", media: { imagePath: { files: "", fileExtension: "", blobPath: "" }, audioPath: { files: "", blobPath: "", fileExtension: "" } }, leftItem: "", rightItem: "" }
            ];
          }
        } else if (questionType === QuestionType.fill) {
          const blanks = updatedData.blanks ?? [];
          const lastBlank = blanks[blanks.length - 1];

          if (updatedData.optionWithImage === OptionWithImage.yes) {
            if (!lastBlank?.media.imagePath.files) {
              errorList.push("Blank must have an image.");
            }

            if (!lastBlank?.media.audioPath.files) {
              errorList.push("Blank must have an audio.")
            }
            if (!lastBlank || lastBlank.blankText.trim() === "") {
              errorList.push("Blank text cannot be empty.");
            }
          } else if (updatedData.optionWithImage === OptionWithImage.no) {
            if (!lastBlank?.media.audioPath.files) {
              errorList.push("Blank must have an audio.")
            }
            if (!lastBlank || lastBlank.blankText.trim() === "") {
              errorList.push("Blank text cannot be empty.");
            }
          }

          const isDuplicate = blanks.some((blank, index) => {
            return index !== blanks.length - 1 && blank.blankText.trim() === lastBlank?.blankText.trim();
          });

          if (isDuplicate) {
            errorList.push("Duplicate blank text is not allowed.");
          }

          if (errorList.length === 0) {
            updatedData.blanks = [
              ...blanks,
              { id: "", blankPosition: blanks.length + 1, blankText: "", media: { audioPath: { files: "", blobPath: "", fileExtension: "" }, imagePath: { files: "", blobPath: "", fileExtension: "" } }, isAnswer: false }
            ];
          }
        } else if (questionType === QuestionType.dragMatch) {
          const dragMatchPair = updatedData.dragMatchPair ?? [];
          const lastPair = dragMatchPair[dragMatchPair.length - 1];

          if (!lastPair || lastPair.item.trim() === "") {
            errorList.push("Drag match item cannot be empty.");
          }

          if (errorList.length === 0) {
            updatedData.dragMatchPair = [
              ...dragMatchPair,
              { id: "", item: "", media: { audioPath: { files: "", blobPath: "", fileExtension: "" } }, answer: "" }
            ];
          }
        }


        // Store all errors in state at once
        if (errorList.length > 0) {
          setMessage({
            successMessage: "",
            errorMessage: errorList,
            failureMessage: ""
          });
        }

        return updatedData;
      });
    } else if (label === "question") {
      setEditQuestionData({
        ...editQuestionData,
        question: value
      })
    } else if (label === "instruction") {
      setEditQuestionData({
        ...editQuestionData,
        instruction: value
      })
    } else if (label === "hint") {
      setEditQuestionData({
        ...editQuestionData,
        hint: value
      })
    } else if (label === "reward") {
      setEditQuestionData({
        ...editQuestionData,
        reward: Number(value)
      })
    } else {
      if (questionType === QuestionType.mcq) {
        if (label === "option") {

          setEditQuestionData((prevData: any) => {
            const updatedData: QuestionDataType = { ...prevData };

            if (updatedData.options) {
              updatedData.options = updatedData.options.map((option: any, index: number) =>
                index === OptionIndex ? { ...option, optionText: value, isAnswer: option.isAnswer } : option
              ) || []
            }

            return { ...updatedData };
          });
        } else if (label === "answer") {
          setEditQuestionData((prevData: any) => {
            const updatedData: QuestionDataType = { ...prevData };
            let errorList: string[] = [];

            if (updatedData.options) {
              if (updatedData.optionWithImage === OptionWithImage.no) {
                updatedData.options = updatedData.options.map((option: OptionDataType, index: number) => {
                  // Check if the option is the target option and optionText is empty
                  if (index === OptionIndex && !option.optionText.trim()) {
                    errorList.push("Option text cannot be empty.");
                    setMessage({
                      ...message,
                      errorMessage: errorList
                    });
                    return option;
                  }

                  // Reset isAnswer for all options
                  option.isAnswer = false;

                  // If this is the correct option, update optionText and set isAnswer to true
                  if (index === OptionIndex) {
                    return { ...option, isAnswer: true };
                  }

                  return option;
                }) || [];
              } else if (updatedData.optionWithImage === OptionWithImage.yes) {
                updatedData.options = updatedData.options.map((option: OptionDataType, index: number) => {
                  // Check if the option is the target option and optionText is empty
                  if (index === OptionIndex && !option.optionText.trim() && !option.media.imagePath.files) {
                    errorList.push("Option image and text cannot be empty.");
                    setMessage({
                      ...message,
                      errorMessage: errorList
                    });
                    return option;
                  } else if (index === OptionIndex && !option.optionText.trim()) {
                    errorList.push("Option text cannot be empty.");
                    setMessage({
                      ...message,
                      errorMessage: errorList
                    });
                    return option;
                  } else if (index === OptionIndex && !option.media.imagePath.files) {
                    errorList.push("Option image cannot be empty.");
                    setMessage({
                      ...message,
                      errorMessage: errorList
                    });
                    return option;
                  }

                  // Reset isAnswer for all options
                  option.isAnswer = false;

                  // If this is the correct option, update optionText and set isAnswer to true
                  if (index === OptionIndex) {
                    return { ...option, isAnswer: true };
                  }

                  return option;
                }) || [];
              }

            }



            return { ...updatedData };
          });
        }
      } else if (questionType === QuestionType.dragMatch) {
        if (label === "option") {
          setEditQuestionData((prevData: any) => {
            const updatedData: QuestionDataType = { ...prevData };

            // Ensure the relevant section (WARMUP, PRACTICE, or MASTER) exists
            if (updatedData.dragMatchPair) {

              updatedData.dragMatchPair = updatedData.dragMatchPair.map((dragMatchPair: any, index: number) =>
                index === OptionIndex
                  ? {
                    ...dragMatchPair,
                    // Conditionally update the Item or answer field
                    item: value,
                  }
                  : dragMatchPair
              )

            }


            return { ...updatedData };
          });
        } else if (label === "answer") {
          setEditQuestionData((prevData: any) => {
            const updatedData: QuestionDataType = { ...prevData };

            // Ensure the relevant section (WARMUP, PRACTICE, or MASTER) exists
            if (updatedData.dragMatchPair) {

              updatedData.dragMatchPair = updatedData.dragMatchPair.map((dragMatchPair: any, index: number) =>
                index === OptionIndex
                  ? {
                    ...dragMatchPair,
                    // Conditionally update the Item or answer field
                    answer: value,
                  }
                  : dragMatchPair
              )

            }


            return { ...updatedData };
          });
        }
      } else if (questionType === QuestionType.fill) {
        if (label === "answer") {
          setEditQuestionData((prevData: any) => {
            const updatedData: QuestionDataType = { ...prevData };
            let errorList: string[] = [];

            if (updatedData.blanks) {

              if (updatedData.optionWithImage === OptionWithImage.no) {
                updatedData.blanks = updatedData.blanks.map((blank: BlankDataType, index: number) => {
                  // Check if the option is the target option and optionText is empty
                  if (index === OptionIndex && !blank.blankText.trim()) {
                    errorList.push("Option text cannot be empty.");
                    setMessage({
                      ...message,
                      errorMessage: errorList
                    });
                    return blank;
                  }

                  // If this is the correct option, update optionText and set isAnswer to true
                  if (index === OptionIndex) {
                    return { ...blank, isAnswer: !blank.isAnswer };
                  }

                  return blank;
                }) || [];
              } else if (updatedData.optionWithImage === OptionWithImage.yes) {
                updatedData.blanks = updatedData.blanks.map((blank: BlankDataType, index: number) => {
                  // Check if the option is the target option and optionText is empty
                  if (index === OptionIndex && !blank.blankText.trim() && !blank.media.imagePath.files) {
                    errorList.push("Option image and text both cannot be empty.");
                    setMessage({
                      ...message,
                      errorMessage: errorList
                    });
                    return blank;
                  } else if (index === OptionIndex && !blank.blankText.trim()) {
                    errorList.push("Option text cannot be empty.");
                    setMessage({
                      ...message,
                      errorMessage: errorList
                    });
                    return blank;
                  } else if (index === OptionIndex && !blank.media.imagePath.files) {
                    errorList.push("Option image cannot be empty.");
                    setMessage({
                      ...message,
                      errorMessage: errorList
                    });
                    return blank;
                  }

                  // If this is the correct option, update optionText and set isAnswer to true
                  if (index === OptionIndex) {
                    return { ...blank, isAnswer: !blank.isAnswer };
                  }

                  return blank;
                }) || [];
              }

            }



            return { ...updatedData };
          });
        } else {
          setEditQuestionData((prevData: any) => {
            const updatedData: QuestionDataType = { ...prevData };

            // Ensure the relevant section (WARMUP, PRACTICE, or MASTER) exists
            if (updatedData.blanks) {

              updatedData.blanks = updatedData.blanks.map((blanks: any, index: number) =>
                index === OptionIndex
                  ? {
                    ...blanks,
                    // Conditionally update the Item or answer field
                    blankText: value,
                  }
                  : blanks
              )
            }


            return { ...updatedData };
          });
        }

      } else if (questionType === QuestionType.match) {
        if (label === "left") {
          setEditQuestionData((prevData: any) => {
            const updatedData: QuestionDataType = { ...prevData };

            // Ensure the relevant section (WARMUP, PRACTICE, or MASTER) exists
            if (updatedData.pairs) {
              updatedData.pairs = updatedData.pairs.map((pair: any, index: number) =>
                index === OptionIndex
                  ? {
                    ...pair,
                    // Conditionally update the Item or answer field
                    leftItem: value,
                  }
                  : pair
              )
            }


            return { ...updatedData };
          });
        } else if (label === "answer") {
          setEditQuestionData((prevData: any) => {
            const updatedData: QuestionDataType = { ...prevData };

            // Ensure the relevant section (WARMUP, PRACTICE, or MASTER) exists
            if (updatedData.pairs) {
              updatedData.pairs = updatedData.pairs.map((pair: any, index: any) =>
                index === OptionIndex
                  ? {
                    ...pair,
                    // Conditionally update the Item or answer field
                    rightItem: value,
                  }
                  : pair
              )
            }


            return { ...updatedData };
          });
        }
      }
    }
  };

    useEffect(() => {
    console.log("Preview Source ><> ", previewSource, showPreview, allQuestionData)

  },[previewSource, showPreview, allQuestionData])

  const handleDeleteByQuestionId = async (question: QuestionDataType) => {
    setShow(true)
    setConfirmationPopupData({
      title: `Are you sure you want to delete question?`,
      message: "This action cannot be undone.",
      descriptions: "",
      acceptText: "Delete",
      cancelText: "Cancel",
      onAccept: async () => {
        setShow(false)

        try {
          setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: true, submitLoading: false, validationLoading: false, }))
          await deleteQuestionByQuestionId(question.id, access_token).then((deletedResponse) => {
            const { data, statusCode } = deletedResponse;
            if (statusCode === 200) {
              setMessage({
                failureMessage: "",
                errorMessage: [],
                successMessage: "Question deleted successfully!"
              });

              getAllQuestion(activeDifficultyType, indexOfFirstItem)
            } else if (statusCode === 401) {
              getAuthorizedToken();
              setMessage({
                ...message,
                failureMessage: "Authorization token expired. Try again!"
              })
            }
          })
        } catch (error: any) {
          if (error.response && error.response.data && typeof error.response.data === "string") {
            setMessage({
              ...message,
              failureMessage: error.response.data.message
            })

          } else {
            setMessage({
              ...message,
              failureMessage: "Something went wrong!"
            })

          }
        } finally {
          setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: true, deleteLoading: false, submitLoading: false, validationLoading: false, }))
          getAllQuestion(activeDifficultyType, indexOfFirstItem)

          setTimeout(() => {
            setMessage({
              ...message,
              successMessage: "",
              failureMessage: ""
            })
          }, 2500)

        }
      },
      onCancel: handleClose,
    })
  }

  const handleEditQuestion = (question: QuestionDataType) => {
    if (editQuestionData.id) {
      setMessage({
        ...message,
        errorMessage: ["Please save or cancel the editted question before adding new question"]
      })
    } else {
      setEditQuestionData(question);

    }


  }

  const validateQuestionData = () => {
    const { type, question, optionWithImage, mediaFile, reward, options, blanks, pairs, dragMatchPair } = editQuestionData;

    let errorMessage: string[] = [];

    if (type === QuestionType.none) {
      errorMessage.push("Select valid Question type.")
    }

    if (!mediaFile.audioFile.files) {
      errorMessage.push("Upload valid voice over audio file.")
    }

    if (type === QuestionType.fill && !mediaFile.completeAudioFile.files) {
      errorMessage.push("Upload valid complete voice over audio file.")
    }

    if (reward < 1) {
      errorMessage.push("Reward should be greater than 0.")
    }

    // Common validation functions
    const validateArray = (arr: any, minLength: number, errorMsg: string) => {
      if (arr.length < minLength) {
        errorMessage.push(errorMsg);
      }
    };

    const validateText = (text: string, errorMsg: string) => {
      if (!text?.trim()) {
        errorMessage.push(errorMsg);
      }
    };

    validateText(question, "Question cannot be empty.");

    // Validate type-specific conditions
    switch (type) {
      case QuestionType.mcq:
        if (options) {
          if (optionWithImage === OptionWithImage.none) {
            errorMessage.push("Option with Image selection is required.");
          }

          validateArray(options, 2, "There should be at least 2 options.");
          options.forEach((option: any) => validateText(option.optionText, "Option Text cannot be empty."));

          if (options.filter((option: any) => option.isAnswer).length !== 1) {
            errorMessage.push("Exactly one option must be marked as the answer.");
          }

          if (optionWithImage === OptionWithImage.yes && options.some((option: OptionDataType) => !(option.media.imagePath.files))) {
            errorMessage.push("Each option must have an image.");
          }

          if (options.some((option: OptionDataType) => !(option.media.audioPath.files))) {
            errorMessage.push("Each option must have an VO audio.");
          }
        }
        break;

      case QuestionType.fill:
        if (blanks) {
          validateArray(blanks, 2, "There should be at least 2 blanks.");
          blanks.forEach((blank: any) => validateText(blank.blankText, "Blank Text cannot be empty."));

          if (optionWithImage === OptionWithImage.yes && blanks.some((blank: BlankDataType) => !(blank.media.imagePath.files))) {
            errorMessage.push("Each blank must have an image.");
          }

          if (blanks.some((blanks: BlankDataType) => !(blanks.media.audioPath.files))) {
            errorMessage.push("Each blank must have an VO audio.")
          }

          const answerCount = blanks.filter((item: any) => item.isAnswer).length;
          if (answerCount < 1) {
            errorMessage.push("Number of answers should be greater than 1.");
          }
        }
        break;

      case QuestionType.match:
        if (pairs) {
          validateArray(pairs, 2, "There should be at least 2 pairs.");

          pairs.forEach((pair: any) => {
            if (editQuestionData.optionWithImage === OptionWithImage.yes) {
              if (!(pair.media.imagePath.files)) {
                errorMessage.push("Each blank must have an image.");
              }
            } else {
              validateText(pair.leftItem, "Left Item should not be empty.");

            }
            validateText(pair.rightItem, "Right Item should not be empty.");
          });
        }
        break;

      case QuestionType.dragMatch:
        if (dragMatchPair) {
          validateArray(dragMatchPair, 2, "There should be at least 2 drag match pairs.");

          dragMatchPair.forEach((pair: any, index: number) => {
            validateText(pair.item, `Pair ${index + 1} should not be empty.`);
            validateText(pair.answer, `Answer ${index + 1} should not be empty.`);
          });
        }
        break;
    }

    // If there are validation errors, show messages
    if (errorMessage.length > 0) {

      setMessage({ ...message, errorMessage });
    } else {
      handleQuestionSubmit()
    }
  };

  const handleQuestionSubmit = async () => {

    const formData = new FormData();
    if (editQuestionData.id) {
      formData.append("id", editQuestionData.id);
      formData.append("reward", String(editQuestionData.reward))
      

      if (editQuestionData.type === QuestionType.mcq) {
        let optionArray: any[] = [];
        let newOptionArray: any[] = []
        let AnswerArray: any[] = [];

        if (editQuestionData.options) {

          const optionsWithId = editQuestionData.options.filter(option => option.id);
          const optionsWithoutId = editQuestionData.options.filter(option => !option.id);

          optionsWithId.forEach((option, index) => {
            if (option.media.imagePath.files instanceof File) {
              formData.append("files", option.media.imagePath.files, `image_option_${index}.${option.media.imagePath.fileExtension}`);
            }
            if (option.media.audioPath.files instanceof File) {
              formData.append("files", option.media.audioPath.files, `audio_option_${index}.${option.media.audioPath.fileExtension}`);
            }
          });

          optionsWithoutId.forEach((option, index) => {
            if (option.media.imagePath.files instanceof File) {
              formData.append("files", option.media.imagePath.files, `image_new_option_${index}.${option.media.imagePath.fileExtension}`);
            }
            if (option.media.audioPath.files instanceof File) {
              formData.append("files", option.media.audioPath.files, `audio_new_option_${index}.${option.media.audioPath.fileExtension}`);
            }
          });

          optionsWithId.forEach((option, index) => {
            optionArray.push({ id: option.id, optionText: option.optionText });
            if (option.media.imagePath.files instanceof File) {
              formData.append("files", option.media.imagePath.files, `image_option_${index}.${option.media.imagePath.fileExtension}`);
            }
            if (option.media.audioPath.files instanceof File) {
              formData.append("files", option.media.audioPath.files, `audio_option_${index}.${option.media.audioPath.fileExtension}`);
            }
            if (option.isAnswer) {
              AnswerArray.push(option.optionText)
            }
          });

          optionsWithoutId.forEach((option, index) => {
            newOptionArray.push({ optionText: option.optionText });
            if (option.media.imagePath.files instanceof File) {
              formData.append("files", option.media.imagePath.files, `image_new_option_${index}.${option.media.imagePath.fileExtension}`);
            }
            if (option.media.audioPath.files instanceof File) {
              formData.append("files", option.media.audioPath.files, `audio_new_option_${index}.${option.media.audioPath.fileExtension}`);
            }
            if (option.isAnswer) {
              AnswerArray.push(option.optionText)
            }
          });


          formData.append('options', JSON.stringify(optionArray));
          if (newOptionArray.length > 0) {
            formData.append('new_options', JSON.stringify(newOptionArray));
          }
          formData.append('answer', AnswerArray.join(','));

        }

        if (editQuestionData.deletedOption && editQuestionData.deletedOption.length > 0) {
          formData.append('delete_options', JSON.stringify(editQuestionData.deletedOption.map((option: string) => ({ id: option }))));
        }

      } else if (editQuestionData.type === QuestionType.fill) {
        if (editQuestionData.blanks) {
          let blanks: any[] = [];
          let newblanks: any[] = []
          let AnswerArray: any[] = [];

          const blanksWithId = editQuestionData.blanks.filter(blank => blank.id);
          const blanksWithoutId = editQuestionData.blanks.filter(blank => !blank.id);

          blanksWithId.forEach((blank, index) => {
            blanks.push({ id: blank.id, blankText: blank.blankText, blankPosition: index + 1 });
            if (blank.isAnswer) {
              AnswerArray.push(blank.blankText)
            }
            if (blank.media.imagePath.files instanceof File) {
              formData.append("files", blank.media.imagePath.files, `image_fill_${index}.${blank.media.imagePath.fileExtension}`);
            }
            if (blank.media.audioPath.files instanceof File) {
              formData.append("files", blank.media.audioPath.files, `audio_fill_${index}.${blank.media.audioPath.fileExtension}`);
            }
          });

          blanksWithoutId.forEach((blank, index) => {
            newblanks.push({ blankText: blank.blankText, blankPosition: blanksWithId.length + 1 });
            if (blank.isAnswer) {
              AnswerArray.push(blank.blankText)
            }
            if (blank.media.imagePath.files instanceof File) {
              formData.append("files", blank.media.imagePath.files, `image_new_fill_${index}.${blank.media.imagePath.fileExtension}`);
            }
            if (blank.media.audioPath.files instanceof File) {
              formData.append("files", blank.media.audioPath.files, `audio_new_fill_${index}.${blank.media.audioPath.fileExtension}`);
            }
          });
          formData.append("blanks", JSON.stringify(blanks))
          if (newblanks.length > 0) {
            formData.append("new_blanks", JSON.stringify(newblanks))
          }

          formData.append('answer', AnswerArray.join(','));
          if (editQuestionData.deletedOption && editQuestionData.deletedOption.length > 0) {
            formData.append('delete_blanks', JSON.stringify(editQuestionData.deletedOption.map((option: string) => ({ id: option }))));
          }



        }
      } else if (editQuestionData.type === QuestionType.dragMatch) {
        if (editQuestionData.dragMatchPair) {
          let dragMatchPairArray: any[] = [];
          let newdragMatchPairArray: any[] = []
          const dragMatchsWithId = editQuestionData.dragMatchPair.filter(blank => blank.id);
          const dragMatchsWithoutId = editQuestionData.dragMatchPair.filter(blank => !blank.id);

          dragMatchsWithId.forEach((dragMatch, index) => {
            dragMatchPairArray.push({ id: dragMatch.id, item: dragMatch.item, answer: dragMatch.answer })


            if (dragMatch.media.audioPath.files instanceof File) {
              formData.append("files", dragMatch.media.audioPath.files, `audio_drag_match_${index}.${dragMatch.media.audioPath.fileExtension}`);
            }
          });

          dragMatchsWithoutId.forEach((dragMatch, index) => {
            newdragMatchPairArray.push({ item: dragMatch.item, answer: dragMatch.answer })

            if (dragMatch.media.audioPath.files instanceof File) {
              formData.append("files", dragMatch.media.audioPath.files, `audio_new_drag_match_${index}.${dragMatch.media.audioPath.fileExtension}`);
            }

          });

          const AnswerArray = editQuestionData?.dragMatchPair?.filter((dragMatch: DragMatchPairDataType) => dragMatch.item && dragMatch.item.trim() !== "" && dragMatch.answer && dragMatch.answer.trim() !== "").map((dragMatch: DragMatchPairDataType) => dragMatch.answer);

          // Remove duplicates using Set and Array.from() for compatibility
          const uniqueAnswers = Array.from(new Set(AnswerArray));

          formData.append("dragMatchPair", JSON.stringify(dragMatchPairArray))
          if (newdragMatchPairArray.length > 0) {
            formData.append("new_dragMatchPair", JSON.stringify(newdragMatchPairArray))
          }
          formData.append('answer', uniqueAnswers.join(','));
          if (editQuestionData.deletedOption) {
            formData.append('delete_dragMatchPair', JSON.stringify(editQuestionData.deletedOption.map((option: string) => ({ id: option }))));
          }

        }
      } else if (editQuestionData.type === QuestionType.match) {
        if (editQuestionData.pairs) {
          let PairArray: any[] = [];
          let newPairArray: any[] = []
          const pairsWithId = editQuestionData.pairs.filter(blank => blank.id);
          const pairsWithoutId = editQuestionData.pairs.filter(blank => !blank.id);

          pairsWithId.forEach((pair, index) => {
            PairArray.push({ id: pair.id, rightItem: pair.rightItem })
            if (pair.media.audioPath.files instanceof File) {
              formData.append("files", pair.media.audioPath.files, `audio_match_${index}.${pair.media.audioPath.fileExtension}`);
            }
            if (pair.media.imagePath.files instanceof File) {
              formData.append("files", pair.media.imagePath.files, `image_match_${index}.${pair.media.imagePath.fileExtension}`);
            }
          });

          pairsWithoutId.forEach((pair, index) => {
            newPairArray.push({ rightItem: pair.rightItem })

            if (pair.media.audioPath.files instanceof File) {
              formData.append("files", pair.media.audioPath.files, `audio_new_match_${index}.${pair.media.audioPath.fileExtension}`);
            }

            if (pair.media.imagePath.files instanceof File) {
              formData.append("files", pair.media.imagePath.files, `image_new_match_${index}.${pair.media.imagePath.fileExtension}`);
            }

          });


          const AnswerArray = editQuestionData?.dragMatchPair?.filter((dragMatch: DragMatchPairDataType) => dragMatch.item && dragMatch.item.trim() !== "" && dragMatch.answer && dragMatch.answer.trim() !== "").map((dragMatch: DragMatchPairDataType) => dragMatch.answer);

          const uniqueAnswers = Array.from(new Set(AnswerArray));
          formData.append("pairs", JSON.stringify(PairArray))
          if (newPairArray.length > 0) {
            formData.append("new_pairs", JSON.stringify(newPairArray))
          }
          formData.append('answer', uniqueAnswers.join(','));

          if (editQuestionData.deletedOption) {
            formData.append('delete_pairs', JSON.stringify(editQuestionData.deletedOption.map((option: string) => ({ id: option }))));
          }
        }
      }

      formData.append("grade_id", unitData.grade.gradeId)
      formData.append("unit_id", unitData.id)
      formData.append("difficulty_level_Id", activeDifficultyType);
      formData.append("type", editQuestionData.type)
      formData.append("question", editQuestionData.question);
      formData.append("hint", (editQuestionData.hint && editQuestionData.hint.trim() !== "") ? editQuestionData.hint : "")
      formData.append("instruction", (editQuestionData.instruction && editQuestionData.instruction.trim() !== "") ? editQuestionData.instruction : "")

      if (editQuestionData.mediaFile.audioFile.files instanceof File) {
        formData.append("audio_file_path", editQuestionData.mediaFile.audioFile.files)
      }

      if (editQuestionData.mediaFile.completeAudioFile.files) {
        if (editQuestionData.mediaFile.completeAudioFile.files instanceof File) {
          formData.append("audio_complete_file_path", editQuestionData.mediaFile.completeAudioFile.files)
        }
        formData.append("complete_audio_exist", "true")
      } else {
        formData.append("complete_audio_exist", "false")
      }

      if (editQuestionData.mediaFile.questionMediaFile.files) {
        if (editQuestionData.mediaFile.questionMediaFile.fileExtension === "json") {
          formData.append("image_exist", "false")
          formData.append("animation_exist", "true")
          formData.append("animation_file", editQuestionData.mediaFile.questionMediaFile.files)
        } else {
          formData.append("image_exist", "true")
          formData.append("animation_exist", "false")
          formData.append("question_image", editQuestionData.mediaFile.questionMediaFile.files)
        }
      } else {
        formData.append("image_exist", "false")
        formData.append("animation_exist", "false")
      }


      if (editQuestionData.deleteS3Path.length > 0) {
        formData.append("removeFiles", JSON.stringify(editQuestionData.deleteS3Path.filter((s3path: string) => s3path.trim() !== "").map((s3path: string) => ({ path: s3path.replace(`${process.env.REACT_APP_S3_BUCKET_NAME}${process.env.REACT_APP_S3_BUCKET_FOLDER}`, "") }))));
      }

      try {
        setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: true, validationLoading: false, }))
        await updateQuestion(formData, access_token).then((createQuestionResponse) => {
          const { data, statusCode } = createQuestionResponse;
          if (statusCode === 200) {

            setMessage({
              errorMessage: [],
              successMessage: "Question updated successfully!",
              failureMessage: ""
            })

          } else if (statusCode === 401) {
            getAuthorizedToken();
            setMessage({
              ...message,
              failureMessage: "Authorization token expired. Try again!"
            })
          }
        })
      } catch (error: any) {
        if (error.response && error.response.data && typeof error.response.data === "string") {
          setMessage({
            ...message,
            failureMessage: error.response.data.message
          })
        } else {
          setMessage({
            ...message,
            failureMessage: "Something went wrong!"
          })
        }

      } finally {
        setTimeout(() => {
          setMessage({
            ...message,
            successMessage: "",
            failureMessage: ""
          })
        }, 2500)
        setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
        setEditQuestionData({
          id: "",
          level: "",
          category: QuestionCategory.random,
          action: Action.none,
          difficultyType: { id: "", name: "" },
          gradeId: "",
          unitId: "",
          type: QuestionType.none,
          hint: "",
          reward: 0,
          mediaFile: {
            image: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
            questionMediaFile: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
            audioFile: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
            completeAudioFile: {
              files: "",
              blobPath: "",
              fileExtension: ""
            }
          },
          question: "",
          answer: [],
          optionWithImage: OptionWithImage.none,
          deleteS3Path: []
        })

        if (activeDifficultyType === "1" || activeDifficultyType === "2" || activeDifficultyType === "3") {
          getAllQuestion(activeDifficultyType, indexOfFirstItem)
        }

        if (activeDifficultyType === "1") {
          getAllIntro()
        }
      }

    } else {
      formData.append("level", "1");
      formData.append("category", editQuestionData.category);
      formData.append("action", editQuestionData.type === QuestionType.dragMatch ? Action.drag : Action.click);
      formData.append("grade_id", unitData.grade.gradeId);
      formData.append("unit_id", unitData.id);
      formData.append("difficulty_level_Id", activeDifficultyType);
      formData.append("type", editQuestionData.type);
      formData.append("question", editQuestionData.question);
      formData.append("reward", String(editQuestionData.reward));

      if (editQuestionData.hint && editQuestionData.hint.trim() !== "") {
        formData.append("hint", editQuestionData.hint);
      }

      if (editQuestionData.instruction && editQuestionData.instruction.trim() !== "") {
        formData.append("instruction", editQuestionData.instruction);
      }

      if (editQuestionData.mediaFile.audioFile.files instanceof File) {
        formData.append("audio_file_path", editQuestionData.mediaFile.audioFile.files);
      }


      if (editQuestionData.mediaFile.questionMediaFile.files && editQuestionData.mediaFile.questionMediaFile.files instanceof File) {
        if (editQuestionData.mediaFile.questionMediaFile.fileExtension === "json") {
          formData.append("animation_file", editQuestionData.mediaFile.questionMediaFile.files);
        } else {
          formData.append("question_image", editQuestionData.mediaFile.questionMediaFile.files);
        }
      }

      if (editQuestionData.type === QuestionType.mcq) {
        let optionArray: any[] = [];
        let AnswerArray: any[] = [];

        if (editQuestionData.options) {
          editQuestionData.options.forEach((option: OptionDataType) => {
            optionArray.push({ optionText: option.optionText });
            if (option.isAnswer) {
              AnswerArray.push(option.optionText)
            }
          })

          formData.append('options', JSON.stringify(optionArray));
          formData.append('answer', AnswerArray.join(','));

          editQuestionData.options.forEach((option: OptionDataType, optionIndex: number) => {
            option.media.imagePath.files && formData.append("files", option.media.imagePath.files, `image_option_${optionIndex}.${option.media.imagePath.fileExtension}`);
            formData.append("files", option.media.audioPath.files, `audio_option_${optionIndex}.${option.media.audioPath.fileExtension}`);
          })
        }

      } else if (editQuestionData.type === QuestionType.dragMatch) {
        if (editQuestionData.dragMatchPair) {
          editQuestionData.dragMatchPair.forEach((dragMatchPair: DragMatchPairDataType, dragMatchIndex: number) => {
            formData.append("files", dragMatchPair.media.audioPath.files, `audio_drag_match_${dragMatchIndex}.${dragMatchPair.media.audioPath.fileExtension}`);
          })

          formData.append('dragMatchPair', JSON.stringify(editQuestionData.dragMatchPair.filter((dragMatch: DragMatchPairDataType) => dragMatch.item && dragMatch.item.trim() !== "" && dragMatch.answer && dragMatch.answer.trim() !== "").map((dragMatch: DragMatchPairDataType) => ({ item: dragMatch.item, answer: dragMatch.answer }))));

          const AnswerArray = editQuestionData.dragMatchPair?.filter((dragMatch: DragMatchPairDataType) =>
            dragMatch.item && dragMatch.item.trim() !== "" &&
            dragMatch.answer && dragMatch.answer.trim() !== ""
          )
            .map((dragMatch: DragMatchPairDataType) => dragMatch.answer);

          // Remove duplicates using Set and Array.from() for compatibility
          const uniqueAnswers = Array.from(new Set(AnswerArray));

          formData.append('answer', uniqueAnswers.join(','));


        }
      } else if (editQuestionData.type === QuestionType.match) {
        if (editQuestionData.pairs) {
          let pairArray: any[] = []
          if (editQuestionData.optionWithImage === OptionWithImage.yes) {

            editQuestionData.pairs.forEach((pair: PairDataType) => {
              pairArray.push({ rightItem: pair.rightItem })
            })

            editQuestionData.pairs.forEach((pair: PairDataType, pairIndex: number) => {
              formData.append("files", pair.media.imagePath.files, `image_match_${pairIndex}.${pair.media.imagePath.fileExtension}`)
              formData.append("files", pair.media.audioPath.files, `audio_match_${pairIndex}.${pair.media.audioPath.fileExtension}`)
            })


          } else {
            editQuestionData.pairs.forEach((pair: PairDataType) => {
              pairArray.push({ leftItem: pair.leftItem, rightItem: pair.rightItem })
            })
          }

          formData.append('pairs', JSON.stringify(pairArray));
        }
      } else if (editQuestionData.type === QuestionType.fill) {
        formData.append("audio_complete_file_path", editQuestionData.mediaFile.completeAudioFile.files);

        if (editQuestionData.blanks) {
          let blanks: any[] = [];
          let AnswerArray: any[] = [];

          editQuestionData.blanks.forEach((blank: BlankDataType, blankIndex: number) => {
            blanks.push({ blankText: blank.blankText, blankPosition: blankIndex + 1 });
            if (blank.isAnswer) {
              AnswerArray.push(blank.blankText)
            }
          })


          formData.append("blanks", JSON.stringify(blanks))
          formData.append('answer', AnswerArray.join(','));

          if (editQuestionData.optionWithImage === OptionWithImage.yes) {
            editQuestionData.blanks.forEach((blank: BlankDataType, blankIndex: number) => {
              formData.append("files", blank.media.imagePath.files, `image_fill_${blankIndex}.${blank.media.imagePath.fileExtension}`)
              formData.append("files", blank.media.audioPath.files, `audio_fill_${blankIndex}.${blank.media.audioPath.fileExtension}`)
            })
          }
        }

      }

      try {
        setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: true, validationLoading: false, }))
        await createQuestion(formData, access_token).then((createQuestionResponse) => {
          const { data, statusCode } = createQuestionResponse;
          if (statusCode === 200) {
            setMessage({
              ...message,
              successMessage: "Question added successfully!",
            })
          } else if (statusCode === 401) {
            getAuthorizedToken();
            setMessage({
              ...message,
              failureMessage: "Authorization token expired. Try again!"
            })
          }
        })
      } catch (error: any) {
        if (error.response && error.response.data && typeof error.response.data === "string") {
          setMessage({
            successMessage: "",
            errorMessage: [],
            failureMessage: error.response.data.message
          })
        } else {
          setMessage({
            successMessage: "",
            errorMessage: [],
            failureMessage: "Something Went Wrong!"
          })
        }

      } finally {
        setTimeout(() => {
          setMessage({
            errorMessage: [],
            successMessage: "",
            failureMessage: ""
          })
        }, 2500)
        setLoading(prev => ({ ...prev, fetchingLoading: false, tableLoading: false, deleteLoading: false, submitLoading: false, validationLoading: false, }))
        setShowAddQuestion(false)
        setEditQuestionData({
          id: "",
          level: "",
          category: QuestionCategory.random,
          action: Action.none,
          difficultyType: { id: "", name: "" },
          gradeId: "",
          unitId: "",
          type: QuestionType.none,
          hint: "",
          reward: 0,
          mediaFile: {
            image: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
            questionMediaFile: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
            audioFile: {
              files: "",
              blobPath: "",
              fileExtension: ""
            },
            completeAudioFile: {
              files: "",
              blobPath: "",
              fileExtension: ""
            }
          },
          question: "",
          answer: [],
          optionWithImage: OptionWithImage.none,
          deleteS3Path: []
        })
        getAllQuestion(activeDifficultyType, indexOfFirstItem)
      }
    }
  }

  return (
    <div className="dashboard d-flex">
      <Header />
      <div className="rightContainer">
        {message.successMessage && <SuccessPopup message={message.successMessage} />}
        {message.failureMessage && <FailurePopup message={message.failureMessage} />}


        <div className="pCard unitCreat bg-transparent">
          <h2 className="main-title text-center page-title">New section</h2>
          {unitData.unitName && <div className="breadcrumbBlock mb-5">
            <ul>
              <li>
                <a href='/unit'>Unit</a> <img src="./../assets/images/breadcrumb-arrow.svg" alt="" />
              </li>
              <li>
                {unitData.unitName} <img src="./../assets/images/breadcrumb-arrow.svg" alt="" />
              </li>
              <li>
                New Section
              </li>
            </ul>
          </div>}

          <div className="btnBlock3">
            <button className={`${activeDifficultyType === "1" ? "active" : ""}`} onClick={() => setActiveDifficultyType("1")}>
              Warm Up
            </button>
            <button className={`${activeDifficultyType === "2" ? "active" : ""}`} onClick={() => setActiveDifficultyType("2")}>
              Practice
            </button>
            <button className={`${activeDifficultyType === "3" ? "active" : ""}`} onClick={() => setActiveDifficultyType("3")}>
              Master
            </button>
          </div>

          {unitData.unitStatus !== "0" && <div className="p-3">
            <button className="btn add-btn btnPurple w-auto px-3" style={{ fontSize: "14px" }} onClick={handlePreview}>Preview</button>
          </div>}

          {activeDifficultyType === "1" && <div className="accordionBox">
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                  <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    Introduction
                  </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <div className="position-relative mb-5">
                      <div className="position-absolute top-0 end-0 d-flex gap-2">
                        {editIntroData.carrousel.length + editIntroData.newCarrousel.length > 1 && (
                          <React.Fragment>
                            <button className={`btn d-flex align-items-center gap-2 px-3 py-1 text-white`} style={{
                              backgroundColor: selected.carrousel ? "#782ACB" : "#737992",
                              borderRadius: "0.5rem",
                              border: selected.carrousel ? "none" : "1px solid #ccc",
                            }} onClick={() => selectedContainer("carrousel")} >
                              <img src="./../assets/images/checkbox.svg" alt="Checkbox" style={{ width: "24px", height: "24px" }} />
                              Select
                            </button>

                            <button className="btn d-flex align-items-center gap-2 px-3 py-1 text-white" style={{
                              backgroundColor: "#737992",
                              borderRadius: "0.5rem",
                              border: "1px solid #ccc",
                            }} disabled={selected.carrousel ? false : true} onClick={() => handleDeleteWarmupIntro("Carrousel")} >
                              <img src="./../assets/images/trash.svg" alt="Trash" style={{ width: "24px", height: "24px" }} />
                              Delete
                            </button>

                          </React.Fragment>
                        )}
                        <button className="btn d-flex align-items-center gap-2 px-3 py-1 text-white" style={{
                          backgroundColor: selected.carrousel ? "#737992" : "#782ACB",
                          borderRadius: "0.5rem",
                          border: "1px solid #ccc",

                        }} disabled={selected.carrousel ? true : false} onClick={() => handleAddCarrousel("carrousel")} >
                          <img src="./../assets/images/plus.svg" alt="Plus" style={{ width: "24px", height: "24px" }} />
                          Add More
                        </button>
                      </div>
                    </div>
                    <h6 className='highlightMediaText'>Carrousel</h6>
                    <div className="inputBlocks mb-4">
                      {[...editIntroData.carrousel, ...editIntroData.newCarrousel].reduce((acc: JSX.Element[], carousel: CarrouselDataType, index: number) => {
                        if (index % 3 === 0) {
                          acc.push(<div className="row align- justify-content-between" key={`row-${index}`}><React.Fragment></React.Fragment></div>);
                        }

                        const currentRow = acc[acc.length - 1];

                        const col = (
                          <div className="col pt-1 m-1" key={index}
                            style={{ outline: carousel.selected ? "2px #782ACB solid" : "", borderRadius: "6px", margin: "10px 0px" }}>
                            <label className='w-100' htmlFor={`selected-carousel-${index}`}>
                              {selected.carrousel && (
                                <div className="form-check mb-2 d-flex justify-content-end">
                                  <input className="form-check-input absolute select-carrousel" type="checkbox" id={`selected-carousel-${index}`} checked={carousel.selected || false} style={{ transform: "scale(1.5)" }} onChange={(e) => handleIntroSelect(editIntroData.carrousel.includes(carousel) ? "Carrousel" : "NewCarrousel", index, e.target.checked)} />
                                </div>
                              )}

                              {/* Image Upload/Preview */}
                              <div className="customImgUpload whitebg">
                                <div className="uploadBtn">
                                  {carousel.carrouselMedia.image.files ? (
                                    <div className="w-100">
                                      <div className="imgName" onClick={() => handleOpenAnimation(carousel.carrouselMedia.image.files)}>
                                        {carousel.carrouselMedia.image.files instanceof File ? carousel.carrouselMedia.image.files.name : `carrousel${index + 1}.json`
                                        }
                                      </div>

                                    </div>
                                  ) : (
                                    <React.Fragment>
                                      <img className="noimage" src="./../assets/images/no-image-icon.png" alt="No content available" />
                                      <label htmlFor={`carousel-${index}`}>
                                        Click to upload <span>.json <br />(max 20mb)</span>
                                      </label>
                                      <input type="file" className="form-control d-none" id={`carousel-${index}`} name={`carousel-${index}`} accept=".json" onChange={(e) => handleWarmupMedia(e, editIntroData.carrousel.includes(carousel) ? "Carrousel" : "NewCarrousel", index, false)} required />
                                      
                                    </React.Fragment>
                                  )}
                                </div>
                              </div>
                            </label>
                            <div className='mb-1' style={{ height: "40px" }}>
                              {carousel.carrouselMedia.image.files && !selected.carrousel && (
                                <div className="row justify-content-center mt-2">
                                  <div className="col-auto">
                                    <button type="button" className="btn btnBorder mb-3 justify-content-start p-0 my-auto" style={{ width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992", fontSize: "14px", fontWeight: "400" }}>
                                      <label className='m-0 flex' htmlFor={`carousel-${index}`} style={{ padding: "6px 12px", cursor: 'pointer' }}>
                                        <img src="./../assets/images/replace.svg" alt="Replace" style={{ marginRight: "10px" }} />
                                        <input type="file" className="form-control d-none" id={`carousel-${index}`} name={`carousel-${index}`} accept=".json" onChange={(e) => handleWarmupMedia(e, editIntroData.carrousel.includes(carousel) ? "Carrousel" : "NewCarrousel", index, false)} />
                                        Replace
                                      </label>
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                            {/* Text Editor */}
                            <ReactQuill className='whitebg' id={`carouselText-${index}`} value={carousel.carrouselIntroText}
                              onChange={(value) => handleWarmupInput(editIntroData.carrousel.includes(carousel) ? "Carrousel" : "NewCarrousel", value, index, false)} style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "1px solid #ddd" }} modules={{
                                toolbar: [
                                  [{ header: [3, 4, false] }],
                                  ["bold", "italic", "underline", "blockquote"],
                                  [
                                    { list: "ordered" },
                                    { list: "bullet" },
                                    { indent: "-1" },
                                    { indent: "+1" }
                                  ],
                                  [{ align: [] }]
                                ]
                              }}
                            />

                            {/* Audio Upload/Preview */}
                            <div className="customImgUpload whitebg mb-3">
                              <div className="uploadBtn">
                                {carousel.carrouselMedia.audio.files ? (
                                  <div className="w-100">
                                    <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                      <audio src={carousel.carrouselMedia.audio.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />
                                    </div>
                                    {carousel.carrouselMedia.audio.files instanceof File && (
                                      <div className="imgName">{carousel.carrouselMedia.audio.files.name}</div>
                                    )}
                                  </div>
                                ) : (
                                  <React.Fragment>
                                    <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                    <label htmlFor={`voice-over-audio-${index}`}>
                                      Click to upload <span>mp3 or wav <br />(max 250mb)</span>
                                    </label>
                                    <input type="file" className="form-control d-none" id={`voice-over-audio-${index}`} name={`voice-over-audio-${index}`} accept=".mp3, .wav" onChange={(e) => handleWarmupMedia(e, editIntroData.carrousel.includes(carousel) ? "Carrousel" : "NewCarrousel", index, true)} required />
                                    
                                  </React.Fragment>
                                )}
                              </div>
                            </div>

                            {/* Replace Audio */}
                            {carousel.carrouselMedia.audio.files && !selected.carrousel && (
                              <div className="row justify-content-center mt-2">
                                <div className="col-auto">
                                  <button type="button" className="btn btnBorder mb-3 justify-content-start p-0 my-auto" style={{ width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992", fontSize: "14px", fontWeight: "400" }}>
                                    <label className='m-0 flex' htmlFor={`voice-over-audio-${index}`} style={{ padding: "6px 12px", cursor: 'pointer' }}>
                                      <img src="./../assets/images/replace.svg" alt="Replace" style={{ marginRight: "10px" }} />
                                      <input type="file" className="form-control d-none" id={`voice-over-audio-${index}`} name={`voice-over-audio-${index}`} accept=".mp3, .wav" onChange={(e) => handleWarmupMedia(e, editIntroData.carrousel.includes(carousel) ? "Carrousel" : "NewCarrousel", index, true)} required />
                                      Replace
                                    </label>
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        );

                        acc[acc.length - 1] = React.cloneElement(currentRow, {
                          children: React.Children.toArray(currentRow.props.children).concat(col),
                        });

                        return acc;
                      }, [])}



                    </div>

                    <h6 className='highlightMediaText'>Introduction Section</h6>
                    <div className="row">
                      <div className="col-md-5">
                        <div className="customImgUpload whitebg mb-3">
                          <div className="uploadBtn">
                            {editIntroData.introduction.introductionSectionMedia.files ?
                              <div className="w-100">
                                <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                  <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                      <img src={editIntroData.introduction.introductionSectionMedia.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(editIntroData.introduction.introductionSectionMedia.files)} />
                                  </div>
                                </div>
                              </div>
                              :
                              <React.Fragment>
                                <img className="noimage" src="./../assets/images/no-image-icon.png" alt="No content available" />
                                <label htmlFor={`introduction`}>
                                  Click to upload <span>png, jpg, or jpeg <br />(max 20mb)</span>
                                </label>
                                <input type="file" className="form-control d-none" id={`introduction`} name={`desktop`} accept=".png, .jpg, .jpeg" onChange={(e) => handleWarmupMedia(e, "Introduction", -1, false)} required />
                                
                              </React.Fragment>
                            }

                          </div>
                        </div>
                        {editIntroData.introduction.introductionSectionMedia.files && <div className="row justify-content-center mt-2">

                          <div className="col-auto">
                            <button type="button" className="btn btnBorder mb-3 justify-content-start p-0 my-auto" style={{ width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992", fontSize: "14px", fontWeight: "400" }}>

                              <label className='m-0 flex' htmlFor="introduction" style={{ padding: "6px 12px", cursor: 'pointer' }} >
                                <img src="./../assets/images/replace.svg" alt="Replace" style={{ marginRight: "10px" }} /><input type="file" className="form-control d-none" id="introduction" name="introduction" accept=".png, .jpg, .jpeg" onChange={(e) => handleWarmupMedia(e, "Introduction", -1, false)} />Replace
                              </label>
                            </button>
                          </div>
                        </div>}
                      </div>

                      <div className="col-md-7">
                        <ReactQuill value={editIntroData.introduction.introductionSectionIntroText} onChange={(value) => handleWarmupInput("Introduction", value, -1, false)} style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} modules={{
                          toolbar: [
                            [{ header: [3, 4, false] }],
                            ["bold", "italic", "underline", "blockquote"],
                            [
                              { list: "ordered" },
                              { list: "bullet" },
                              { indent: "-1" },
                              { indent: "+1" },
                            ],
                            [{ align: [] }],
                          ],
                        }} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    Learning Path
                  </button>
                </h2>

                {/* </div> */}
                <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <div className="position-relative mb-5">
                      {editIntroData.learningPath.length + editIntroData.newLearningPath.length > 0 && <div className="position-absolute top-0 end-0 d-flex gap-2">
                        <button className={`btn d-flex align-items-center gap-2 px-3 py-1 text-white`}
                          style={{
                            backgroundColor: selected.learningPath ? "#782ACB" : "#737992",
                            borderRadius: "0.5rem",
                            border: selected.learningPath ? "none" : "1px solid #ccc",
                          }} onClick={() => selectedContainer("learningPath")} >
                          <img src="./../assets/images/checkbox.svg" alt="Checkbox" style={{ width: "24px", height: "24px" }} />
                          Select
                        </button>

                        <button className="btn d-flex align-items-center gap-2 px-3 py-1 text-white" style={{
                          backgroundColor: "#737992",
                          borderRadius: "0.5rem",
                          border: "1px solid #ccc",
                        }} disabled={selected.learningPath ? false : true} onClick={() => handleDeleteWarmupIntro("LearningPath")}
                        >
                          <img src="./../assets/images/trash.svg" alt="trash" style={{ width: "24px", height: "24px" }} />
                          Delete
                        </button>
                      </div>}
                    </div>

                    {editIntroData.learningPath.map((learningPath: LearningPathDataType, index: number) => (
                      <div className="form-group" key={index}>
                        <label htmlFor={`selected-learning-path-${index}`} className="w-100">
                          <div style={{ outline: learningPath.selected ? "2px #782ACB solid" : "", borderRadius: "6px" }}>
                            <div className="row pt-2 m-2 pb-2">
                              <div className="col-md-4">
                                <h6 className='highlightMediaText'>{`Gesture ${index + 1}`}</h6>

                                <div className="form-group">
                                  <select className="selectWhite form-select" name={`gesture-${index}`} value={learningPath.gesture} onChange={(e) => handleWarmupInput("LearningPath", e.target.value, index, true)}>
                                    <option value={Gesture.Empty} disabled>Select</option>
                                    {/* <option value={Gesture.None}>Drag None</option> */}
                                    <option value={Gesture.Left}>Drag Left</option>
                                    <option value={Gesture.Right}>Drag Right</option>
                                    <option value={Gesture.Up}>Drag Up</option>
                                    <option value={Gesture.Down}>Drag Down</option>
                                    <option value={Gesture.Tap}>Tap</option>
                                    <option value={Gesture.DragLeftAndRight}>Drag Left and Right</option>
                                    <option value={Gesture.DragUpAndDown}>Drag Up and Down</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <h6 className='highlightMediaText'>Media File <span className="text-danger">*</span></h6>
                                <div className="customImgUpload whitebg mb-3">
                                  <div className="uploadBtn">
                                    {learningPath.learningPathMedia.gestureAnimation.files ?
                                      <div className="w-100">
                                      <div className="imgName" onClick={() => handleOpenAnimation(learningPath.learningPathMedia.gestureAnimation.files)}>
                                          {learningPath.learningPathMedia.gestureAnimation.files instanceof File
                                              ? learningPath.learningPathMedia.gestureAnimation.files.name
                                              : `LearningPath${index + 1}.json`
                                          }
                                      </div>

                                    </div>
                                      :
                                      <React.Fragment>
                                        <img className="noimage" src="./../assets/images/no-image-icon.png" alt="No content available" />
                                        <label htmlFor={`learning-path-${index}`}>
                                          Click to upload <span>.json <br />(max 20mb)</span>
                                        </label>
                                        <input type="file" className="form-control d-none" id={`learning-path-${index}`} name={`learning-path-${index}`} accept=".json" onChange={(e) => handleWarmupMedia(e, "LearningPath", index, false)} required />
                                        
                                      </React.Fragment>
                                    }
                                  </div>
                                </div>

                                {learningPath.learningPathMedia.gestureAnimation.files && !selected.learningPath && <div className="row justify-content-center mt-2">
                                  <div className="col-auto">
                                    <button type="button" className="btn btnBorder mb-3 justify-content-start" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992", fontSize: "14px", fontWeight: "400" }}>

                                      <label className='m-0' htmlFor={`learning-path-${index}`} style={{ cursor: 'pointer' }} >
                                        <img src="./../assets/images/replace.svg" alt="Replace" style={{ marginRight: "12px" }} /><input type="file" className="form-control d-none" id={`learning-path-${index}`} name={`learning-path-${index}`} accept=".json" onChange={(e) => handleWarmupMedia(e, "LearningPath", index, false)} required />Replace
                                      </label>
                                    </button>
                                  </div>
                                </div>}
                              </div>



                              <div className="col-md-4">
                                <div className="d-flex justify-content-between">
                                  <h6 className='highlightMediaText'>Voice over File <span className="text-danger">*</span></h6>
                                  {selected.learningPath && <div className="form-check mb-2 d-flex justify-content-end">
                                    <input className="form-check-input absolute select-carrousel" type="checkbox" id={`selected-learning-path-${index}`} checked={learningPath.selected || false} style={{ transform: "scale(1.5)" }} onChange={(e) => handleIntroSelect("LearningPath", index, e.target.checked)} />
                                  </div>}

                                </div>

                                {/* Audio Upload/Preview */}
                                <div className="customImgUpload whitebg mb-3">
                                  <div className="uploadBtn">
                                    {learningPath.learningPathMedia.gestureAudio.files ? (
                                      <div className="w-100">
                                        <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                          <audio src={learningPath.learningPathMedia.gestureAudio.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />
                                        </div>
                                        {learningPath.learningPathMedia.gestureAudio.files instanceof File && (
                                          <div className="imgName">{learningPath.learningPathMedia.gestureAudio.files.name}</div>
                                        )}
                                      </div>
                                    ) : (
                                      <React.Fragment>
                                        <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                        <label htmlFor={`learning-path-voice-over-audio-${index}`}>
                                          Click to upload <span>mp3 or wav <br />(max 20mb)</span>
                                        </label>
                                        <input type="file" className="form-control d-none" id={`learning-path-voice-over-audio-${index}`} name={`learning-path-voice-over-audio-${index}`} accept=".mp3, .wav" onChange={(e) => handleWarmupMedia(e, "LearningPath", index, false)} required />
                                        
                                      </React.Fragment>
                                    )}
                                  </div>
                                </div>

                                {/* Replace Audio */}
                                {learningPath.learningPathMedia.gestureAudio.files && !selected.carrousel && (
                                  <div className="row justify-content-center mt-2">
                                    <div className="col-auto">
                                      <button type="button" className="btn btnBorder mb-3 justify-content-start p-0 my-auto" style={{ width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992", fontSize: "14px", fontWeight: "400" }}>
                                        <label className='m-0 flex' htmlFor={`learning-path-voice-over-audio-${index}`} style={{ padding: "6px 12px", cursor: 'pointer' }}>
                                          <img src="./../assets/images/replace.svg" alt="Replace" style={{ marginRight: "10px" }} />
                                          <input type="file" className="form-control d-none" id={`learning-path-voice-over-audio-${index}`} name={`learning-path-voice-over-audio-${index}`} accept=".mp3, .wav" onChange={(e) => handleWarmupMedia(e, "LearningPath", index, false)} required />
                                          Replace
                                        </label>
                                      </button>
                                    </div>
                                  </div>
                                )}

                              </div>


                            </div>
                            <div className='row m-2 pb-2'>
                              <div className='col-6'>
                                <h6 className='highlightMediaText'>Gesture {index + 1} instruction <span className="text-danger">*</span></h6>
                                <ReactQuill value={learningPath.description} onChange={(value) => handleWarmupInput("LearningPath", value, index, false)} style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }}
                                  modules={{
                                    toolbar: [
                                      [{ header: [3, 4, false] }],
                                      ["bold", "italic", "underline", "blockquote"],
                                      [
                                        { list: "ordered" },
                                        { list: "bullet" },
                                        { indent: "-1" },
                                        { indent: "+1" },
                                      ],
                                      [{ align: [] }],
                                    ],
                                  }}
                                />
                              </div>
                              <div className="col-md-6 my-auto">
                                <div className="form-group">
                                  <h6 className='questionText'>Reward <span className="text-danger">*</span></h6>
                                  <input type='number' name="reward" className="form-control questionInput" placeholder="Reward" value={learningPath.reward} onChange={(e) => handleWarmupInput("LearningPath", e.target.value, index, true, e.target.name)} onWheel={(e: any) => e.target.blur()} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </label>

                      </div>
                    ))}

                    {editIntroData.newLearningPath.map((newLearningPath: LearningPathDataType, index: number) => (
                      <div className="form-group" key={index}>
                        <label htmlFor={`selected-learning-path-${index}`} className="w-100">
                          <div style={{ outline: newLearningPath.selected ? "2px #782ACB solid" : "", borderRadius: "6px" }}>
                            <div className="row pt-2 m-2 pb-2">
                              <div className="col-md-4">
                                <h6 className='highlightMediaText'>{`Gesture ${editIntroData.learningPath.length + index + 1}`} <span className="text-danger">*</span></h6>

                                <div className="form-group">
                                  <select className="selectWhite form-select" name={`gesture-${index}`} value={newLearningPath.gesture} onChange={(e) => handleWarmupInput("NewLearningPath", e.target.value, index, true)}>
                                    <option value={Gesture.Empty} disabled>Select</option>
                                    {/* <option value={Gesture.None}>Drag None</option> */}
                                    <option value={Gesture.Left}>Drag Left</option>
                                    <option value={Gesture.Right}>Drag Right</option>
                                    <option value={Gesture.Up}>Drag Up</option>
                                    <option value={Gesture.Down}>Drag Down</option>
                                    <option value={Gesture.Tap}>Tap</option>
                                    <option value={Gesture.DragLeftAndRight}>Drag Left and Right</option>
                                    <option value={Gesture.DragUpAndDown}>Drag Up and Down</option>
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <h6 className='highlightMediaText'>Media File <span className="text-danger">*</span></h6>
                                <div className="customImgUpload whitebg mb-3">
                                  <div className="uploadBtn">
                                    {newLearningPath.learningPathMedia.gestureAnimation.files ?
                                      <div className="w-100">
                                      <div className="imgName">
                                        {newLearningPath.learningPathMedia.gestureAnimation.files instanceof File ? newLearningPath.learningPathMedia.gestureAnimation.files.name : newLearningPath.learningPathMedia.gestureAnimation.files.match(/intro_image_animation_\d+\.json/)
                                        }
                                      </div>

                                    </div>
                                      :
                                      <React.Fragment>
                                        <img className="noimage" src="./../assets/images/no-image-icon.png" alt="No content available" />
                                        <label htmlFor={`new-learning-path-${index}`}>
                                          Click to upload <span>.json <br />(max 20mb)</span>
                                        </label>
                                        <input type="file" className="form-control d-none" id={`new-learning-path-${index}`} name={`new-learning-path-${index}`} accept=".json" onChange={(e) => handleWarmupMedia(e, "NewLearningPath", index, false)} required />
                                        
                                      </React.Fragment>
                                    }
                                  </div>
                                </div>

                                {newLearningPath.learningPathMedia.gestureAnimation.files && !selected.learningPath && <div className="row justify-content-center mt-2">
                                  <div className="col-auto">
                                    <button type="button" className="btn btnBorder mb-3 justify-content-start" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992", fontSize: "14px", fontWeight: "400" }}>

                                      <label className='m-0' htmlFor={`new-learning-path-${index}`} style={{ cursor: 'pointer' }} >
                                        <img src="./../assets/images/replace.svg" alt="Replace" style={{ marginRight: "12px" }} /><input type="file" className="form-control d-none" id={`new-learning-path-${index}`} name={`new-learning-path-${index}`} accept=".json" onChange={(e) => handleWarmupMedia(e, "NewLearningPath", index, false)} required />Replace
                                      </label>
                                    </button>
                                  </div>
                                </div>}
                              </div>



                              <div className="col-md-4">
                                <div className="d-flex justify-content-between">
                                  <h6 className='highlightMediaText'>Voice over File <span className="text-danger">*</span></h6>
                                  {selected.learningPath && <div className="form-check mb-2 d-flex justify-content-end">
                                    <input className="form-check-input absolute select-carrousel" type="checkbox" id={`selected-learning-path-${index}`} checked={newLearningPath.selected || false} style={{ transform: "scale(1.5)" }} onChange={(e) => handleIntroSelect("LearningPath", index, e.target.checked)} />
                                  </div>}

                                </div>

                                <div className="customImgUpload whitebg mb-3">
                                  <div className="uploadBtn">
                                    {newLearningPath.learningPathMedia.gestureAudio.files ? (
                                      <div className="w-100">
                                        <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                          <audio src={newLearningPath.learningPathMedia.gestureAudio.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />
                                        </div>
                                        {newLearningPath.learningPathMedia.gestureAudio.files instanceof File  && (
                                          <div className="imgName">{newLearningPath.learningPathMedia.gestureAudio.files.name}</div>
                                        )}
                                      </div>
                                    ) : (
                                      <React.Fragment>
                                        <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                        <label htmlFor={`new-learning-path-voice-over-audio-${index}`}>
                                          Click to upload <span>mp3 or wav <br />(max 20mb)</span>
                                        </label>
                                        <input type="file" className="form-control d-none" id={`new-learning-path-voice-over-audio-${index}`} name={`new-learning-path-voice-over-audio-${index}`} accept=".mp3, .wav" onChange={(e) => handleWarmupMedia(e, "NewLearningPath", index, false)} required />
                                        
                                      </React.Fragment>
                                    )}
                                  </div>
                                </div>

                                {/* Replace Audio */}
                                {newLearningPath.learningPathMedia.gestureAudio.files && !selected.carrousel && (
                                  <div className="row justify-content-center mt-2">
                                    <div className="col-auto">
                                      <button type="button" className="btn btnBorder mb-3 justify-content-start p-0 my-auto" style={{ width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992", fontSize: "14px", fontWeight: "400" }}>
                                        <label className='m-0 flex' htmlFor={`new-learning-path-voice-over-audio-${index}`} style={{ padding: "6px 12px", cursor: 'pointer' }}>
                                          <img src="./../assets/images/replace.svg" alt="Replace" style={{ marginRight: "10px" }} />
                                          <input type="file" className="form-control d-none" id={`new-learning-path-voice-over-audio-${index}`} name={`new-learning-path-voice-over-audio-${index}`} accept=".mp3, .wav" onChange={(e) => handleWarmupMedia(e, "NewLearningPath", index, false)} required />
                                          Replace
                                        </label>
                                      </button>
                                    </div>
                                  </div>
                                )}

                              </div>


                            </div>
                            <div className='row m-2 pb-2'>
                              <div className='col-6'>
                                <h6 className='highlightMediaText'>{`Gesture ${editIntroData.learningPath.length + index + 1} Instruction`} <span className="text-danger">*</span></h6>


                                <ReactQuill value={newLearningPath.description} onChange={(value) => handleWarmupInput("NewLearningPath", value, index, false)} style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }}
                                  modules={{
                                    toolbar: [
                                      [{ header: [3, 4, false] }],
                                      ["bold", "italic", "underline", "blockquote"],
                                      [
                                        { list: "ordered" },
                                        { list: "bullet" },
                                        { indent: "-1" },
                                        { indent: "+1" },
                                      ],
                                      [{ align: [] }],
                                    ],
                                  }}
                                />
                              </div>

                              <div className="col-md-6 my-auto">
                                <div className="form-group">
                                  <h6 className='questionText'>Reward <span className="text-danger">*</span></h6>
                                  <input type='number' name="reward" className="form-control questionInput" placeholder="Reward" value={newLearningPath.reward} onChange={(e) => handleWarmupInput("NewLearningPath", e.target.value, index, true, e.target.name)} onWheel={(e: any) => e.target.blur()} />
                                </div>
                              </div>
                            </div>
                          </div>
                        </label>

                      </div>
                    ))}



                    <div className="form-group mt-3">
                      <div className="position-relative">
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="m-0">Add Gestures</p>
                          <button className="btn" type="button" id="button-addon2" disabled={selected.learningPath ? true : false} onClick={() => handleAddCarrousel("gesture")} style={{ border: "none" }}><img src="./../assets/images/add-icon.svg" alt="plus" /></button>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-end mt-3 mb-3">
                      <button type="button" className="btn btn-save btnPurple" style={{ width: '250px' }} onClick={validateIntroData}>Save</button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingThree">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    Multiple Choice Questions
                  </button>
                </h2>
                <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                  <div className="accordion-body">

                    {loading.tableLoading ?
                      <div className="d-flex align-items-center mt-5">
                        <div className="loader mx-auto"></div>
                      </div>
                      :
                      <React.Fragment>
                        {(activeDifficultyType === "1") &&
                          <React.Fragment>
                            <div className="form-group">
                              <div className="position-relative">
                                {!showAddQuestion && !editQuestionData.id && <div className="d-flex justify-content-between align-items-center">
                                  <p className="m-0" style={{ fontFamily: "Nunito", fontWeight: "700", fontSize: "18px", letterSpacing: "2%", lineHeight: "100%" }}>Add Question</p>
                                  <button className="btn" type="button" id="button-addon2" onClick={() => setShowAddQuestion(true)}><img src="./../assets/images/add-icon.svg" alt="Add" /></button>
                                </div>}
                              </div>
                              {showAddQuestion &&
                                <div>
                                  <div className="accordion quesDropBlock bg-transparent" id="accordionQuest">
                                    <div className="accordion-item">
                                      <h2 className="accordion-header">
                                        <button className="accordion-button titlebtn border-0 bg-transparent" type="button" data-bs-toggle="collapse" data-bs-target="#collapseQuesOne" aria-expanded="true" aria-controls="collapseQuesOne">
                                          {`Question ${allQuestionData.length + 1}`}
                                        </button>
                                      </h2>
                                      <div id="collapseQuesOne" className="accordion-collapse collapse show" data-bs-parent="#accordionQuest">
                                        <div className="accordion-body">
                                          <div className="row">
                                            <div className="col-md-6 my-auto">
                                              <h6 className='questionText'>Type <span className="text-danger">*</span></h6>
                                              <div className="form-group">
                                                <select className="form-select questionInput" name="type" value={editQuestionData.type ?? ""} onChange={(e) => handleInput(e.target.name, e.target.value)}>
                                                  <option value="" disabled>
                                                    Select Question Type
                                                  </option>
                                                  <option value={QuestionType.mcq}>MCQ</option>
                                                </select>
                                              </div>
                                            </div>

                                            {(editQuestionData.type === QuestionType.mcq) ?
                                              <div className='col-md-6 form-group'>
                                                <h6 className='questionText'>Option with Image <span className="text-danger">*</span></h6>
                                                <select className="form-select questionInput" name="optionWithImage" value={editQuestionData.optionWithImage ?? ""} onChange={(e) => handleInput(e.target.name, e.target.value)} required >
                                                  <option value="" disabled>
                                                    Select
                                                  </option>
                                                  <option value={OptionWithImage.yes}>Yes</option>
                                                  <option value={OptionWithImage.no}>No</option>
                                                </select>
                                                

                                              </div>
                                              :
                                              <div className="col-md-6 form-group">
                                                <h6 className='questionText'>Voice Over Audio <span className="text-danger">*</span></h6>
                                                <div className="customImgUpload mb-3">
                                                  <div className="uploadBtn">
                                                    {editQuestionData.mediaFile.audioFile.files ? (
                                                      <div className="w-100">
                                                        <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                          <audio src={editQuestionData.mediaFile.audioFile.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />
                                                          {/* <button type="button" className="bg-transparent" onClick={() => handleOptionDelete(editQuestionData.type, editQuestionData.mediaFile.audioFile.files, -1, "voice-over-audio")} >
                                                  <img src="./../assets/images/delete.svg" alt="Delete" width="24" />
                                                </button> */}

                                                        </div>
                                                        {editQuestionData.mediaFile.audioFile.files instanceof File  &&
                                                          <div className="imgName">
                                                            {editQuestionData.mediaFile.audioFile.files.name}
                                                          </div>
                                                        }
                                                      </div>
                                                    ) : (
                                                      <React.Fragment>
                                                        <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                        <label htmlFor="voice-over-audio">
                                                          Click to upload <span>mp3 or wav <br />(max 20mb)</span>
                                                        </label>
                                                        <input type="file" className="form-control d-none" id="voice-over-audio" name="voice-over-audio" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, -1, "audio")} required />
                                                        
                                                      </React.Fragment>
                                                    )}
                                                  </div>
                                                </div>
                                                


                                                {editQuestionData.mediaFile.audioFile.files && <div className="row justify-content-center mt-2">
                                                  <div className="col-auto">
                                                    <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, editQuestionData.mediaFile.audioFile.files, -1, "voice-over-audio", "audio")} >
                                                      <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                    </button>
                                                  </div>
                                                </div>}

                                              </div>
                                            }
                                          </div>

                                          <div className="row">
                                            {editQuestionData.optionWithImage === OptionWithImage.no && editQuestionData.type !== QuestionType.match && editQuestionData.type !== QuestionType.dragMatch &&
                                              <div className="col-md-6 form-group">
                                                <h6 className='questionText'>Media</h6>
                                                <div className="customImgUpload mb-3" >
                                                  <div className="uploadBtn">
                                                    {editQuestionData.mediaFile.questionMediaFile.files ?
                                                      <div className='w-100'>
                                                        <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                          <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                            {editQuestionData.mediaFile.questionMediaFile.fileExtension === "json" ?
                                                              <div className="w-100">
                                                                <div className="imgName" onClick={() => handleOpenAnimation(editQuestionData.mediaFile.questionMediaFile.files)}>
                                                                  {editQuestionData.mediaFile.questionMediaFile.files instanceof File ? editQuestionData.mediaFile.questionMediaFile.files.name : "questionMedia.json"
                                                                  }
                                                                </div>

                                                              </div>
                                                              
                                                              :
                                                              <React.Fragment>
                                                                <img src={editQuestionData.mediaFile.questionMediaFile.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} />
                                                                {editQuestionData.mediaFile.questionMediaFile.files instanceof File &&
                                                                  <div className="imgName">
                                                                    {editQuestionData.mediaFile.questionMediaFile.files.name}
                                                                  </div>
                                                                }
                                                              </React.Fragment>
                                                            }

                                                          </div>
                                                
                                                        </div>



                                                      </div>
                                                      :
                                                      <React.Fragment>
                                                        <img className="noimage" src={"./../assets/images/no-image-icon.png"} alt="" />
                                                        <label htmlFor={`question-media`}>Click to upload <span>png, jpg, jpeg, or json <br />(max 20mb)</span></label>
                                                        <input type="file" className={`form-control d-none`} name={`question-media`} id={`question-media`} onChange={(e) => handleOptionMedia(editQuestionData.type, e, -1, "audio")} accept=".json, .png, .jpg, .jpeg" />

                                                      </React.Fragment>
                                                    }
                                                  </div>
                                                </div>
                                                {editQuestionData.mediaFile.questionMediaFile.files && <div className="row justify-content-center mt-2">
                                                  <div className="col-auto">
                                                    <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, editQuestionData.mediaFile.questionMediaFile.files, -1, "question-media", "image")}>
                                                      <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                    </button>
                                                  </div>
                                                </div>}
                                              </div>
                                            }

                                            {editQuestionData.type === QuestionType.mcq && <div className="col-md-6 form-group">
                                              <h6 className='questionText'>Voice Over Audio <span className="text-danger">*</span></h6>
                                              <div className="customImgUpload mb-3">
                                                <div className="uploadBtn">
                                                  {editQuestionData.mediaFile.audioFile.files ? (
                                                    <div className="w-100">
                                                      <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                        <audio src={editQuestionData.mediaFile.audioFile.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />
                                                        {/* <button type="button" className="bg-transparent" onClick={() => handleOptionDelete(editQuestionData.type, editQuestionData.mediaFile.audioFile.files, -1, "voice-over-audio")} >
                                                <img src="./../assets/images/delete.svg" alt="Delete" width="24" />
                                              </button> */}

                                                      </div>
                                                      {editQuestionData.mediaFile.audioFile.files instanceof File &&
                                                        <div className="imgName">
                                                          {editQuestionData.mediaFile.audioFile.files.name}
                                                        </div>
                                                      }
                                                    </div>
                                                  ) : (
                                                    <React.Fragment>
                                                      <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                      <label htmlFor="voice-over-audio">
                                                        Click to upload <span>mp3 or wav <br />(max 20mb)</span>
                                                      </label>
                                                      <input type="file" className="form-control d-none" id="voice-over-audio" name="voice-over-audio" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, -1, "audio")} required />
                                                      
                                                    </React.Fragment>
                                                  )}
                                                </div>
                                              </div>

                                              {editQuestionData.mediaFile.audioFile.files && <div className="row justify-content-center mt-2">
                                                <div className="col-auto">
                                                  <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, editQuestionData.mediaFile.audioFile.files, -1, "voice-over-audio", "audio")} >
                                                    <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                  </button>
                                                </div>
                                              </div>}
                                            </div>}
                                          </div>

                                          <div className="form-group">
                                            <h6 className='questionText'>Question <span className="text-danger">*</span></h6>
                                            <textarea rows={2} name={`question`} className="questionInput" placeholder={`Question`} value={editQuestionData.question} onChange={(e) => handleInput(e.target.name, e.target.value)} required />
                                            
                                          </div>

                                          <div className="row">
                                            <div className="col-md-6">
                                              <div className="form-group">
                                                <h6 className='questionText'>Instruction (if any)</h6>
                                                <textarea rows={4} name="instruction" placeholder="Instruction" value={editQuestionData?.instruction ?? ""} onChange={(e) => handleInput(e.target.name, e.target.value)} maxLength={255} />
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <div className="form-group">
                                                <h6 className='questionText'>Hint (if any)</h6>
                                                <textarea rows={4} name="hint" placeholder="Hint" value={editQuestionData?.hint ?? ""} onChange={(e) => handleInput(e.target.name, e.target.value)} maxLength={500} />
                                              </div>
                                            </div>
                                          </div>

                                          <div className="form-group">
                                            <h6 className='questionText'>Reward <span className="text-danger">*</span></h6>
                                            <input type='number' name="reward" className="form-control questionInput" placeholder="Reward" value={editQuestionData.reward} onChange={(e) => handleInput(e.target.name, e.target.value)} onWheel={(e: any) => e.target.blur()} />
                                          </div>






                                          {editQuestionData.type === QuestionType.mcq && editQuestionData.optionWithImage !== OptionWithImage.none && (
                                            <div className="form-group">
                                              <div className="row">
                                                <div className="col-md-12">
                                                  <h6 className='questionText'>Options (select the checkbox if corresponding option is the answer) <span className="text-danger">*</span></h6>

                                                  {editQuestionData.options?.map((option: OptionDataType, optionIndex: number) => (
                                                    <div className="form-group" key={`option-${optionIndex}`} >

                                                      <div className="row">

                                                        

                                                        {editQuestionData.optionWithImage === OptionWithImage.yes &&
                                                          <div className="col-md-3">
                                                            <h6 className='highlightMediaText'>Option {optionIndex + 1} image <span className="text-danger">*</span></h6>
                                                            <div className="customImgUpload mb-3">
                                                              <div className="uploadBtn">
                                                                {option.media.imagePath.files ? (
                                                                  <div className="w-100">
                                                                        {option.media.imagePath.fileExtension === "json" ?
                                                                          <div className="imgName" onClick={() => handleOpenAnimation(option.media.imagePath.files)}>
                                                                          {option.media.imagePath.files instanceof File ? option.media.imagePath.files.name : `option ${optionIndex + 1} json`}
                                                                        </div>
                                                                           :
                                                                           
                                                                    <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                      <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                                          <img src={option.media.imagePath.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "8vw", maxHeight: "8vh" }} onClick={() => handleOpenImage(option.media.imagePath.files)} />
                                                                          </div>
                                                                      {option.media.imagePath.fileExtension !== "json" && option.media.imagePath.files instanceof File &&
                                                                        <div className="imgName">
                                                                          {option.media.imagePath.files.name}
                                                                        </div>
                                                                      }
                                                                    </div>
                                                                        }


                                                                      
                                                                  </div>
                                                                ) : (
                                                                  <React.Fragment>
                                                                    <img className="noimage" src="./../assets/images/no-image-icon.png" alt="NoImage" />
                                                                    <label htmlFor={`optionMediaFile-${optionIndex}`}>Click to upload <span>png, jpg, jpeg, or json <br />(max 20mb)</span></label>
                                                                    <input type="file" className="form-control d-none" id={`optionMediaFile-${optionIndex}`} accept=".png, .jpg, jpeg, .svg, .json" onChange={(e) => handleOptionMedia(editQuestionData.type, e, optionIndex, "image")} required />
                                                                    
                                                                  </React.Fragment>
                                                                )}
                                                              </div>
                                                            </div>
                                                            {option.media.imagePath.files && <div className="row justify-content-center mt-2">
                                                              <div className="col-auto">
                                                                <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, option.media.imagePath.files, optionIndex, `optionMediaFile-${optionIndex}`, "image")}>
                                                                  <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                </button>
                                                              </div>
                                                            </div>}
                                                          </div>
                                                        }



                                                        <div className={`${editQuestionData.optionWithImage === OptionWithImage.no ? "col-md-4 my-auto" : "col-md-3 my-auto"}`}>
                                                          <h6 className='highlightMediaText'>Option {optionIndex + 1} Text <span className="text-danger">*</span></h6>
                                                          <textarea rows={4} className="w-100 questionInput" id={`option-${activeDifficultyType}-${editQuestionData.category}-${option}`} value={option.optionText || ""} name={`option-${option}`} placeholder={`Option ${optionIndex + 1}`} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, optionIndex, "option")} required />
                                                          
                                                        </div>

                                                        <div className="col-md-4">
                                                          <h6 className='highlightMediaText'>Option {optionIndex + 1} VO <span className="text-danger">*</span></h6>
                                                          <div className="customImgUpload mb-3">
                                                            <div className="uploadBtn">
                                                              {option.media.audioPath.files ?
                                                                <div className="w-100">
                                                                  <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                    <audio src={option.media.audioPath.blobPath} className="mx-auto" controls />
                                                                  </div>
                                                                  {option.media.audioPath.files instanceof File  &&
                                                                    <div className="imgName">
                                                                      {option.media.audioPath.files.name}
                                                                    </div>
                                                                  }
                                                                </div>
                                                                :
                                                                <React.Fragment>
                                                                  <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                                  <label htmlFor={`audioFile${optionIndex}`}>Click to upload <span>mp3 or wav <br />(max 20mb)</span></label>
                                                                  <input type="file" className="form-control d-none" id={`audioFile${optionIndex}`} name="audioFile" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, optionIndex, "audio")} required />
                                                                  
                                                                </React.Fragment>
                                                              }
                                                            </div>
                                                          </div>
                                                          {option.media.audioPath.files && <div className="row justify-content-center mt-2">
                                                            <div className="col-auto">
                                                              <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, option.media.audioPath.files, optionIndex, `audioFile${optionIndex}`, "audio")}>
                                                                <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                              </button>
                                                            </div>
                                                          </div>}
                                                        </div>

                                                        <div className='col-auto my-auto'>
                                                          <div className="d-flex justify-content-between">
                                                            {/* Is Answer Checkbox */}
                                                            <input type="checkbox" className="ms-3" style={{ transform: "scale(1.5)" }} checked={option.isAnswer || false} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, optionIndex, "answer")} />

                                                            {/* Delete Button */}
                                                            {editQuestionData.options && editQuestionData.options.length > 1 &&
                                                              <button className="btn border-0 ms-2" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", optionIndex, "delete")}>
                                                                <img src="../assets/images/delete.svg" alt="Delete" width="24" />
                                                              </button>
                                                            }
                                                            {editQuestionData.options && editQuestionData.options.length - 1 === optionIndex && editQuestionData.options.length < 4 &&
                                                              <button className="btn border-0 ms-2" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", -1, "add")}>
                                                                <img src="../assets/images/add-icon.svg" alt="add" />
                                                              </button>
                                                            }
                                                          </div>
                                                        </div>
                                                      </div>

                                                    </div>
                                                  ))}
                                                </div>
                                              </div>
                                            </div>
                                          )}




                                        </div>
                                        <div className="d-flex justify-content-end p-3">
                                          <button type="button" className="btn btn-save btnPurple" style={{ width: '250px' }} onClick={validateQuestionData}>Save</button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }

                            </div>
                            {allQuestionData.length > 0 &&
                              allQuestionData.map((questionData: QuestionDataType, index: number) => (
                                // questionData.type === QuestionType.mcq &&
                                <div key={questionData.id} id={questionData.id}>
                                  <div className="unitQustLists mb-4">
                                    <div className="unitQustLists">
                                      <div className='listHead'>
                                        <div className="row mb-2">
                                          {editQuestionData.id === questionData.id ? (
                                            <div className="col-10 form-group">
                                              <h6 className='highlightMediaText'>Question <span className="text-danger">*</span></h6>
                                              <textarea rows={2} name={`question`} className="questionInput" placeholder={`Question`} value={editQuestionData.question} onChange={(e) => handleInput(e.target.name, e.target.value)} required />
                                              
                                            </div>
                                          ) : (
                                            <div className="col-10">
                                              <pre className='quesText'>{indexOfFirstItem + index + 1} - {questionData.question}</pre>
                                              {/* <p className="quesText">{index + 1} - {questionData.question} - {questionData.id} - {questionData.type}</p> */}

                                            </div>
                                          )}

                                          {!editQuestionData.id && !showAddQuestion &&
                                            <div className="col-2">
                                              <div className="d-flex justify-content-end">
                                                <button className="btn" style={{ flexShrink: 0 }} type="button" data-bs-toggle="collapse" data-bs-target={`#question-mcq-fill-${questionData.id}`} aria-expanded="false" aria-controls={`question-mcq-fill-${questionData.id}`}>
                                                  <img src="./../assets/images/chevron-down-M.svg" alt="" />
                                                </button>



                                                <div className="dropdown dots">
                                                  <button className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" >
                                                    <img src='./../assets/images/more.svg' alt='action button' />
                                                  </button>
                                                  <ul className="dropdown-menu">

                                                    <li>
                                                      <button className="dropdown-item" onClick={() => handleEditQuestion(questionData)}>
                                                        <img src="./../assets/images/edit-icon.png" alt="" className="me-2" />
                                                        Edit
                                                      </button>
                                                    </li>
                                                    <li>
                                                      <button className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => handleDeleteByQuestionId(questionData)} >
                                                        <img src="./../assets/images/delete.png" alt="" className="me-2" />
                                                        Delete
                                                      </button>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                            </div>}



                                        </div>

                                        {editQuestionData.id === questionData.id ? (
                                          <div>
                                            <h6 className='highlightMediaText'>Option <span className="text-danger">*</span></h6>
                                            {editQuestionData.options && editQuestionData.options.map((option: OptionDataType, optionIndex: number) => (
                                              <div className="form-group" key={`option-${optionIndex}`} >

                                                <div className="row">

                                                  {editQuestionData.options && <div className={`col-md-${Math.floor(12 / editQuestionData.options.length)}`}>
                                                    <div className="customImgUpload mb-3">
                                                      <div className="uploadBtn">
                                                        {option.media.audioPath.files ?
                                                          <div className="w-100">
                                                            <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                              <audio src={option.media.audioPath.blobPath} className="mx-auto" controls />
                                                            </div>
                                                            {option.media.audioPath.files instanceof File  &&
                                                              <div className="imgName">
                                                                {option.media.audioPath.files.name}
                                                              </div>
                                                            }
                                                          </div>
                                                          :
                                                          <React.Fragment>
                                                            <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                            <label htmlFor={`audioFile${optionIndex}`}>Click to upload <span>mp3 or wav <br />(max 20mb)</span></label>
                                                            <input type="file" className="form-control d-none" id={`audioFile${optionIndex}`} name="audioFile" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, optionIndex, "audio")} required />
                                                            
                                                          </React.Fragment>
                                                        }
                                                      </div>
                                                    </div>
                                                    {option.media.audioPath.files && <div className="row justify-content-center mt-2">
                                                      <div className="col-auto">
                                                        <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, option.media.audioPath.files, optionIndex, `audioFile${optionIndex}`, "audio")}>
                                                          <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                        </button>
                                                      </div>
                                                    </div>}
                                                  </div>
                                                  }

                                                  {editQuestionData.optionWithImage === OptionWithImage.yes &&
                                                    <div className="col-md-2">
                                                      <div className="customImgUpload mb-3">
                                                        <div className="uploadBtn">
                                                          {option.media.imagePath.files ? (
                                                            <div className="w-100">
                                                              {option.media.imagePath.fileExtension === "json" ?
                                                                <div className="imgName" onClick={() => handleOpenAnimation(option.media.imagePath.files)}>
                                                                  {option.media.imagePath.files instanceof File ? option.media.imagePath.files.name : `option ${optionIndex + 1} json`}
                                                                </div>
                                                                :
                                                                <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                  <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>

                                                                    <img src={option.media.imagePath.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "8vw", maxHeight: "8vh" }} onClick={() => handleOpenImage(option.media.imagePath.files)} />


                                                                  </div>
                                                                  {option.media.imagePath.files instanceof File &&
                                                                    <div className="imgName">
                                                                      {option.media.imagePath.files.name}
                                                                    </div>
                                                                  }
                                                                </div>
                                                              }


                                                            </div>
                                                          ) : (
                                                            <React.Fragment>
                                                              <img className="noimage" src="./../assets/images/no-image-icon.png" alt="NoImage" />
                                                              <label htmlFor={`optionMediaFile-${optionIndex}`}>Click to upload <span>png, jpg, jpeg, or json <br />(max 20mb)</span></label>
                                                              <input type="file" className="form-control d-none" id={`optionMediaFile-${optionIndex}`} accept=".png, .jpg, jpeg, .svg, .json" onChange={(e) => handleOptionMedia(editQuestionData.type, e, optionIndex, "image")} required />
                                                              
                                                            </React.Fragment>
                                                          )}
                                                        </div>
                                                      </div>
                                                      {option.media.imagePath.files && <div className="row justify-content-center mt-2">
                                                        <div className="col-auto">
                                                          <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, option.media.imagePath.files, optionIndex, `optionMediaFile-${optionIndex}`, "image")}>
                                                            <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                          </button>
                                                        </div>
                                                      </div>}
                                                    </div>
                                                  }

                                                  <div className={`${editQuestionData.optionWithImage === OptionWithImage.no ? "col-md-4 my-auto" : "col-md-3 my-auto"}`}>
                                                    <textarea rows={6} className="w-100 questionInput" id={`option-${activeDifficultyType}-${editQuestionData.category}-${option}`} value={option.optionText || ""} name={`option-${option}`} placeholder={`Option ${optionIndex + 1}`} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, optionIndex, "option")} required />
                                                    
                                                  </div>
                                                  <div className='col-auto my-auto'>
                                                    <div className="d-flex justify-content-between">
                                                      {/* Is Answer Checkbox */}
                                                      <input type="checkbox" className="ms-3" style={{ transform: "scale(1.5)" }} checked={option.isAnswer || false} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, optionIndex, "answer")} />

                                                      {/* Delete Button */}
                                                      {editQuestionData.options && editQuestionData.options.length > 1 &&
                                                        <button className="btn border-0 ms-2" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", optionIndex, "delete")}>
                                                          <img src="../assets/images/delete.svg" alt="Delete" width="24" />
                                                        </button>
                                                      }
                                                      {editQuestionData.options && editQuestionData.options.length - 1 === optionIndex && editQuestionData.options.length < 4 &&
                                                        <button className="btn border-0 ms-2" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", -1, "add")}>
                                                          <img src="../assets/images/add-icon.svg" alt="add" />
                                                        </button>
                                                      }
                                                    </div>
                                                  </div>
                                                </div>

                                              </div>
                                            ))}
                                          </div>
                                        ) : (
                                          <React.Fragment>
                                            <div className="row">
                                              {questionData.options?.map((option, i) => (
                                                (questionData.options && <div key={i} className={`col-md-${Math.floor(12 / questionData.options.length)} mb-3`}>
                                                  {option.media.imagePath.files ? (
                                                    <div>
                                                      {/* width: 100px; height: 100px; margin: 0px auto; */}
                                                      
                                                      {option.media.imagePath.fileExtension === "json" ? (
                                                        <div className="imgName mb-3" style={{justifyContent: "center", textAlign: "center", color: option.isAnswer ? "#01BE8580" : "#000000"}} onClick={() => handleOpenAnimation(option.media.imagePath.files)}>
                                                          {option.media.imagePath.files instanceof File ? option.media.imagePath.files.name : `option ${i + 1} json`}
                                                        </div>

                                                      ) : (
                                                        <div className='mb-3' style={{ background: option.isAnswer ? "#01BE8580" : "", border: option.isAnswer ? "1px solid #005B51" : "", borderRadius: option.isAnswer ? "20px" : "", width: "100px", height: "100px", margin: "0px auto" }} >
                                                          <img src={option.media.imagePath.blobPath} alt={option.optionText} onClick={() => handleOpenImage(option.media.imagePath.files)} />

                                                        </div>
                                                      )}
                                                      <pre className={`matchClass ${option.isAnswer ? "greenText" : ""}`} style={{ border: "1px solid rgba(0, 0, 0, 0.1)", padding: "2% 0 1% 4%", borderRadius: "10px", whiteSpace: "normal", width: "100%", overflow: "hidden" }}>{option.optionText}</pre>
                                                    </div>
                                                  ) : (
                                                    <pre className={`${option.isAnswer ? "greenText" : ""}`} style={{ border: "1px solid rgba(0, 0, 0, 0.1)", padding: "2% 0 1% 4%", borderRadius: "10px", whiteSpace: "normal", width: "100%", overflow: "hidden" }}>{option.optionText}</pre>
                                                  )}
                                                </div>)
                                              ))}
                                            </div>
                                          </React.Fragment>
                                        )}

                                      </div>
                                    </div>

                                    <div className={questionData.id === editQuestionData.id ? "collapse show" : "collapse"} id={`question-mcq-fill-${questionData.id}`}>

                                      <div className="card card-body bg-transparent" style={{ border: 0 }}>
                                        <div className="row mb-2">
                                          <div className="col-3">
                                            <div className="form-group">
                                              <h6 className='highlightMediaText'>Level2</h6>
                                              <input type="text" name="" className="form-control questionInput opactity5" placeholder="Level" value={questionData.level} readOnly />
                                            </div>
                                          </div>

                                          <div className="col-3">
                                            <div className="form-group">
                                              <h6 className='highlightMediaText'>Question Type</h6>
                                              <input type="text" name="" className="form-control questionInput opactity5" placeholder="Question Type" value={questionData.type} readOnly />
                                            </div>
                                          </div>
                                          {(questionData.id === editQuestionData.id && editQuestionData.type === QuestionType.mcq) &&
                                            <div className='col-3 form-group'>
                                              <h6 className='questionText'>Option with Image <span className="text-danger">*</span></h6>
                                              <select className="form-select questionInput" name="optionWithImage" value={editQuestionData.optionWithImage ?? ""} onChange={(e) => handleInput(e.target.name, e.target.value)} required >
                                                <option value="" disabled>
                                                  Select
                                                </option>
                                                <option value={OptionWithImage.yes}>Yes</option>
                                                <option value={OptionWithImage.no}>No</option>
                                              </select>
                                              

                                            </div>
                                          }

                                        </div>

                                        <div className="row mb-3">
                                          <div className="col-3">
                                            <div className="form-group">
                                              <h6 className='highlightMediaText'>Lesson</h6>
                                              <input type="text" name="Unit" className="form-control questionInput opactity5" placeholder="Unit" value={unitData.unitLesson.name} readOnly />
                                            </div>
                                          </div>
                                          <div className="col-3">
                                            <div className="form-group">
                                              <h6 className='highlightMediaText'>Unit</h6>
                                              <input type="text" name="Unit" className="form-control questionInput opactity5" placeholder="Unit" value={unitData.unitName} readOnly />
                                            </div>
                                          </div>
                                          <div className="col-3">
                                            <div className="form-group">
                                              <h6 className='highlightMediaText'>Grade</h6>
                                              <input type="text" name="Unit" className="form-control questionInput opactity5" placeholder="Unit" value={unitData.grade.gradeName} readOnly />
                                            </div>
                                          </div>

                                        </div>
                                        <div className="row mb-3">
                                          {(questionData.id === editQuestionData.id) ?
                                            <div className="col-5">
                                              <div className="form-group">
                                                <h6 className='highlightMediaText'>Instruction (if any)</h6>
                                                <textarea rows={6} name="instruction" className="questionInput" placeholder="Instruction (if any)" value={editQuestionData.id ? editQuestionData.instruction : questionData.instruction} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, -1, "instruction")} maxLength={255} />
                                              </div>
                                            </div>
                                            :
                                            ((questionData.instruction && <div className="col-5">
                                              <div className="form-group">
                                                <h6 className='highlightMediaText'>Instruction</h6>
                                                <pre className="questionInput" style={{ background: "#F0F2F6", border: "1px solid rgba(0, 0, 0, 0.1)", padding: "2% 0 1% 4%", borderRadius: "10px", whiteSpace: "normal", width: "100%", overflow: "hidden" }}>{questionData.instruction}</pre>
                                              </div>
                                            </div>))
                                          }
                                          {(questionData.id === editQuestionData.id) ?
                                            <div className="col-5">
                                              <div className="form-group">
                                                <h6 className='highlightMediaText'>Hint (if any)</h6>
                                                <textarea rows={6} name="hint" className="questionInput" placeholder="Hint (if any)" value={editQuestionData.id ? editQuestionData.hint : questionData.hint} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, -1, "hint")} maxLength={500} />
                                              </div>
                                            </div>
                                            :
                                            (questionData.hint && <div className="col-5">
                                              <div className="form-group">
                                                <h6 className='highlightMediaText'>Hint</h6>
                                                <pre className="matchClass" style={{ background: "#F0F2F6", border: "1px solid rgba(0, 0, 0, 0.1)", padding: "2% 0 1% 4%", borderRadius: "10px", whiteSpace: "normal", width: "100%", overflow: "hidden" }}>{questionData.hint}</pre>
                                              </div>
                                            </div>)
                                          }
                                        </div>

                                        <div className="row mb-3">
                                          {(questionData.id === editQuestionData.id) ?
                                            <div className="col-5">
                                              <div className="form-group">
                                                <h6 className='highlightMediaText'>Reward</h6>
                                                <input type='number' name="reward" className="form-control questionInput" placeholder="Reward" value={editQuestionData.reward} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, -1, "reward")} onWheel={(e: any) => e.target.blur()} required />
                                              </div>
                                            </div>
                                            :
                                            <div className="col-5">
                                              <div className="form-group">
                                                <h6 className='highlightMediaText'>Reward</h6>
                                                <input type='number' name="reward" className="form-control questionInput" placeholder="Reward" value={questionData.reward} readOnly />
                                              </div>
                                            </div>
                                          }
                                        </div>




                                        <div className="row">
                                          {/* {editQuestionData.optionWithImage === OptionWithImage.no && */}
                                          {(editQuestionData.id === questionData.id && editQuestionData.optionWithImage === OptionWithImage.no) ?
                                            <div className="col-md-5">
                                              <div className="form-group">
                                                <h6 className='highlightMediaText'>Media</h6>
                                                <div className="customImgUpload mb-3">
                                                  <div className="uploadBtn">
                                                    {editQuestionData.mediaFile.questionMediaFile.files ?
                                                      <div className="w-100">
                                                        
                                                            {editQuestionData.mediaFile.questionMediaFile.fileExtension === "json" ?
                                                              <div className="imgName" onClick={() => handleOpenAnimation(editQuestionData.mediaFile.questionMediaFile.files)}>
                                                                  {/* {`question json`} */}
                                                                  {editQuestionData.mediaFile.questionMediaFile.files instanceof File ? editQuestionData.mediaFile.questionMediaFile.files.name : `questionMedia.json`}
                                                                </div>

                                                              :
                                                              <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                          <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                              <img src={editQuestionData.mediaFile.questionMediaFile.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(editQuestionData.mediaFile.questionMediaFile.files)} />
                                                              
                                                          </div>
                                                          {editQuestionData.mediaFile.questionMediaFile.files instanceof File &&
                                                              <div className="imgName">
                                                                {editQuestionData.mediaFile.questionMediaFile.files.name}
                                                              </div>
                                                            }
                                                        </div>
                                                            }
                                                      </div>
                                                      :
                                                      <React.Fragment>
                                                          <img className="noimage" src={"../assets/images/no-image-icon.png"} alt="" />

                                                          <label htmlFor={`question-media-${questionData.id}`}>Click to upload<span>png, jpg, jpeg, or json <br />(max 20mb)</span></label>
                                                          <input type="file" className="form-control d-none" name={`question-media`} id={`question-media-${questionData.id}`} accept=".png, .jpg, .jpeg, .json" onChange={(e) => handleOptionMedia(editQuestionData.type, e, -1, "video")} required />
                                                          
                                                      </React.Fragment>}


                                                  </div>
                                                </div>
                                              </div>

                                              {editQuestionData.mediaFile.questionMediaFile.files && <div className="row justify-content-center mt-2">
                                                <div className="col-auto">
                                                  <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, editQuestionData.mediaFile.questionMediaFile.files, -1, "question-media", "image")}>
                                                    <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                  </button>
                                                </div>
                                              </div>}
                                            </div>
                                            :
                                            (questionData.mediaFile.questionMediaFile.files &&
                                              <div className="col-md-3">
                                                <div className="form-group">
                                                  <h6 className='highlightMediaText'>Media3</h6>
                                                  <div className="customImgUpload mb-3">
                                                    <div className="uploadBtn">
                                                      <div className="w-100">
                                                        {questionData.mediaFile.questionMediaFile.fileExtension === "json" ?
                                                          <div className="imgName" onClick={() => handleOpenAnimation(questionData.mediaFile.questionMediaFile.files)}>
                                                            {questionData.mediaFile.questionMediaFile.files instanceof File ? questionData.mediaFile.questionMediaFile.files.name : `questionMedia.json`}
                                                          </div>
                                                          :

                                                          <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                            <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                              <img src={questionData.mediaFile.questionMediaFile.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(questionData.mediaFile.questionMediaFile.files)} />


                                                            </div>
                                                          </div>
                                                        }
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )
                                          }


                                          {editQuestionData.id === questionData.id ? (
                                            <div className="col-md-5">
                                              <div className="form-group">
                                                <h6 className='highlightMediaText'>Voice Over Audio <span className="text-danger">*</span></h6>
                                                <div className="customImgUpload mb-3">
                                                  <div className="uploadBtn">
                                                    {editQuestionData.mediaFile.audioFile.files ? (
                                                      <div className="w-100">
                                                        <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                          <div className="imagesPrev" style={{ margin: "0 auto", textAlign: "center" }}>
                                                            <div className="w-100">
                                                              <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                <audio src={questionData.mediaFile.audioFile.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />
                                                              </div>
                                                              {questionData.mediaFile.audioFile.files instanceof File && (
                                                                <div className="imgName">
                                                                  {questionData.mediaFile.audioFile.files.name}
                                                                </div>
                                                              )}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    ) : (
                                                      <React.Fragment>
                                                        <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                        <label htmlFor={`question-voice-over-audio-${questionData.id}`}>
                                                          Click to upload <span>mp3 or wav <br />(max 20mb)</span>
                                                        </label>
                                                        <input type="file" className="form-control d-none" id={`question-voice-over-audio-${questionData.id}`} name="voice-over-audio" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, -1, "audio")} required />
                                                        
                                                      </React.Fragment>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>

                                              {editQuestionData.mediaFile.audioFile.files && <div className="row justify-content-center mt-2">
                                                <div className="col-auto">
                                                  <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, editQuestionData.mediaFile.audioFile.files, -1, "voice-over-audio", "audio")} >
                                                    <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                  </button>
                                                </div>
                                              </div>}
                                            </div>
                                          ) : (
                                            questionData.mediaFile.audioFile.files && (
                                              <div className="col-md-3">
                                                <div className="form-group">
                                                  <h6 className='highlightMediaText'>Voice Over Audio <span className="text-danger">*</span></h6>
                                                  <div className="customImgUpload mb-3">
                                                    <div className="uploadBtn">
                                                      <div className="w-100">
                                                        <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                          <div className="imagesPrev" style={{ margin: "0 auto", textAlign: "center" }}>
                                                            {editQuestionData.id === questionData.id ? null : (
                                                              <div className="w-100">
                                                                <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                  <audio src={questionData.mediaFile.audioFile.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />
                                                                </div>
                                                                {questionData.mediaFile.audioFile.files instanceof File && (
                                                                  <div className="imgName">
                                                                    {questionData.mediaFile.audioFile.files.name}
                                                                  </div>
                                                                )}
                                                              </div>
                                                            )}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )
                                          )}



                                        </div>





                                        {editQuestionData.id === questionData.id &&
                                          <div className="row justify-content-center" style={{ padding: "25px 0" }}>
                                            <div className="col-md-3">
                                              <div className="btn-group w-100">
                                                <button type="button" className="btn btn-save btnPurple" onClick={validateQuestionData}>Save</button>
                                              </div>
                                            </div>
                                            <div className="col-md-3">
                                              <button type="button" className="btn btn-cancel btnBorder" onClick={handleCancel}>Cancel</button>
                                            </div>
                                          </div>}
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              ))}
                          </React.Fragment>
                        }
                      </React.Fragment>
                    }
                  </div>
                  {/* <div className="pagination-container">
                    <nav className="d-flex justify-content-between">
                      <div className="page-length">
                        Showing
                      </div>
                      <ul className="pagination justify-content-center mx-auto">
                        <li className="page-item">
                          <button className="page-link" aria-label="Previous" >
                            <span aria-hidden="true"><img src="./../assets/images/arrow-left-small.svg" alt="" /></span>
                          </button>
                        </li>
                        <li className="page-item disabled">
                          <span className="page-link">
                            {indexOfFirstItem + 1} of {indexOfLastItem}
                          </span>
                        </li>
                        <li className="page-item">
                          <button className="page-link" aria-label="Next">
                            <span aria-hidden="true"><img src="./../assets/images/arrow-right-small.svg" alt="" /></span>
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div> */}
                </div>

              </div>

              <div className="accordion-item">
                <h2 className="accordion-header" id={`headingFour-${activeDifficultyType}`}>
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseFour-${activeDifficultyType}`} aria-expanded="false" aria-controls={`collapseFour-${activeDifficultyType}`}>
                    Congratulations Screen
                  </button>
                </h2>
                <div id={`collapseFour-${activeDifficultyType}`} className="accordion-collapse collapse" aria-labelledby={`headingFour-${activeDifficultyType}`} data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <div className="form-group">
                      <div className="row">
                        <div className="col-md-6">
                          <h6 className='highlightMediaText'>Congratulation Badge Icon <span className="text-danger">*</span></h6>
                          <div className="customImgUpload whitebg mb-3">
                            <div className="uploadBtn">
                              {editIntroData.congratulation.congratulationBadgeIcon.files ? (
                                <div className="w-100">
                                      {editIntroData.congratulation.congratulationBadgeIcon.fileExtension === "json" ? (
                                        <div className="imgName" onClick={() => handleOpenAnimation(editIntroData.congratulation.congratulationBadgeIcon.files)}>
                                                                  {editIntroData.congratulation.congratulationBadgeIcon.files instanceof File ? editIntroData.congratulation.congratulationBadgeIcon.files.name : `congrats.json`}
                                                                </div>
                                      ) : (
                                        
                                  <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                    <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                        <img src={editIntroData.congratulation.congratulationBadgeIcon.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(editIntroData.congratulation.congratulationBadgeIcon.files)} />
                                        
                                    </div>
                                  </div>
                                      )}
                                  {editIntroData.congratulation.congratulationBadgeIcon.fileExtension !== "json" && editIntroData.congratulation.congratulationBadgeIcon.files instanceof File &&
                                    <div className="imgName">
                                      {editIntroData.congratulation.congratulationBadgeIcon.files.name}
                                    </div>
                                  }
                                </div>
                              ) : (
                                <React.Fragment>
                                  <img className="noimage" src="./../assets/images/no-image-icon.png" alt="No content available" />
                                  <label htmlFor={`congratulation-badge-icon-${editIntroData.congratulation.congratulationId}-${activeDifficultyType}`}>
                                    Click to upload <span>png, jpg, jpeg, or json <br />(max 20mb)</span>
                                  </label>
                                  <input type="file" className="form-control d-none" id={`congratulation-badge-icon-${editIntroData.congratulation.congratulationId}`} name="congratulations-badge" accept=".png, .jpg, .jpeg, .json" onChange={(e) => handleCongratsInput(e, e.target.name, "")} required />
                                  
                                </React.Fragment>
                              )}
                            </div>
                          </div>
                          {editIntroData.congratulation.congratulationBadgeIcon.files && (
                            <div className="row justify-content-center mt-2">
                              <div className="col-auto">
                                <button type="button" className="btn btnBorder mb-3 justify-content-start p-0 my-auto" style={{ width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992", fontSize: "14px", fontWeight: "400" }}>
                                  <label className='m-0 flex' htmlFor={`congratulation-badge-icon-${editIntroData.congratulation.congratulationId}-${activeDifficultyType}`} style={{ padding: "6px 12px", cursor: 'pointer' }}>
                                    <img src="./../assets/images/replace.svg" alt="Replace" style={{ marginRight: "10px" }} />
                                    <input type="file" className="form-control d-none" id={`congratulation-badge-icon-${editIntroData.congratulation.congratulationId}-${activeDifficultyType}`} name="congratulations-badge" accept=".png, .jpg, .jpeg, .json" onChange={(e) => handleCongratsInput(e, e.target.name, "")} required />
                                    Replace
                                  </label>
                                </button>
                              </div>
                            </div>
                          )}

                        </div>

                        <div className="col-md-6">

                          <h6 className='highlightMediaText'>Congratulations Voice Over <span className="text-danger">*</span></h6>
                          {/* Audio Upload/Preview */}
                          <div className="customImgUpload whitebg mb-3">
                            <div className="uploadBtn">
                              {editIntroData.congratulation.congratulationAudio.files ? (
                                <div className="w-100">
                                  <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                    <audio src={editIntroData.congratulation.congratulationAudio.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />
                                  </div>
                                  {editIntroData.congratulation.congratulationAudio.files instanceof File  && (
                                    <div className="imgName">{editIntroData.congratulation.congratulationAudio.files.name}</div>
                                  )}
                                </div>
                              ) : (
                                <React.Fragment>
                                  <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                  <label htmlFor={`congratulation-audio-${editIntroData.congratulation.congratulationId}`}>
                                    Click to upload <span>mp3 or wav <br />(max 20mb)</span>
                                  </label>
                                  <input type="file" className="form-control d-none" id={`congratulation-audio-${editIntroData.congratulation.congratulationId}`} name="congratulations-audio" accept=".mp3, .wav" onChange={(e) => handleCongratsInput(e, e.target.name, "")} required />
                                  
                                </React.Fragment>
                              )}
                            </div>
                          </div>

                          {/* Replace Audio */}
                          {editIntroData.congratulation.congratulationAudio.files && (
                            <div className="row justify-content-center mt-2">
                              <div className="col-auto">
                                <button type="button" className="btn btnBorder mb-3 justify-content-start p-0 my-auto" style={{ width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992", fontSize: "14px", fontWeight: "400" }}>
                                  <label className='m-0 flex' htmlFor="congratulations-audio" style={{ padding: "6px 12px", cursor: 'pointer' }}>
                                    <img src="./../assets/images/replace.svg" alt="Replace" style={{ marginRight: "10px" }} />
                                    <input type="file" className="form-control d-none" id="congratulations-audio" name="congratulations-audio" accept=".mp3, .wav" onChange={(e) => handleCongratsInput(e, e.target.name, "")} required />
                                    Replace
                                  </label>
                                </button>
                              </div>
                            </div>
                          )}
                        </div>

                      </div>

                      <div className="mt-3">
                        <h6 className='highlightMediaText'>Congratulations Text <span className="text-danger">*</span></h6>

                        <ReactQuill className='whitebg' onChange={(value) => handleCongratsInput(null, "congratulation-text", value)} value={editIntroData?.congratulation?.congratulationText || ""} style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }}
                          modules={{
                            toolbar: [
                              [{ header: [3, 4, false] }],
                              ["bold", "italic", "underline", "blockquote"],
                              [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
                              [{ align: [] }]
                            ]
                          }}
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-end mt-3 mb-3">
                      <button type="button" className="btn btn-save btnPurple" style={{ width: '250px' }} onClick={validateCongratsData}>Save</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}


          {(activeDifficultyType === "2" || activeDifficultyType === "3") &&
            <div className="accordionBox">
              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header" id={`headingFive-${activeDifficultyType}`}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseFive-${activeDifficultyType}`} aria-expanded="false" aria-controls={`collapseFive-${activeDifficultyType}`}>
                      {(activeDifficultyType === "2" ? "Instructions" : (activeDifficultyType === "3" ? "Objective and Scientific Hypothesis" : ""))}
                    </button>
                  </h2>
                  <div id={`collapseFive-${activeDifficultyType}`} className="accordion-collapse collapse" aria-labelledby={`headingFive-${activeDifficultyType}`} data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      <div className="form-group">
                        <div className="row">
                          <div className="col-md-12">
                            <h6 className='highlightMediaText'>Image <span className="text-danger">*</span></h6>
                            <div className="customImgUpload whitebg mb-3">
                              <div className="uploadBtn">
                                {editIntroData.instruction.instruction_image.files ? (
                                  <div className="w-100">
                                        {editIntroData.instruction.instruction_image.fileExtension === "json" ? (
                                          <div className="imgName" onClick={() => handleOpenAnimation(editIntroData.instruction.instruction_image.files)}>
                                                                  {/* {`question json`} */}
                                                                  {editIntroData.instruction.instruction_image.files instanceof File ? editIntroData.instruction.instruction_image.files.name : `instruction.json`}
                                                                </div>
                                        ) : (
                                          
                                    <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                      <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                          <img src={editIntroData.instruction.instruction_image.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(editIntroData.instruction.instruction_image.files)} />
                                          
                                      </div>
                                    </div>
                                        )}
                                    {editIntroData.instruction.instruction_image.fileExtension !== "json"  && editIntroData.instruction.instruction_image.files instanceof File &&
                                    <div className="imgName">
                                      {editIntroData.instruction.instruction_image.files.name}
                                    </div>
                                  }
                                  </div>
                                ) : (
                                  <React.Fragment>
                                    <img className="noimage" src="./../assets/images/no-image-icon.png" alt="No content available" />
                                    <label htmlFor={`instruction-image-${editIntroData.instruction.id}`}>
                                      Click to upload <span>.png, .jpg, .jpeg <br />(max 20mb)</span>
                                    </label>
                                    <input type="file" className="form-control d-none" id={`instruction-image-${editIntroData.instruction.id}`} name="instruction-image" accept=".png, .jpg, .jpeg" onChange={(e) => handleInstructionInput(e, e.target.name, "", false)} required />
                                  </React.Fragment>
                                )}
                              </div>
                            </div>
                            {editIntroData.instruction.instruction_image.files && (
                              <div className="row justify-content-center pt-3">
                                <div className="col-auto">
                                  <button type="button" className="btn btnBorder mb-3 justify-content-start p-0 my-auto" style={{ width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992", fontSize: "14px", fontWeight: "400" }}>
                                    <label className='m-0 flex' htmlFor="instruction-image" style={{ padding: "6px 12px", cursor: 'pointer' }}>
                                      <img src="./../assets/images/replace.svg" alt="Replace" style={{ marginRight: "10px" }} />
                                      <input type="file" className="form-control d-none" id="instruction-image" name="instruction-image" accept=".png, .jpg, .jpeg" onChange={(e) => handleInstructionInput(e, e.target.name, "", true)} required />
                                      Replace
                                    </label>
                                  </button>
                                </div>
                              </div>
                            )}

                          </div>
                        </div>
                        <div className="form-group mt-3">

                          {activeDifficultyType === "2" &&
                            <React.Fragment>
                              <h6 className='highlightMediaText'>Intruction Text <span className="text-danger">*</span></h6>
                              <ReactQuill className='whitebg' onChange={(value) => handleInstructionInput(null, "instruction-text", value, false)} value={editIntroData?.instruction.text || ""} style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }}
                                modules={{
                                  toolbar: [
                                    [{ header: [3, 4, false] }],
                                    ["bold", "italic", "underline", "blockquote"],
                                    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
                                    [{ align: [] }]
                                  ]
                                }}
                              />
                            </React.Fragment>
                          }
                          {activeDifficultyType === "3" && (
                            <React.Fragment>
                              <div className="form-group">
                                <h6 className='highlightMediaText'>Objective <span className="text-danger">*</span></h6>
                                <textarea rows={2} placeholder="Enter text here..." value={editIntroData.instruction.text} name="instruction-text" onChange={(e) => handleInstructionInput(null, e.target.name, e.target.value, false)} required />
                              </div>

                              <div className='form-group'>
                                <h6 className='highlightMediaText'>Scientific Hypothesis <span className="text-danger">*</span></h6>
                                <ReactQuill className='whitebg' onChange={(value) => handleInstructionInput(null, "scientific-hypothesis", value, false)} value={editIntroData?.instruction?.scientific_hypothesis || ""} style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }}
                                  modules={{
                                    toolbar: [
                                      [{ header: [3, 4, false] }],
                                      ["bold", "italic", "underline", "blockquote"],
                                      [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
                                      [{ align: [] }]
                                    ]
                                  }}
                                />
                              </div>
                            </React.Fragment>
                          )}

                          {/* {activeDifficultyType === "3" && */}
                          <div className="row mt-3">
                            <div className="col-md-12">
                              <h6 className='highlightMediaText'>Audio <span className="text-danger">*</span></h6>
                              <div className="customImgUpload whitebg mb-3">
                                <div className="uploadBtn">
                                  {editIntroData.instruction.audio.files ?
                                    <div className="w-100">
                                      <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                        <audio src={editIntroData.instruction.audio.blobPath} className="mx-auto" controls />
                                      </div>
                                      {editIntroData.instruction.audio.files instanceof File  &&
                                        <div className="imgName">
                                          {editIntroData.instruction.audio.files.name}
                                        </div>
                                      }
                                    </div>
                                    :
                                    <React.Fragment>
                                      <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                      <label htmlFor={`audio-${activeDifficultyType}-${editIntroData.instruction.id}`}>
                                        Click to upload <span>.wav, .mp3 <br />(max 20mb)</span>
                                      </label>
                                      <input type="file" className="form-control d-none" id={`audio-${activeDifficultyType}-${editIntroData.instruction.id}`} name="audio" accept=".mp3, .wav" onChange={(e) => handleInstructionInput(e, e.target.name, "", false)} required />
                                    </React.Fragment>
                                  }
                                </div>
                              </div>
                              {editIntroData.instruction.audio.files && (
                                <div className="row justify-content-center pt-3">
                                  <div className="col-auto">
                                    <button type="button" className="btn btnBorder mb-3 justify-content-start p-0 my-auto" style={{ width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992", fontSize: "14px", fontWeight: "400" }}>
                                      <label className='m-0 flex' htmlFor={`audio-${activeDifficultyType}-${editIntroData.instruction.id}`} style={{ padding: "6px 12px", cursor: 'pointer' }}>
                                        <img src="./../assets/images/replace.svg" alt="Replace" style={{ marginRight: "10px" }} />
                                        <input type="file" className="form-control d-none" id={`audio-${activeDifficultyType}-${editIntroData.instruction.id}`} name="audio" accept=".mp3, .wav" onChange={(e) => handleInstructionInput(e, e.target.name, "", true)} required />
                                        Replace
                                      </label>
                                    </button>
                                  </div>
                                </div>
                              )}

                            </div>
                          </div>
                          {/* } */}

                        </div>
                      </div>
                      <div className="d-flex justify-content-end mt-3 mb-3">
                        <button type="button" className="btn btn-save btnPurple" style={{ width: '250px' }} onClick={validateInstructionData}>Save</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                      Questions
                    </button>
                  </h2>
                  <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                    <div className="accordion-body">

                      {loading.tableLoading ?
                        <div className="d-flex align-items-center mt-5">
                          <div className="loader mx-auto"></div>
                        </div>
                        :
                        <React.Fragment>
                          {(activeDifficultyType === "2" || activeDifficultyType === "3") &&
                            <React.Fragment>
                              <div className="form-group">
                                <div className="position-relative">
                                  {!showAddQuestion && !editQuestionData.id && <div className="d-flex justify-content-between align-items-center">
                                    <p className="m-0" style={{ fontFamily: "Nunito", fontWeight: "700", fontSize: "18px", letterSpacing: "2%", lineHeight: "100%" }}>Add Question</p>
                                    <button className="btn" type="button" id="button-addon2" onClick={() => setShowAddQuestion(true)}><img src="./../assets/images/add-icon.svg" alt="Add" /></button>
                                  </div>}
                                </div>
                                {showAddQuestion &&
                                  <div>
                                    <div className="accordion quesDropBlock accordion-flush bg-transparent" id="accordionQuest">
                                      <div className="accordion-item">
                                        <h2 className="accordion-header">
                                          <button className="accordion-button titlebtn border-0 bg-transparent shadow-none" type="button" data-bs-toggle="collapse" data-bs-target="#collapseQuesOne" aria-expanded="true" aria-controls="collapseQuesOne">
                                            {`Question ${allQuestionData.length + 1}`}
                                          </button>
                                        </h2>
                                        <div id="collapseQuesOne" className="accordion-collapse collapse show" data-bs-parent="#accordionQuest">
                                          <div className="accordion-body">
                                            <div className="row">
                                              <div className="col-md-6 my-auto">
                                                <h6 className='questionText'>Type <span className="text-danger">*</span></h6>
                                                <div className="form-group">
                                                  <select className="form-select questionInput" name="type" value={editQuestionData.type ?? ""} onChange={(e) => handleInput(e.target.name, e.target.value)}>
                                                    <option value="" disabled>
                                                      Select Question Type
                                                    </option>
                                                    {(activeDifficultyType === "3") &&
                                                      <option value={QuestionType.mcq}>MCQ</option>
                                                    }
                                                    {activeDifficultyType === "2" &&
                                                      <React.Fragment>
                                                        <option value={QuestionType.mcq}>MCQ</option>
                                                        <option value={QuestionType.match}>MATCH</option>
                                                        <option value={QuestionType.dragMatch}>DRAGMATCH</option>
                                                        <option value={QuestionType.fill}>FILL</option>
                                                      </React.Fragment>
                                                    }
                                                  </select>
                                                </div>
                                              </div>

                                              {(editQuestionData.type === QuestionType.mcq) ?
                                                <div className='col-md-6 form-group'>
                                                  <h6 className='questionText'>Option with Image <span className="text-danger">*</span></h6>
                                                  <select className="form-select questionInput" name="optionWithImage" value={editQuestionData.optionWithImage ?? ""} onChange={(e) => handleInput(e.target.name, e.target.value)} required >
                                                    <option value="" disabled>
                                                      Select
                                                    </option>
                                                    <option value={OptionWithImage.yes}>Yes</option>
                                                    <option value={OptionWithImage.no}>No</option>
                                                  </select>
                                                  

                                                </div>
                                                :
                                                (editQuestionData.type !== QuestionType.fill &&
                                                  <div className="col-md-6 form-group">
                                                    <h6 className='questionText'>Voice Over Audio <span className="text-danger">*</span></h6>
                                                    <div className="customImgUpload mb-3">
                                                      <div className="uploadBtn">
                                                        {editQuestionData.mediaFile.audioFile.files ? (
                                                          <div className="w-100">
                                                            <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                              <audio src={editQuestionData.mediaFile.audioFile.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />
                                                              {/* <button type="button" className="bg-transparent" onClick={() => handleOptionDelete(editQuestionData.type, editQuestionData.mediaFile.audioFile.files, -1, "voice-over-audio")} >
                                                  <img src="./../assets/images/delete.svg" alt="Delete" width="24" />
                                                </button> */}

                                                            </div>
                                                            {editQuestionData.mediaFile.audioFile.files instanceof File  &&
                                                              <div className="imgName">
                                                                {editQuestionData.mediaFile.audioFile.files.name}
                                                              </div>
                                                            }
                                                          </div>
                                                        ) : (
                                                          <React.Fragment>
                                                            <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                            <label htmlFor="voice-over-audio">
                                                              Click to upload <span>mp3 or wav <br />(max 20mb)</span>
                                                            </label>
                                                            <input type="file" className="form-control d-none" id="voice-over-audio" name="voice-over-audio" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, -1, "audio")} required />
                                                            
                                                          </React.Fragment>
                                                        )}
                                                      </div>
                                                    </div>


                                                    {editQuestionData.mediaFile.audioFile.files && <div className="row justify-content-center mt-2">
                                                      <div className="col-auto">
                                                        <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, editQuestionData.mediaFile.audioFile.files, -1, "voice-over-audio", "audio")} >
                                                          <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                        </button>
                                                      </div>
                                                    </div>}

                                                  </div>
                                                )


                                              }
                                            </div>

                                            {editQuestionData.type === QuestionType.fill && <div className="row">
                                              <div className="col-md-6 form-group">
                                                <h6 className='questionText'>Voice Over Audio <span className="text-danger">*</span></h6>
                                                <div className="customImgUpload mb-3">
                                                  <div className="uploadBtn">
                                                    {editQuestionData.mediaFile.audioFile.files ? (
                                                      <div className="w-100">
                                                        <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                          <audio src={editQuestionData.mediaFile.audioFile.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />
                                                          {/* <button type="button" className="bg-transparent" onClick={() => handleOptionDelete(editQuestionData.type, editQuestionData.mediaFile.audioFile.files, -1, "voice-over-audio")} >
                                                  <img src="./../assets/images/delete.svg" alt="Delete" width="24" />
                                                </button> */}

                                                        </div>
                                                        {editQuestionData.mediaFile.audioFile.files instanceof File  &&
                                                          <div className="imgName">
                                                            {editQuestionData.mediaFile.audioFile.files.name}
                                                          </div>
                                                        }
                                                      </div>
                                                    ) : (
                                                      <React.Fragment>
                                                        <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                        <label htmlFor="voice-over-audio">
                                                          Click to upload <span>mp3 or wav <br />(max 20mb)</span>
                                                        </label>
                                                        <input type="file" className="form-control d-none" id="voice-over-audio" name="voice-over-audio" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, -1, "audio")} required />
                                                        
                                                      </React.Fragment>
                                                    )}
                                                  </div>
                                                </div>


                                                {editQuestionData.mediaFile.audioFile.files && <div className="row justify-content-center mt-2">
                                                  <div className="col-auto">
                                                    <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, editQuestionData.mediaFile.audioFile.files, -1, "voice-over-audio", "audio")} >
                                                      <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                    </button>
                                                  </div>
                                                </div>}

                                              </div>

                                              <div className="col-md-6 form-group">
                                                <h6 className='questionText'>Complete Answer Voice Over Audio <span className="text-danger">*</span></h6>
                                                <div className="customImgUpload mb-3">
                                                  <div className="uploadBtn">
                                                    {editQuestionData.mediaFile.completeAudioFile.files ? (
                                                      <div className="w-100">
                                                        <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                          <audio src={editQuestionData.mediaFile.completeAudioFile.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />

                                                        </div>
                                                        {editQuestionData.mediaFile.completeAudioFile.files instanceof File  &&
                                                          <div className="imgName">
                                                            {editQuestionData.mediaFile.completeAudioFile.files.name}
                                                          </div>
                                                        }
                                                      </div>
                                                    ) : (
                                                      <React.Fragment>
                                                        <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                        <label htmlFor="complete-voice-over-audio">
                                                          Click to upload <span>mp3 or wav <br />(max 20mb)</span>
                                                        </label>
                                                        <input type="file" className="form-control d-none" id="complete-voice-over-audio" name="complete-voice-over-audio" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, -1, "complete-audio")} required />
                                                        
                                                      </React.Fragment>
                                                    )}
                                                  </div>
                                                </div>


                                                {editQuestionData.mediaFile.completeAudioFile.files && <div className="row justify-content-center mt-2">
                                                  <div className="col-auto">
                                                    <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, editQuestionData.mediaFile.completeAudioFile.files, -1, "complete-voice-over-audio", "audio")} >
                                                      <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                    </button>
                                                  </div>
                                                </div>}

                                              </div>
                                            </div>}



                                            <div className="row">
                                              {editQuestionData.optionWithImage === OptionWithImage.no && editQuestionData.type !== QuestionType.match && editQuestionData.type !== QuestionType.dragMatch &&
                                                <div className="col-md-6 form-group">
                                                  <h6 className='questionText'>Media</h6>
                                                  <div className="customImgUpload mb-3" >
                                                    <div className="uploadBtn">
                                                      {editQuestionData.mediaFile.questionMediaFile.files ?
                                                        <div className='w-100'>
                                                          
                                                              {editQuestionData.mediaFile.questionMediaFile.fileExtension === "json" ?
                                                                <div className="imgName" onClick={() => handleOpenAnimation(editQuestionData.mediaFile.questionMediaFile.files)}>
                                                                  {editQuestionData.mediaFile.questionMediaFile.files instanceof File ? editQuestionData.mediaFile.questionMediaFile.files.name : `questionMedia.json`}
                                                                </div>
                                                                :
                                                                <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                            <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                                <img src={editQuestionData.mediaFile.questionMediaFile.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(editQuestionData.mediaFile.questionMediaFile.files)} />
                                                                

                                                            </div>
                                                          </div>
                                                              }
                                                        {editQuestionData.mediaFile.questionMediaFile.fileExtension !== "json" && editQuestionData.mediaFile.questionMediaFile.files instanceof File &&
                                                          <div className="imgName">
                                                            {editQuestionData.mediaFile.questionMediaFile.files.name}
                                                          </div>
                                                        }
                                                        </div>
                                                        :
                                                        <React.Fragment>
                                                          <img className="noimage" src={"./../assets/images/no-image-icon.png"} alt="" />
                                                          <label htmlFor={`question-media`}>Click to upload  <span>.json, .png, .jpg, .jpeg <br />(max 20mb)</span></label>
                                                          <input type="file" className={`form-control d-none`} name={`question-media`} id={`question-media`} onChange={(e) => handleOptionMedia(editQuestionData.type, e, -1, "audio")} accept=".json, .png, .jpg, .jpeg" />

                                                        </React.Fragment>
                                                      }
                                                    </div>
                                                  </div>
                                                  {editQuestionData.mediaFile.questionMediaFile.files && <div className="row justify-content-center mt-2">
                                                    <div className="col-auto">
                                                      <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, editQuestionData.mediaFile.questionMediaFile.files, -1, "question-media", "image")}>
                                                        <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                      </button>
                                                    </div>
                                                  </div>}
                                                </div>
                                              }

                                              {editQuestionData.type === QuestionType.mcq && <div className="col-md-6 form-group">
                                                <h6 className='questionText'>Voice Over Audio <span className="text-danger">*</span></h6>
                                                <div className="customImgUpload mb-3">
                                                  <div className="uploadBtn">
                                                    {editQuestionData.mediaFile.audioFile.files ? (
                                                      <div className="w-100">
                                                        <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                          <audio src={editQuestionData.mediaFile.audioFile.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />

                                                        </div>
                                                        {editQuestionData.mediaFile.audioFile.files instanceof File  &&
                                                          <div className="imgName">
                                                            {editQuestionData.mediaFile.audioFile.files.name}
                                                          </div>
                                                        }
                                                      </div>
                                                    ) : (
                                                      <React.Fragment>
                                                        <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                        <label htmlFor="voice-over-audio">
                                                          Click to upload <span>mp3 or wav <br />(max 20mb)</span>
                                                        </label>
                                                        <input type="file" className="form-control d-none" id="voice-over-audio" name="voice-over-audio" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, -1, "audio")} required />
                                                        
                                                      </React.Fragment>
                                                    )}
                                                  </div>
                                                </div>

                                                {editQuestionData.mediaFile.audioFile.files && <div className="row justify-content-center mt-2">
                                                  <div className="col-auto">
                                                    <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, editQuestionData.mediaFile.audioFile.files, -1, "voice-over-audio", "audio")} >
                                                      <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                    </button>
                                                  </div>
                                                </div>}
                                              </div>}
                                            </div>

                                            <div className="form-group">
                                              <h6 className='questionText'>Question <span className="text-danger">*</span></h6>
                                              <textarea rows={2} name={`question`} className="questionInput" placeholder={`Question`} value={editQuestionData.question} onChange={(e) => handleInput(e.target.name, e.target.value)} required />
                                              
                                            </div>

                                            <div className="row">
                                              <div className="col-md-6">
                                                <div className="form-group">
                                                  <h6 className='questionText'>Instruction (if any)</h6>
                                                  <textarea rows={3} name={`instruction`} className="questionInput" placeholder="Instruction" value={editQuestionData?.instruction ?? ""} onChange={(e) => handleInput(e.target.name, e.target.value)} />
                                                </div>
                                              </div>
                                              <div className="col-md-6">
                                                <div className="form-group">
                                                  <h6 className='questionText'>Hint (if any)</h6>
                                                  <textarea rows={3} name={`hint`} className="questionInput" placeholder="Hint" value={editQuestionData?.hint ?? ""} onChange={(e) => handleInput(e.target.name, e.target.value)} />
                                                </div>
                                              </div>
                                            </div>

                                            <div className="form-group">
                                              <h6 className='questionText'>Reward <span className="text-danger">*</span></h6>
                                              <input type='number' name="reward" className="form-control questionInput" placeholder="Reward" value={editQuestionData.reward} onChange={(e) => handleInput(e.target.name, e.target.value)} onWheel={(e: any) => e.target.blur()} />
                                            </div>






                                            {editQuestionData.type === QuestionType.mcq && editQuestionData.optionWithImage !== OptionWithImage.none && (
                                              <div className="form-group">
                                                <div className="row">
                                                  <div className="col-md-12">
                                                    <h6 className='questionText'>Options (select the checkbox if corresponding option is the answer) <span className="text-danger">*</span></h6>

                                                    {editQuestionData.options?.map((option: OptionDataType, optionIndex: number) => (
                                                      <div className="form-group" key={`option-${optionIndex}`} >

                                                        <div className="row">

                                                          

                                                          {editQuestionData.optionWithImage === OptionWithImage.yes &&
                                                            <div className="col-md-3">
                                                              <h6 className='highlightMediaText'>Option {optionIndex + 1} Image <span className="text-danger">*</span></h6>
                                                              <div className="customImgUpload mb-3">
                                                                <div className="uploadBtn">
                                                                  {option.media.imagePath.files ? (
                                                                    <div className="w-100">
                                                                      {option.media.imagePath.fileExtension === "json" ?
                                                                        <div className="imgName" style={{justifyContent: "center", textAlign: "center", color: option.isAnswer ? "#01BE8580" : "#000000"}} onClick={() => handleOpenAnimation(option.media.imagePath.files)}>
                                                                          {option.media.imagePath.files instanceof File ? option.media.imagePath.files.name : `option ${optionIndex + 1} json`}
                                                                        </div>
                                                                        :
                                                                        <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                          <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                                            <img src={option.media.imagePath.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "8vw", maxHeight: "8vh" }} onClick={() => handleOpenImage(option.media.imagePath.files)} />


                                                                          </div>
                                                                          {option.media.imagePath.fileExtension !== "json" && option.media.imagePath.files instanceof File &&
                                                                            <div className="imgName">
                                                                              {option.media.imagePath.files.name}
                                                                            </div>
                                                                          }
                                                                        </div>
                                                                      }


                                                                    </div>
                                                                  ) : (
                                                                    <React.Fragment>
                                                                      <img className="noimage" src="./../assets/images/no-image-icon.png" alt="NoImage" />
                                                                      <label htmlFor={`optionMediaFile-${optionIndex}`}>Click to upload <span>.png, .jpg, .jpeg .svg, .json <br />(max 20mb)</span></label>
                                                                      <input type="file" className="form-control d-none" id={`optionMediaFile-${optionIndex}`} accept=".png, .jpg, .jpeg, .json" onChange={(e) => handleOptionMedia(editQuestionData.type, e, optionIndex, "image")} required />
                                                                      
                                                                    </React.Fragment>
                                                                  )}
                                                                </div>
                                                              </div>
                                                              {option.media.imagePath.files && <div className="row justify-content-center mt-2">
                                                                <div className="col-auto">
                                                                  <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, option.media.imagePath.files, optionIndex, `optionMediaFile-${optionIndex}`, "image")}>
                                                                    <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                  </button>
                                                                </div>
                                                              </div>}
                                                            </div>
                                                          }



                                                          <div className={`${editQuestionData.optionWithImage === OptionWithImage.no ? "col-md-4 my-auto" : "col-md-3 my-auto"}`}>
                                                            <h6 className='highlightMediaText'>Option {optionIndex + 1} Text <span className="text-danger">*</span></h6>
                                                            <textarea rows={4} className="w-100 questionInput" id={`option-${activeDifficultyType}-${editQuestionData.category}-${option}`} value={option.optionText || ""} name={`option-${option}`} placeholder={`Option ${optionIndex + 1}`} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, optionIndex, "option")} required />
                                                            
                                                          </div>
                                                          <div className="col-md-4">
                                                            <h6 className='highlightMediaText'>Option {optionIndex + 1} VO <span className="text-danger">*</span></h6>
                                                            <div className="customImgUpload mb-3">
                                                              <div className="uploadBtn">
                                                                {option.media.audioPath.files ?
                                                                  <div className="w-100">
                                                                    <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                      <audio src={option.media.audioPath.blobPath} className="mx-auto" controls />
                                                                    </div>
                                                                    {option.media.audioPath.files instanceof File  &&
                                                                      <div className="imgName">
                                                                        {option.media.audioPath.files.name}
                                                                      </div>
                                                                    }
                                                                  </div>
                                                                  :
                                                                  <React.Fragment>
                                                                    <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                                    <label htmlFor={`audioFile${optionIndex}`}>Click to upload <span>mp3 or wav <br />(max 20mb)</span></label>
                                                                    <input type="file" className="form-control d-none" id={`audioFile${optionIndex}`} name="audioFile" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, optionIndex, "audio")} required />
                                                                    
                                                                  </React.Fragment>
                                                                }
                                                              </div>
                                                            </div>
                                                            {option.media.audioPath.files && <div className="row justify-content-center mt-2">
                                                              <div className="col-auto">

                                                                <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, option.media.audioPath.files, optionIndex, `audioFile${optionIndex}`, "audio")}>
                                                                  <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                </button>
                                                              </div>
                                                            </div>}
                                                          </div>
                                                          <div className='col-auto my-auto'>
                                                            <div className="d-flex justify-content-between">
                                                              {/* Is Answer Checkbox */}
                                                              <input type="checkbox" className="ms-3" style={{ transform: "scale(1.5)" }} checked={option.isAnswer || false} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, optionIndex, "answer")} />

                                                              {/* Delete Button */}
                                                              {editQuestionData.options && editQuestionData.options.length > 1 &&
                                                                <button className="btn border-0 ms-2" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", optionIndex, "delete")}>
                                                                  <img src="../assets/images/delete.svg" alt="Delete" width="24" />
                                                                </button>
                                                              }
                                                              {editQuestionData.options && editQuestionData.options.length - 1 === optionIndex && editQuestionData.options.length < 4 &&
                                                                <button className="btn border-0 ms-2" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", -1, "add")}>
                                                                  <img src="../assets/images/add-icon.svg" alt="add" />
                                                                </button>
                                                              }
                                                            </div>
                                                          </div>
                                                        </div>

                                                      </div>
                                                    ))}
                                                  </div>
                                                </div>
                                              </div>
                                            )}

                                            {editQuestionData.type === QuestionType.fill && editQuestionData.optionWithImage !== OptionWithImage.none && (
                                              <div className="form-group">
                                                <div className="row">
                                                  <div className="col-md-12">
                                                    <h6 className='questionText'>Options (select the checkbox if corresponding option is the answer) <span className="text-danger">*</span></h6>

                                                    {editQuestionData.blanks?.map((blank: BlankDataType, blankIndex: number) => (
                                                      <div className="form-group" key={`blank-${blankIndex}`} >
                                                        <div className="row">
                                                          {editQuestionData.optionWithImage === OptionWithImage.yes &&
                                                            <div className="col-md-3">
                                                              <h6 className='highlightMediaText'>Fill up {blankIndex + 1} Image <span className="text-danger">*</span></h6>
                                                              <div className="customImgUpload">
                                                                <div className="uploadBtn">
                                                                  {blank.media.imagePath.files ? (
                                                                    <div className="w-100">
                                                                      <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                        <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                                          <img src={blank.media.imagePath.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "8vw", maxHeight: "8vh" }} onClick={() => handleOpenImage(blank.media.imagePath.files)} />

                                                                        </div>
                                                                        {blank.media.imagePath.files instanceof File  &&
                                                                          <div className="imgName">
                                                                            {blank.media.imagePath.files.name}
                                                                          </div>
                                                                        }
                                                                      </div>


                                                                    </div>
                                                                  ) : (
                                                                    <React.Fragment>
                                                                      <img className="noimage" src="./../assets/images/no-image-icon.png" alt="NoImage" />
                                                                      <label htmlFor={`optionMediaFile-${blankIndex}`}>Click to upload <span>.png, .jpg, .jpeg <br />(max 20mb)</span></label>
                                                                      <input type="file" className="form-control d-none" id={`optionMediaFile-${blankIndex}`} accept=".png, .jpg, .jpeg" onChange={(e) => handleOptionMedia(editQuestionData.type, e, blankIndex, "image")} required />
                                                                      
                                                                    </React.Fragment>
                                                                  )}
                                                                </div>
                                                              </div>
                                                              {blank.media.imagePath.files && <div className="row justify-content-center mt-2">
                                                                <div className="col-auto">
                                                                  <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, blank.media.imagePath.files, blankIndex, `optionMediaFile-${blankIndex}`, "image")}>
                                                                    <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                  </button>
                                                                </div>
                                                              </div>}
                                                            </div>
                                                          }

                                                          <div className={`${editQuestionData.optionWithImage === OptionWithImage.no ? "col-md-6" : "col-md-4"}`}>
                                                            <h6 className='highlightMediaText'>Fill up {blankIndex + 1} VO <span className="text-danger">*</span></h6>
                                                            <div className="customImgUpload">

                                                              <div className="uploadBtn">
                                                                {blank.media.audioPath.files ?
                                                                  <div className="w-100">
                                                                    <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                      <audio src={blank.media.audioPath.blobPath} className="mx-auto" controls />
                                                                    </div>
                                                                    {blank.media.audioPath.files instanceof File  &&
                                                                      <div className="imgName">
                                                                        {blank.media.audioPath.files.name}
                                                                      </div>
                                                                    }
                                                                  </div>
                                                                  :
                                                                  <React.Fragment>
                                                                    <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                                    <label htmlFor={`audioFile${blankIndex}`}>Click to upload <span>mp3 or wav <br />(max 20mb)</span></label>
                                                                    <input type="file" className="form-control d-none" id={`audioFile${blankIndex}`} name="audioFile" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, blankIndex, "audio")} required />
                                                                    
                                                                  </React.Fragment>
                                                                }
                                                              </div>
                                                            </div>
                                                            {blank.media.audioPath.files && <div className="row justify-content-center mt-2">
                                                              <div className="col-auto">
                                                                <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, blank.media.audioPath.files, blankIndex, `audioFile${blankIndex}`, "audio")}>
                                                                  <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                </button>
                                                              </div>
                                                            </div>}
                                                          </div>

                                                          <div className={`${editQuestionData.optionWithImage === OptionWithImage.no ? "col-md-4 my-auto" : "col-md-3 my-auto"}`}>
                                                            <h6 className='highlightMediaText'>Fill up {blankIndex + 1} Text <span className="text-danger">*</span></h6>
                                                            <textarea rows={4} className="w-100 questionInput" id={`option-${activeDifficultyType}-${editQuestionData.category}-${blank}`} value={blank.blankText || ""} name={`option-${blank}`} placeholder={`Option ${blankIndex + 1}`} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, blankIndex, "option")} required />
                                                            
                                                          </div>
                                                          <div className='col-auto my-auto'>
                                                            <div className="d-flex justify-content-between">
                                                              {/* Is Answer Checkbox */}
                                                              <input type="checkbox" className="ms-3" style={{ transform: "scale(1.5)" }} checked={blank.isAnswer || false} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, blankIndex, "answer")} />

                                                              {/* Delete Button */}
                                                              {editQuestionData.blanks && editQuestionData.blanks.length > 1 &&
                                                                <button className="btn border-0 ms-2" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", blankIndex, "delete")}>
                                                                  <img src="../assets/images/delete.svg" alt="Delete" width="24" />
                                                                </button>
                                                              }
                                                              {editQuestionData.blanks && editQuestionData.blanks.length - 1 === blankIndex && editQuestionData.blanks.length < 4 &&
                                                                <button className="btn border-0 ms-2" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", -1, "add")}>
                                                                  <img src="../assets/images/add-icon.svg" alt="add" />
                                                                </button>
                                                              }
                                                            </div>
                                                          </div>
                                                        </div>

                                                      </div>
                                                    ))
                                                    }
                                                  </div>
                                                </div>
                                              </div>
                                            )}

                                            {editQuestionData.type === QuestionType.match && editQuestionData.optionWithImage !== OptionWithImage.none && (
                                              <div className="form-group">
                                                <div className="row">
                                                  <div className="col-md-12">
                                                    <h6 className='questionText'>Pairs <span className="text-danger">*</span></h6>
                                                    {editQuestionData.pairs?.map((pair: PairDataType, pairIndex: number) => (
                                                      <div key={`Pair-${pairIndex}`} className="form-group">
                                                        <div className="row">
                                                          <div className="col-md-4">
                                                            <h6 className='highlightMediaText'>Pair {pairIndex + 1} Image VO <span className="text-danger">*</span></h6>
                                                            <div className="customImgUpload">
                                                              <div className="uploadBtn">
                                                                {pair.media.audioPath.files ?
                                                                  <div className="w-100">
                                                                    <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                      <audio src={pair.media.audioPath.blobPath} className="mx-auto" controls />
                                                                    </div>
                                                                    {pair.media.audioPath.files instanceof File  &&
                                                                      <div className="imgName">
                                                                        {pair.media.audioPath.files.name}
                                                                      </div>
                                                                    }
                                                                  </div>
                                                                  :
                                                                  <React.Fragment>
                                                                    <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                                    <label htmlFor={`audioFile${pairIndex}`}>Click to upload <span>mp3 or wav <br />(max 20mb)</span></label>
                                                                    <input type="file" className="form-control d-none" id={`audioFile${pairIndex}`} name="audioFile" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, pairIndex, "audio")} required />
                                                                    
                                                                  </React.Fragment>
                                                                }
                                                              </div>
                                                            </div>
                                                            {pair.media.audioPath.files && <div className="row justify-content-center mt-2">
                                                              <div className="col-auto">
                                                                <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, pair.media.audioPath.files, pairIndex, `audioFile${pairIndex}`, "audio")}>
                                                                  <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                </button>
                                                              </div>
                                                            </div>}
                                                          </div>
                                                          {editQuestionData.optionWithImage === OptionWithImage.yes ? <div className="col-md-3">
                                                            <h6 className='highlightMediaText'>Pair {pairIndex + 1} Image <span className="text-danger">*</span></h6>
                                                            <div className="customImgUpload">
                                                              <div className="uploadBtn">
                                                                {pair.media.imagePath.files ? (
                                                                  <div className="w-100">
                                                                    <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                      <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                                        <img src={pair.media.imagePath.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(pair.media.imagePath.files)} />

                                                                      </div>
                                                                      {pair.media.imagePath.files instanceof File  &&
                                                                        <div className="imgName">
                                                                          {pair.media.imagePath.files.name}
                                                                        </div>
                                                                      }
                                                                    </div>
                                                                  </div>
                                                                ) : (
                                                                  <React.Fragment>
                                                                    <img className="noimage" src="./../assets/images/no-image-icon.png" alt="NoImage" />
                                                                    <label htmlFor={`optionMediaFile-${pairIndex}-${pairIndex}`}>
                                                                      Click to upload <span>.png, .jpg, .jpeg <br />(max 20mb)</span>
                                                                    </label>
                                                                    <input type="file" className="form-control d-none" id={`optionMediaFile-${pairIndex}-${pairIndex}`} accept=".png, .jpg, .jpeg" onChange={(e) => handleOptionMedia(editQuestionData.type, e, pairIndex, "image")} required />
                                                                    
                                                                  </React.Fragment>
                                                                )}
                                                              </div>
                                                            </div>
                                                            {pair.media.imagePath.files && <div className="row justify-content-center mt-2">
                                                              <div className="col-auto">
                                                                <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, pair.media.imagePath.files, pairIndex, `optionMediaFile-${pairIndex}-${pairIndex}`, "image")}>
                                                                  <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                </button>
                                                              </div>
                                                            </div>}
                                                          </div>
                                                            :
                                                            <div className="col-3">
                                                              <h6 className='highlightMediaText'>Pair {pairIndex + 1} Image Answer <span className="text-danger">*</span></h6>
                                                              <textarea rows={2} key={`Left-${activeDifficultyType}-${editQuestionData.category}-${pairIndex}`} className="form-control w-100 questionInput" id={`Left-${activeDifficultyType}-${editQuestionData.category}-${pairIndex}`} value={pair.leftItem} placeholder={`Left Item ${pairIndex + 1}`} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, pairIndex, "left")} required />
                                                              
                                                            </div>
                                                          }

                                                          <div className="col-3 my-auto">
                                                            <h6 className='highlightMediaText'>Pair {pairIndex + 1} Image Answer <span className="text-danger">*</span></h6>
                                                            <textarea rows={2} key={`Answer-${activeDifficultyType}-${editQuestionData.category}-${pairIndex}`} className="form-control w-100 questionInput" id={`Answer-${activeDifficultyType}-${editQuestionData.category}-${pairIndex}`} value={pair.rightItem} placeholder={`Answer to Left ${pairIndex + 1}`} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, pairIndex, "answer")} required />
                                                            
                                                          </div>
                                                          <div className="col-auto my-auto">
                                                            {editQuestionData.pairs && editQuestionData.pairs.length > 1 && (
                                                              <button className="btn border-0 ms-2" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", pairIndex, "delete")} >
                                                                <img src="../assets/images/delete.svg" alt="Delete" width="24" />
                                                              </button>
                                                            )}
                                                            {editQuestionData.pairs && pairIndex === editQuestionData.pairs.length - 1 && editQuestionData.pairs.length < 4 &&
                                                              <button className="btn border-0 ms-2" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", pairIndex, "add")} >
                                                                <img src="./../assets/images/add-icon.svg" alt="Add" width="24" />
                                                              </button>
                                                            }
                                                          </div>
                                                        </div>
                                                      </div>
                                                    ))}
                                                  </div>
                                                </div>
                                              </div>
                                            )}

                                            {editQuestionData.type === QuestionType.dragMatch && (
                                              <div className="form-group">
                                                <div className="row">
                                                  <div className="col-md-12">
                                                    <h6 className='questionText'>Drag Match Pairs <span className="text-danger">*</span></h6>
                                                    {editQuestionData.dragMatchPair?.map((dragMatchPair: DragMatchPairDataType, dragMatchIndex: number) => (
                                                      <div key={`Pair-${dragMatchIndex}`} className="form-group">
                                                        <div className="row">
                                                          <div className="col-md-3">
                                                            <h6 className='highlightMediaText'> Drag Match {dragMatchIndex + 1} Text VO <span className="text-danger">*</span></h6>
                                                            <div className="customImgUpload">
                                                              <div className="uploadBtn">
                                                                {dragMatchPair.media.audioPath.files ?
                                                                  <div className="w-100">
                                                                    <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                      <audio src={dragMatchPair.media.audioPath.blobPath} className="mx-auto" controls />
                                                                    </div>
                                                                    {dragMatchPair.media.audioPath.files instanceof File  &&
                                                                      <div className="imgName">
                                                                        {dragMatchPair.media.audioPath.files.name}
                                                                      </div>
                                                                    }
                                                                  </div>
                                                                  :
                                                                  <React.Fragment>
                                                                    <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                                    <label htmlFor={`audioFile${dragMatchIndex}`}>Click to upload <span>mp3 or wav <br />(max 20mb)</span></label>
                                                                    <input type="file" className="form-control d-none" id={`audioFile${dragMatchIndex}`} name="audioFile" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, dragMatchIndex, "audio")} required />
                                                                    
                                                                  </React.Fragment>
                                                                }
                                                              </div>
                                                            </div>
                                                            {dragMatchPair.media.audioPath.files && <div className="row justify-content-center mt-2">
                                                              <div className="col-auto">
                                                                <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, dragMatchPair.media.audioPath.files, dragMatchIndex, `audioFile${dragMatchIndex}`, "audio")}>
                                                                  <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                                </button>
                                                              </div>
                                                            </div>}
                                                          </div>
                                                          <div className="col-4 my-auto">
                                                            <h6 className='highlightMediaText'> Drag Match {dragMatchIndex + 1} Text <span className="text-danger">*</span></h6>
                                                            <textarea rows={2} key={`Option-${activeDifficultyType}-${editQuestionData.category}-${dragMatchIndex}`} className="w-100 questionInput" id={`Left-${activeDifficultyType}-${editQuestionData.category}-${dragMatchIndex}`} value={dragMatchPair.item} placeholder={`Pair ${dragMatchIndex + 1}`} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, dragMatchIndex, "option")} required />
                                                            
                                                          </div>




                                                          <div className="col-3 my-auto">
                                                            <h6 className='highlightMediaText'> Drag Match {dragMatchIndex + 1} Text Answer <span className="text-danger">*</span></h6>
                                                            <textarea rows={2} key={`Answer-${activeDifficultyType}-${editQuestionData.category}-${dragMatchIndex}`} className="w-100 questionInput" id={`Answer-${activeDifficultyType}-${editQuestionData.category}-${dragMatchIndex}`} value={dragMatchPair.answer} placeholder={`Answer ${dragMatchIndex + 1}`} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, dragMatchIndex, "answer")} required />
                                                            
                                                          </div>
                                                          <div className="col-auto my-auto">
                                                            {editQuestionData.dragMatchPair && editQuestionData.dragMatchPair.length > 1 &&
                                                              <button className="btn border-0" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", dragMatchIndex, "delete")} >
                                                                <img src="../assets/images/delete.svg" alt="Delete" width="24" />
                                                              </button>
                                                            }

                                                            {editQuestionData.dragMatchPair && editQuestionData.dragMatchPair.length - 1 === dragMatchIndex && editQuestionData.dragMatchPair.length < 6 &&
                                                              <button className="btn border-0" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", dragMatchIndex, "add")} >
                                                                <img src="../assets/images/add-icon.svg" alt="Add" width="24" />
                                                              </button>
                                                            }
                                                          </div>
                                                        </div>
                                                      </div>
                                                    ))}
                                                  </div>
                                                </div>
                                              </div>
                                            )}



                                          </div>
                                          <div className="d-flex justify-content-end p-3">
                                            <button type="button" className="btn btn-save btnPurple" style={{ width: '250px' }} onClick={validateQuestionData}>Save</button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                }

                              </div>
                              {allQuestionData.length > 0 ?
                                allQuestionData.map((questionData: QuestionDataType, index: number) => (
                                  // questionData.type === QuestionType.mcq &&
                                  <div key={questionData.id} id={questionData.id}>
                                    <div className="unitQustLists mb-4">
                                      <div className="unitQustLists">
                                        <div className='listHead'>
                                          <div className="row mb-2">
                                            {editQuestionData.id === questionData.id ? (
                                              <div className="col-10 form-group mb-3">
                                                <h6 className='highlightMediaText'>Question <span className="text-danger">*</span></h6>
                                                <textarea rows={2} name={`question-${activeDifficultyType}-${index}`} className="questionInput" placeholder="Question" value={editQuestionData.question} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, -1, "question")} required />
                                                
                                              </div>
                                            ) : (
                                              <div className="col-10">
                                                <pre className="quesText">{indexOfFirstItem + index + 1} - {questionData.question}</pre>
                                                {/* <p className="quesText">{index + 1} - {questionData.question} - {questionData.id} - {questionData.type}</p> */}

                                              </div>
                                            )}

                                            {!editQuestionData.id && !showAddQuestion &&
                                              <div className="col-2">
                                                <div className="d-flex justify-content-end">
                                                  <button className="btn" style={{ flexShrink: 0 }} type="button" data-bs-toggle="collapse" data-bs-target={`#question-mcq-fill-${questionData.id}`} aria-expanded="false" aria-controls={`question-mcq-fill-${questionData.id}`}>
                                                    <img src="./../assets/images/chevron-down-M.svg" alt="" />
                                                  </button>



                                                  <div className="dropdown dots">
                                                    <button className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" >
                                                      <img src='./../assets/images/more.svg' alt='action button' />
                                                    </button>
                                                    <ul className="dropdown-menu">
                                                      <li>
                                                        <button className="dropdown-item" onClick={() => handleEditQuestion(questionData)}>
                                                          <img src="./../assets/images/edit-icon.png" alt="" className="me-2" />
                                                          Edit
                                                        </button>
                                                      </li>
                                                      <li>
                                                        <button className="dropdown-item" style={{ cursor: 'pointer' }} onClick={() => handleDeleteByQuestionId(questionData)} >
                                                          <img src="./../assets/images/delete.png" alt="" className="me-2" />
                                                          Delete
                                                        </button>
                                                      </li>
                                                    </ul>
                                                  </div>
                                                </div>
                                              </div>}



                                          </div>

                                          {editQuestionData.id === questionData.id ? (
                                            <div>
                                              {(editQuestionData.type === QuestionType.mcq || editQuestionData.type === QuestionType.fill) ? <h6 className='highlightMediaText mt-3'>Option <span className="text-danger">*</span></h6> : editQuestionData.type === QuestionType.match ? <h6 className='highlightMediaText mt-3'>Pairs <span className="text-danger">*</span></h6> : editQuestionData.type === QuestionType.dragMatch ? <h6 className='highlightMediaText mt-3'>Drag Match Pairs <span className="text-danger">*</span></h6> : ""}
                                              {editQuestionData.blanks?.map((blank: BlankDataType, blankIndex: number) => (
                                                <div className="form-group" key={`blank-${blankIndex}`} >

                                                  <div className="row">

                                                    {editQuestionData.optionWithImage === OptionWithImage.yes &&
                                                      <div className="col-md-2">
                                                        <h6 className='highlightMediaText'> Fill up {blankIndex + 1} Image <span className="text-danger">*</span></h6>
                                                        <div className="customImgUpload">
                                                          <div className="uploadBtn">
                                                            {blank.media.imagePath.files ? (
                                                              <div className="w-100">
                                                                <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                  <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                                    <img src={blank.media.imagePath.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "8vw", maxHeight: "8vh" }} onClick={() => handleOpenImage(blank.media.imagePath.files)} />

                                                                  </div>
                                                                </div>
                                                                {blank.media.imagePath.files instanceof File  &&
                                                                  <div className="imgName">
                                                                    {blank.media.imagePath.files.name}
                                                                  </div>
                                                                }

                                                              </div>
                                                            ) : (
                                                              <React.Fragment>
                                                                <img className="noimage" src="./../assets/images/no-image-icon.png" alt="NoImage" />
                                                                <label htmlFor={`optionMediaFile-${blankIndex}`}>Click to upload <span>.png, .jpg, .jpeg <br />(max 20mb)</span></label>
                                                                <input type="file" className="form-control d-none" id={`optionMediaFile-${blankIndex}`} accept=".png, .jpg, .jpeg" onChange={(e) => handleOptionMedia(editQuestionData.type, e, blankIndex, "image")} required />
                                                                
                                                              </React.Fragment>
                                                            )}
                                                          </div>
                                                        </div>
                                                        {blank.media.imagePath.files && <div className="row justify-content-center mt-2">
                                                          <div className="col-auto">
                                                            <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, blank.media.imagePath.files, blankIndex, `optionMediaFile-${blankIndex}`, "image")}>
                                                              <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                            </button>
                                                          </div>
                                                        </div>}
                                                      </div>
                                                    }

                                                    <div className={`${editQuestionData.optionWithImage === OptionWithImage.no ? "col-md-6" : "col-md-4"}`}>
                                                      <h6 className='highlightMediaText'> Fill up {blankIndex + 1} VO <span className="text-danger">*</span></h6>
                                                      <div className="customImgUpload">
                                                        <div className="uploadBtn">
                                                          {blank.media.audioPath.files ?
                                                            <div className="w-100">
                                                              <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                <audio src={blank.media.audioPath.blobPath} className="mx-auto" controls />
                                                                
                                                              </div>
                                                              {blank.media.audioPath.files instanceof File  &&
                                                                <div className="imgName">
                                                                  {blank.media.audioPath.files.name}
                                                                </div>
                                                              }
                                                            </div>
                                                            :
                                                            <React.Fragment>
                                                              <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                              <label htmlFor={`audioFile${blankIndex}`}>Click to upload <span>mp3 or wav <br />(max 20mb)</span></label>
                                                              <input type="file" className="form-control d-none" id={`audioFile${blankIndex}`} name="audioFile" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, blankIndex, "audio")} required />
                                                              
                                                            </React.Fragment>
                                                          }
                                                        </div>
                                                      </div>
                                                      {blank.media.audioPath.files && <div className="row justify-content-center mt-2">
                                                        <div className="col-auto">
                                                          <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, blank.media.audioPath.files, blankIndex, `audioFile${blankIndex}`, "audio")}>
                                                            <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                          </button>
                                                        </div>
                                                      </div>}
                                                    </div>

                                                    <div className={`${editQuestionData.optionWithImage === OptionWithImage.no ? "col-md-4 my-auto" : "col-md-3 my-auto"}`}>
                                                      <h6 className='highlightMediaText'> Fill up {blankIndex + 1} Text <span className="text-danger">*</span></h6>
                                                      <textarea rows={2} className="w-100 questionInput" id={`option-${activeDifficultyType}-${editQuestionData.category}-${blank}`} value={blank.blankText || ""} name={`option-${blank}`} placeholder={`Option ${blankIndex + 1}`} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, blankIndex, "option")} required />
                                                      
                                                    </div>
                                                    <div className='col-auto my-auto'>
                                                      <div className="d-flex justify-content-between">
                                                        {/* Is Answer Checkbox */}
                                                        <input type="checkbox" className="ms-3" style={{ transform: "scale(1.5)" }} checked={blank.isAnswer || false} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, blankIndex, "answer")} />

                                                        {/* Delete Button */}
                                                        {editQuestionData.blanks && editQuestionData.blanks.length > 1 &&
                                                          <button className="btn border-0 ms-2" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", blankIndex, "delete")}>
                                                            <img src="../assets/images/delete.svg" alt="Delete" width="24" />
                                                          </button>
                                                        }
                                                        {editQuestionData.blanks && editQuestionData.blanks.length - 1 === blankIndex && editQuestionData.blanks.length < 4 &&
                                                          <button className="btn border-0 ms-2" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", -1, "add")}>
                                                            <img src="../assets/images/add-icon.svg" alt="add" />
                                                          </button>
                                                        }
                                                      </div>
                                                    </div>
                                                  </div>

                                                </div>
                                              ))}

                                              {editQuestionData.options?.map((option: OptionDataType, optionIndex: number) => (
                                                <div className="form-group" key={`option-${optionIndex}`} >
                                                  <div className="row">
                                                    <div className="col-md-4">
                                                      <h6 className='highlightMediaText'> Option {optionIndex + 1} VO <span className="text-danger">*</span></h6>
                                                      <div className="customImgUpload mb-3">
                                                        <div className="uploadBtn">
                                                          {option.media.audioPath.files ?
                                                            <div className="w-100">
                                                              <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                <audio src={option.media.audioPath.blobPath} className="mx-auto" controls />
                                                              </div>
                                                              {option.media.audioPath.files instanceof File  &&
                                                                <div className="imgName">
                                                                  {option.media.audioPath.files.name}
                                                                </div>
                                                              }
                                                            </div>
                                                            :
                                                            <React.Fragment>
                                                              <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                              <label htmlFor={`audioFile${optionIndex}`}>Click to upload <span>mp3 or wav <br />(max 20mb)</span></label>
                                                              <input type="file" className="form-control d-none" id={`audioFile${optionIndex}`} name="audioFile" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, optionIndex, "audio")} required />
                                                              
                                                            </React.Fragment>
                                                          }
                                                        </div>
                                                      </div>
                                                      {option.media.audioPath.files && <div className="row justify-content-center mt-2">
                                                        <div className="col-auto">
                                                          <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, option.media.audioPath.files, optionIndex, `audioFile${optionIndex}`, "audio")}>
                                                            <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                          </button>
                                                        </div>
                                                      </div>}
                                                    </div>

                                                    {editQuestionData.optionWithImage === OptionWithImage.yes &&
                                                      <div className="col-md-2">
                                                        <h6 className='highlightMediaText'> Option {optionIndex + 1} Image <span className="text-danger">*</span></h6>
                                                        <div className="customImgUpload mb-3">
                                                          <div className="uploadBtn">
                                                            {option.media.imagePath.files ? (
                                                              <div className="w-100">
                                                                    {option.media.imagePath.fileExtension === "json" ?
                                                                      <div className="imgName" style={{justifyContent: "center", textAlign: "center", color: option.isAnswer ? "#01BE8580" : "#000000"}} onClick={() => handleOpenAnimation(option.media.imagePath.files)}>
                                                                          {option.media.imagePath.files instanceof File ? option.media.imagePath.files.name : `option ${optionIndex + 1} json`}
                                                                        </div>
                                                                      :
                                                                      
                                                                <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                  <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                                      <img src={option.media.imagePath.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "8vw", maxHeight: "8vh" }} onClick={() => handleOpenImage(option.media.imagePath.files)} />

                                                                  </div>
                                                                </div>
                                                                    }
                                                                {option.media.imagePath.fileExtension !== "json" && option.media.imagePath.files instanceof File &&
                                                                  <div className="imgName">
                                                                    {option.media.imagePath.files.name}
                                                                  </div>
                                                                }

                                                              </div>
                                                            ) : (
                                                              <React.Fragment>
                                                                <img className="noimage" src="./../assets/images/no-image-icon.png" alt="NoImage" />
                                                                <label htmlFor={`optionMediaFile-${optionIndex}`}>Click to upload <span>png, jpg, jpeg, or json <br />(max 20mb)</span></label>
                                                                <input type="file" className="form-control d-none" id={`optionMediaFile-${optionIndex}`} accept=".png, .jpg, .jpeg, .json" onChange={(e) => handleOptionMedia(editQuestionData.type, e, optionIndex, "image")} required />
                                                                
                                                              </React.Fragment>
                                                            )}
                                                          </div>
                                                        </div>
                                                        {option.media.imagePath.files && <div className="row justify-content-center mt-2">
                                                          <div className="col-auto">
                                                            <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, option.media.imagePath.files, optionIndex, `optionMediaFile-${optionIndex}`, "image")}>
                                                              <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                            </button>
                                                          </div>
                                                        </div>}
                                                      </div>
                                                    }



                                                    <div className={`${editQuestionData.optionWithImage === OptionWithImage.no ? "col-md-4 my-auto" : "col-md-3 my-auto"}`}>
                                                      <h6 className='highlightMediaText'> Option {optionIndex + 1} Text <span className="text-danger">*</span></h6>
                                                      <textarea rows={2} className="w-100 questionInput" id={`option-${activeDifficultyType}-${editQuestionData.category}-${option}`} value={option.optionText || ""} name={`option-${option}`} placeholder={`Option ${optionIndex + 1}`} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, optionIndex, "option")} required />
                                                      
                                                    </div>
                                                    <div className='col-auto my-auto'>
                                                      <div className="d-flex justify-content-between">
                                                        {/* Is Answer Checkbox */}
                                                        <input type="checkbox" className="ms-3" style={{ transform: "scale(1.5)" }} checked={option.isAnswer || false} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, optionIndex, "answer")} />

                                                        {/* Delete Button */}
                                                        {editQuestionData.options && editQuestionData.options.length > 1 &&
                                                          <button className="btn border-0 ms-2" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", optionIndex, "delete")}>
                                                            <img src="../assets/images/delete.svg" alt="Delete" width="24" />
                                                          </button>
                                                        }
                                                        {editQuestionData.options && editQuestionData.options.length - 1 === optionIndex && editQuestionData.options.length < 4 &&
                                                          <button className="btn border-0 ms-2" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", -1, "add")}>
                                                            <img src="../assets/images/add-icon.svg" alt="add" />
                                                          </button>
                                                        }
                                                      </div>
                                                    </div>
                                                  </div>

                                                </div>
                                              ))}

                                              {editQuestionData.pairs?.map((pair: PairDataType, pairIndex: number) => (
                                                <div key={`Pair-${pairIndex}`} className="form-group">
                                                  <div className="row">
                                                    <div className="col-md-4">
                                                      <h6 className='highlightMediaText'> Pair {pairIndex + 1} Image VO <span className="text-danger">*</span></h6>
                                                      <div className="customImgUpload">
                                                        <div className="uploadBtn">
                                                          {pair.media.audioPath.files ?
                                                            <div className="w-100">
                                                              <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                <audio src={pair.media.audioPath.blobPath} className="mx-auto" controls />
                                                              </div>
                                                              {pair.media.audioPath.files instanceof File  &&
                                                                <div className="imgName">
                                                                  {pair.media.audioPath.files.name}
                                                                </div>
                                                              }
                                                            </div>
                                                            :
                                                            <React.Fragment>
                                                              <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                              <label htmlFor={`audioFile${pairIndex}`}>Click to upload <span>mp3 or wav <br />(max 20mb)</span></label>
                                                              <input type="file" className="form-control d-none" id={`audioFile${pairIndex}`} name="audioFile" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, pairIndex, "audio")} required />
                                                              
                                                            </React.Fragment>
                                                          }
                                                        </div>
                                                      </div>
                                                      {pair.media.audioPath.files && <div className="row justify-content-center mt-2">
                                                        <div className="col-auto">
                                                          <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, pair.media.audioPath.files, pairIndex, `audioFile${pairIndex}`, "audio")}>
                                                            <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                          </button>
                                                        </div>
                                                      </div>}
                                                    </div>
                                                    {editQuestionData.optionWithImage === OptionWithImage.yes ? <div className="col-md-3">
                                                      <h6 className='highlightMediaText'> Pair {pairIndex + 1} Image <span className="text-danger">*</span></h6>
                                                      <div className="customImgUpload">
                                                        <div className="uploadBtn">
                                                          {pair.media.imagePath.files ? (
                                                            <div className="w-100">
                                                              <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                                  <img src={pair.media.imagePath.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(pair.media.imagePath.files)} />
                                                                </div>
                                                              </div>
                                                              {pair.media.imagePath.files instanceof File  &&
                                                                        <div className="imgName">
                                                                          {pair.media.imagePath.files.name}
                                                                        </div>
                                                                      }
                                                            </div>
                                                          ) : (
                                                            <React.Fragment>
                                                              <img className="noimage" src="./../assets/images/no-image-icon.png" alt="NoImage" />
                                                              <label htmlFor={`optionMediaFile-${pairIndex}-${pairIndex}`}>
                                                                Click to upload <span>.png, .jpg, .jpeg <br />(max 20mb)</span>
                                                              </label>
                                                              <input type="file" className="form-control d-none" id={`optionMediaFile-${pairIndex}-${pairIndex}`} accept=".png, .jpg, .jpeg" onChange={(e) => handleOptionMedia(editQuestionData.type, e, pairIndex, "image")} required />
                                                              
                                                            </React.Fragment>
                                                          )}
                                                        </div>
                                                      </div>
                                                      {pair.media.imagePath.files && <div className="row justify-content-center mt-2">
                                                        <div className="col-auto">
                                                          <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, pair.media.imagePath.files, pairIndex, `optionMediaFile-${pairIndex}-${pairIndex}`, "image")}>
                                                            <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                          </button>
                                                        </div>
                                                      </div>}
                                                    </div>
                                                      :
                                                      <div className="col-3">
                                                        <h6 className='highlightMediaText'> Pair {pairIndex + 1} Left Text <span className="text-danger">*</span></h6>
                                                        <textarea rows={2} key={`Left-${activeDifficultyType}-${editQuestionData.category}-${pairIndex}`} className="w-100 questionInput" id={`Left-${activeDifficultyType}-${editQuestionData.category}-${pairIndex}`} value={pair.leftItem} placeholder={`Left Item ${pairIndex + 1}`} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, pairIndex, "left")} required />
                                                        
                                                      </div>
                                                    }

                                                    <div className="col-3 my-auto">
                                                      <h6 className='highlightMediaText'> Pair {pairIndex + 1} Answer <span className="text-danger">*</span></h6>
                                                      <textarea
                                                        key={`Answer-${activeDifficultyType}-${editQuestionData.category}-${pairIndex}`}
                                                        className="w-100 questionInput"
                                                        id={`Answer-${activeDifficultyType}-${editQuestionData.category}-${pairIndex}`}
                                                        value={pair.rightItem}
                                                        placeholder={`Answer to Left ${pairIndex + 1}`}
                                                        rows={2} // show 4 lines by default
                                                        style={{ resize: "vertical", overflow: "auto" }}
                                                        onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, pairIndex, "answer")}
                                                        required
                                                      />
                                                      
                                                    </div>

                                                    <div className="col-auto my-auto">
                                                      {editQuestionData.pairs && editQuestionData.pairs.length > 1 && (
                                                        <button className="btn border-0 ms-2" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", pairIndex, "delete")} >
                                                          <img src="../assets/images/delete.svg" alt="Delete" width="24" />
                                                        </button>
                                                      )}
                                                      {editQuestionData.pairs && pairIndex === editQuestionData.pairs.length - 1 && editQuestionData.pairs.length < 4 &&
                                                        <button className="btn border-0 ms-2" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", pairIndex, "add")} >
                                                          <img src="./../assets/images/add-icon.svg" alt="Add" width="24" />
                                                        </button>
                                                      }
                                                    </div>
                                                  </div>
                                                </div>
                                              ))}

                                              {editQuestionData.dragMatchPair?.map((dragMatchPair: DragMatchPairDataType, dragMatchIndex: number) => (
                                                <div key={`Pair-${dragMatchIndex}`} className="form-group">
                                                  <div className="row">
                                                    <div className="col-md-3">
                                                      <h6 className='highlightMediaText'> Drag match {dragMatchIndex + 1} Text VO <span className="text-danger">*</span></h6>
                                                      <div className="customImgUpload">
                                                        <div className="uploadBtn">
                                                          {dragMatchPair.media.audioPath.files ?
                                                            <div className="w-100">
                                                              <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                <audio src={dragMatchPair.media.audioPath.blobPath} className="mx-auto" controls />
                                                              </div>
                                                              {dragMatchPair.media.audioPath.files instanceof File  &&
                                                                <div className="imgName">
                                                                  {dragMatchPair.media.audioPath.files.name}
                                                                </div>
                                                              }
                                                            </div>
                                                            :
                                                            <React.Fragment>
                                                              <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                              <label htmlFor={`audioFile${dragMatchIndex}`}>Click to upload <span>mp3 or wav <br />(max 20mb)</span></label>
                                                              <input type="file" className="form-control d-none" id={`audioFile${dragMatchIndex}`} name="audioFile" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, dragMatchIndex, "audio")} required />
                                                              
                                                            </React.Fragment>
                                                          }
                                                        </div>
                                                      </div>
                                                      {dragMatchPair.media.audioPath.files && <div className="row justify-content-center mt-2">
                                                        <div className="col-auto">
                                                          <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, dragMatchPair.media.audioPath.files, dragMatchIndex, `audioFile${dragMatchIndex}`, "audio")}>
                                                            <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                          </button>
                                                        </div>
                                                      </div>}
                                                    </div>
                                                    <div className="col-4 my-auto">
                                                      <h6 className='highlightMediaText'> Drag Match{dragMatchIndex + 1} Text <span className="text-danger">*</span></h6>
                                                      <textarea rows={2} key={`Option-${activeDifficultyType}-${editQuestionData.category}-${dragMatchIndex}`} className="w-100 questionInput" id={`Left-${activeDifficultyType}-${editQuestionData.category}-${dragMatchIndex}`} value={dragMatchPair.item} placeholder={`Pair ${dragMatchIndex + 1}`} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, dragMatchIndex, "option")} required />
                                                      
                                                    </div>




                                                    <div className="col-3 my-auto">
                                                      <h6 className='highlightMediaText'> Drag Match {dragMatchIndex + 1} Text Answer<span className="text-danger">*</span></h6>
                                                      <textarea rows={2} key={`Answer-${activeDifficultyType}-${editQuestionData.category}-${dragMatchIndex}`} className="w-100 questionInput" id={`Answer-${activeDifficultyType}-${editQuestionData.category}-${dragMatchIndex}`} value={dragMatchPair.answer} placeholder={`Answer ${dragMatchIndex + 1}`} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, dragMatchIndex, "answer")} required />
                                                      
                                                    </div>
                                                    <div className="col-auto my-auto">
                                                      {editQuestionData.dragMatchPair && editQuestionData.dragMatchPair.length > 1 &&
                                                        <button className="btn border-0" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", dragMatchIndex, "delete")} >
                                                          <img src="../assets/images/delete.svg" alt="Delete" width="24" />
                                                        </button>
                                                      }

                                                      {editQuestionData.dragMatchPair && editQuestionData.dragMatchPair.length - 1 === dragMatchIndex && editQuestionData.dragMatchPair.length < 6 &&
                                                        <button className="btn border-0" type="button" onClick={() => handleQuestionInput(editQuestionData.type, "", dragMatchIndex, "add")} >
                                                          <img src="../assets/images/add-icon.svg" alt="Add" width="24" />
                                                        </button>
                                                      }
                                                    </div>
                                                  </div>
                                                </div>
                                              ))}
                                            </div>
                                          ) : (
                                            <React.Fragment>
                                              <div className="row">
                                                {questionData.options?.map((option, i) => (
                                                  (questionData.options && <div key={i} className={`col-md-${Math.floor(12 / questionData.options.length)} mb-3`}>
                                                    {option.media.imagePath.files ? (
                                                      <div>
                                                          {option.media.imagePath.fileExtension === "json" ? (
                                                            <div className="imgName" style={{justifyContent: "center", textAlign: "center", color: option.isAnswer ? "#01BE8580" : "#000000"}} onClick={() => handleOpenAnimation(option.media.imagePath.files)}>
                                                              {option.media.imagePath.files instanceof File ? option.media.imagePath.files.name : `option ${i + 1} json`}
                                                            </div>
                                                          ) : (
                                                            
                                                        <div className='mb-3' style={{ background: option.isAnswer ? "#01BE8580" : "", border: option.isAnswer ? "1px solid #005B51" : "", borderRadius: option.isAnswer ? "20px" : "", width: "100px", height: "100px", margin: "0px auto" }} >
                                                            <img src={option.media.imagePath.blobPath} alt={option.optionText} onClick={() => handleOpenImage(option.media.imagePath.files)} />
                                                            
                                                        </div>
                                                          )}
                                                        <pre className={`matchClass ${option.isAnswer ? "greenText" : ""}`} style={{ border: "1px solid rgba(0, 0, 0, 0.1)", padding: "2% 0 1% 4%", borderRadius: "10px", whiteSpace: "normal", width: "100%", overflow: "hidden" }}>{option.optionText}</pre>
                                                      </div>
                                                    ) : (
                                                      <pre className={`matchClass ${option.isAnswer ? "greenText" : ""}`} style={{ border: "1px solid rgba(0, 0, 0, 0.1)", padding: "2% 0 1% 4%", borderRadius: "10px", whiteSpace: "normal", width: "100%", overflow: "hidden" }}>{option.optionText}</pre>
                                                    )}
                                                  </div>)
                                                ))}
                                                {questionData.blanks?.map((blank, i) => (
                                                  <div key={i} className={`col-md-${12 / (questionData.blanks?.length ?? 1)} mb-3`}>
                                                    {blank.media.imagePath.files ?
                                                      <div style={{ maxWidth: "100%", width: "auto" }}>
                                                        <img src={blank.media.imagePath.files} style={{ height: "200px" }} className={`${blank.isAnswer ? "hightlightImage" : ""}`} onClick={() => handleOpenImage(blank.media.imagePath.files)} alt={blank.blankText} />
                                                      </div>
                                                      :
                                                      <pre className={`matchClass ${blank.isAnswer ? "greenText" : ""}`} style={{ border: "1px solid rgba(0, 0, 0, 0.1)", padding: "2% 0 1% 4%", borderRadius: "10px", whiteSpace: "normal", width: "100%", overflow: "hidden" }}>{blank.blankText}</pre>
                                                    }

                                                  </div>
                                                ))}

                                                {(() => {
                                                  const pairs = questionData.pairs || [];
                                                  const groupedElements: JSX.Element[] = [];

                                                  for (let i = 0; i < pairs.length; i += 4) {
                                                    const group = pairs.slice(i, i + 4);

                                                    groupedElements.push(
                                                      <div key={`Top-Row-${i}`} className="row mb-2">
                                                        {group.map((pair) => (
                                                          <div className="col-3 mb-2" key={`Top-${pair.id}`}>
                                                            {questionData.optionWithImage === OptionWithImage.yes ? (
                                                              <div style={{ maxWidth: "100%", width: "auto" }} >
                                                                <img src={pair.media.imagePath.blobPath} alt={pair.leftItem} style={{ width: "100%", height: "auto" }} onClick={() => handleOpenImage(pair.media.imagePath.files)} />
                                                              </div>
                                                            ) : (
                                                              <pre className="form-control matchClass" style={{ background: "#F0F2F6", border: "1px solid rgba(0, 0, 0, 0.1)", padding: "2% 0 1% 4%", borderRadius: "10px", whiteSpace: "normal", width: "100%", overflow: "hidden" }}> {pair.leftItem}</pre>
                                                            )}
                                                          </div>
                                                        ))}
                                                      </div>
                                                    );

                                                    groupedElements.push(
                                                      <div key={`Bottom-Row-${i}`} className="row mb-4">
                                                        {group.map((pair) => (
                                                          <div className="col-3" key={`Bottom-${pair.id}`}>
                                                            <pre className="matchClass" style={{ background: "#F0F2F6", border: "1px solid rgba(0, 0, 0, 0.1)", padding: "2% 0 1% 4%", borderRadius: "10px", whiteSpace: "normal", width: "100%", overflow: "hidden" }}>{pair.rightItem}</pre>
                                                          </div>
                                                        ))}
                                                      </div>
                                                    );
                                                  }

                                                  return groupedElements;
                                                })()}


                                                {questionData.dragMatchPair?.map((dragMatch: DragMatchPairDataType, pairIndex: number) => (
                                                  <div key={`Pair-${dragMatch.id}`} className="row mb-3">
                                                    <div className="col">
                                                      <pre className="matchClass" style={{ background: "#F0F2F6", border: "1px solid rgba(0, 0, 0, 0.1)", padding: "2% 0 1% 4%", borderRadius: "10px", whiteSpace: "normal", width: "100%", overflow: "hidden" }}>{dragMatch.item}</pre>
                                                    </div>
                                                    <div className="col">
                                                      <pre className="matchClass" style={{ background: "#F0F2F6", border: "1px solid rgba(0, 0, 0, 0.1)", padding: "2% 0 1% 4%", borderRadius: "10px", whiteSpace: "normal", width: "100%", overflow: "hidden" }}>{dragMatch.answer}</pre>
                                                    </div>
                                                  </div>
                                                ))}
                                              </div>
                                            </React.Fragment>
                                          )}
                                        </div>
                                      </div>

                                      <div className={questionData.id === editQuestionData.id ? "collapse show" : "collapse"} id={`question-mcq-fill-${questionData.id}`}>

                                        <div className="card card-body bg-transparent" style={{ border: 0 }}>
                                          <div className="row mb-2">
                                            <div className="col-3">
                                              <div className="form-group">
                                                <h6 className='highlightMediaText'>Level1</h6>
                                                <input type="text" name="" className="form-control opactity5 questionInput" placeholder="Level" value={questionData.level} readOnly />
                                              </div>
                                            </div>

                                            <div className="col-3">
                                              <div className="form-group">
                                                <h6 className='highlightMediaText'>Question Type</h6>
                                                <input type="text" name="" className="form-control opactity5 questionInput" placeholder="Question Type" value={questionData.type} readOnly />
                                              </div>
                                            </div>

                                            {(questionData.id === editQuestionData.id && editQuestionData.type === QuestionType.mcq) &&
                                              <div className='col-3 form-group'>
                                                <h6 className='questionText'>Option with Image <span className="text-danger">*</span></h6>
                                                <select className="form-select questionInput" name="optionWithImage" value={editQuestionData.optionWithImage ?? ""} onChange={(e) => handleInput(e.target.name, e.target.value)} required >
                                                  <option value="" disabled>
                                                    Select
                                                  </option>
                                                  <option value={OptionWithImage.yes}>Yes</option>
                                                  <option value={OptionWithImage.no}>No</option>
                                                </select>
                                                

                                              </div>
                                            }
                                          </div>

                                          <div className="row mb-3">
                                            <div className="col-3">
                                              <div className="form-group">
                                                <h6 className='highlightMediaText'>Lesson</h6>
                                                <input type="text" name="Unit" className="form-control opactity5 questionInput" placeholder="Unit" value={unitData.unitLesson.name} readOnly />
                                              </div>
                                            </div>
                                            <div className="col-3">
                                              <div className="form-group">
                                                <h6 className='highlightMediaText'>Unit</h6>
                                                <input type="text" name="Unit" className="form-control questionInput opactity5" placeholder="Unit" value={unitData.unitName} readOnly />
                                              </div>
                                            </div>
                                            <div className="col-3">
                                              <div className="form-group">
                                                <h6 className='highlightMediaText'>Grade</h6>
                                                <input type="text" name="Unit" className="form-control questionInput opactity5" placeholder="Unit" value={unitData.grade.gradeName} readOnly />
                                              </div>
                                            </div>
                                          </div>

                                          <div className="row mb-3">

                                          </div>

                                          <div className="row mb-3">
                                            {(questionData.id === editQuestionData.id) ?
                                              <div className="col-5">
                                                <div className="form-group">
                                                  <h6 className='highlightMediaText'>Instruction (if any)</h6>
                                                  <textarea rows={4} name="instruction" className="questionInput" placeholder="Instruction (if any)" value={editQuestionData.id ? editQuestionData.instruction : questionData.instruction} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, -1, "instruction")} maxLength={255} />
                                                </div>
                                              </div>
                                              :
                                              ((questionData.instruction && <div className="col-5">
                                                <div className="form-group">
                                                  <h6 className='highlightMediaText'>Instruction</h6>
                                                  <pre className="matchClass" style={{ background: "#F0F2F6", border: "1px solid rgba(0, 0, 0, 0.1)", padding: "2% 0 1% 4%", borderRadius: "10px", whiteSpace: "normal", width: "100%", overflow: "hidden" }}>{questionData.instruction}</pre>
                                                </div>
                                              </div>))
                                            }
                                            {(questionData.id === editQuestionData.id) ?
                                              <div className="col-5">
                                                <div className="form-group">
                                                  <h6 className='highlightMediaText'>Hint (if any)</h6>
                                                  <textarea rows={4} name="hint" className="questionInput" placeholder="Hint (if any)" value={editQuestionData.id ? editQuestionData.hint : questionData.hint} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, -1, "hint")} maxLength={500} />
                                                </div>
                                              </div>
                                              :
                                              (questionData.hint && <div className="col-5">
                                                <div className="form-group">
                                                  <h6 className='highlightMediaText'>Hint</h6>
                                                  <pre className="matchClass" style={{ background: "#F0F2F6", border: "1px solid rgba(0, 0, 0, 0.1)", padding: "2% 0 1% 4%", borderRadius: "10px", whiteSpace: "normal", width: "100%", overflow: "hidden" }}>{questionData.hint}</pre>
                                                </div>
                                              </div>)
                                            }
                                          </div>

                                          <div className="row mb-3">
                                            {(questionData.id === editQuestionData.id) ?
                                              <div className="col-5">
                                                <div className="form-group">
                                                  <h6 className='highlightMediaText'>Reward</h6>
                                                  <input type='number' name="reward" className="form-control questionInput" placeholder="Reward" value={editQuestionData.reward} onChange={(e) => handleQuestionInput(editQuestionData.type, e.target.value, -1, "reward")} onWheel={(e: any) => e.target.blur()} required />
                                                </div>
                                              </div>
                                              :
                                              <div className="col-5">
                                                <div className="form-group">
                                                  <h6 className='highlightMediaText'>Reward</h6>
                                                  <input type='number' name="reward" className="form-control questionInput" placeholder="Reward" value={questionData.reward} readOnly />
                                                </div>
                                              </div>
                                            }
                                          </div>


                                          {questionData.id !== editQuestionData.id &&
                                            <div className="row">
                                              {editQuestionData.mediaFile.questionMediaFile.files &&
                                                <div className="col-md-6">
                                                  <div className="form-group">
                                                    <h6 className='highlightMediaText'>Media</h6>
                                                    <div className="customImgUpload">
                                                      <div className="uploadBtn">
                                                        <div className="w-100">
                                                          <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                            <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                              <img src={editQuestionData.mediaFile.questionMediaFile.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} />

                                                            </div>
                                                            {questionData.id === editQuestionData.id &&
                                                              <button type="button" className="bg-transparent" onClick={() => handleOptionDelete(editQuestionData.type, editQuestionData.mediaFile.questionMediaFile.files, index, "question-media", "image")}>
                                                                <img src="./../assets/images/delete.svg" alt="Delete" width="24" />
                                                              </button>
                                                            }

                                                          </div>

                                                        </div>

                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>}
                                            </div>}

                                          <div className="row">
                                            {(editQuestionData.id === questionData.id && (editQuestionData.type === QuestionType.mcq || editQuestionData.type === QuestionType.fill) && editQuestionData.optionWithImage === OptionWithImage.no) ?
                                              <div className="col-md-5">
                                                <div className="form-group">
                                                  <h6 className='highlightMediaText'>Media</h6>
                                                  <div className="customImgUpload mb-3">
                                                    <div className="uploadBtn">
                                                      {editQuestionData.mediaFile.questionMediaFile.files ?
                                                        <div className="w-100">
                                                              {editQuestionData.mediaFile.questionMediaFile.fileExtension === "json" ?
                                                                <div className="imgName" onClick={() => handleOpenAnimation(editQuestionData.mediaFile.questionMediaFile.files)}>
                                                                  {editQuestionData.mediaFile.questionMediaFile.files instanceof File ? editQuestionData.mediaFile.questionMediaFile.files.name : `questionMedia.json`}
                                                                </div>
                                                                :
                                                                
                                                          <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                            <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>
                                                                <img src={editQuestionData.mediaFile.questionMediaFile.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }} onClick={() => handleOpenImage(editQuestionData.mediaFile.questionMediaFile.files)} />
                                                              
                                                            </div>
                                                            
                                                          </div>
                                                              }
                                                          {editQuestionData.mediaFile.questionMediaFile.fileExtension !== "json" && editQuestionData.mediaFile.questionMediaFile.files instanceof File &&
                                                                        <div className="imgName">
                                                                          {editQuestionData.mediaFile.questionMediaFile.files.name}
                                                                        </div>
                                                                      }
                                                        </div>
                                                        :
                                                        <React.Fragment>
                                                          <img className="noimage" src={"./../assets/images/no-image-icon.png"} alt="" />
                                                          <label htmlFor={`question-media-${questionData.id}`}>Click to upload <span>png, jpg, jpeg, or json <br />(max 20mb)</span></label>
                                                          <input type="file" className="form-control d-none" name={`question-media`} id={`question-media-${questionData.id}`} onChange={(e) => handleOptionMedia(editQuestionData.type, e, -1, "image")} accept=".json, .png, .jpg, .jpeg" />

                                                        </React.Fragment>
                                                      }

                                                    </div>
                                                  </div>
                                                </div>
                                                {editQuestionData.mediaFile.questionMediaFile.files && <div className="row justify-content-center mt-2">
                                                  <div className="col-auto">
                                                    <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, editQuestionData.mediaFile.questionMediaFile.files, -1, "question-media", "image")}>
                                                      <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                    </button>
                                                  </div>
                                                </div>}
                                              </div>
                                              :

                                              ((questionData.type === QuestionType.mcq || questionData.type === QuestionType.fill) &&
                                                questionData.mediaFile.questionMediaFile.files && (
                                                  <div className="col-md-5">
                                                    <div className="form-group">
                                                      <h6 className='highlightMediaText'>Media</h6>
                                                      <div className="customImgUpload mb-3">
                                                        <div className="uploadBtn w-100">
                                                          
                                                              {questionData.mediaFile.questionMediaFile.fileExtension === "json" ? (
                                                               <div className="imgName" onClick={() => handleOpenAnimation(questionData.mediaFile.questionMediaFile.files)}>
                                                                  {/* {`question json`} */}
                                                                  {questionData.mediaFile.questionMediaFile.files instanceof File ? questionData.mediaFile.questionMediaFile.files.name : `questionMedia.json`}
                                                                </div>
                                                              ) : (
                                                                <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                            <div className="imagesPrev" style={{ margin: "0 auto", textAlign: "center" }}>
                                                                <img src={questionData.mediaFile.questionMediaFile.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh", }}  onClick={() => handleOpenImage(questionData.mediaFile.questionMediaFile.files)} />
                                                                
                                                            </div>
                                                          </div>
                                                              )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                ))

                                            }
                                          </div>


                                          {editQuestionData.id === questionData.id ? (
                                            <div className="row">
                                              <div className="col-md-5">
                                                <div className="form-group">
                                                  <h6 className='highlightMediaText'>Voice Over Audio <span className="text-danger">*</span></h6>
                                                  <div className="customImgUpload mb-3">
                                                    <div className="uploadBtn">
                                                      {editQuestionData.mediaFile.audioFile.files ? (
                                                        <div className="w-100">
                                                          <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                            <audio src={editQuestionData.mediaFile.audioFile.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />

                                                          </div>
                                                          {editQuestionData.mediaFile.audioFile.files instanceof File  &&
                                                            <div className="imgName">
                                                              {editQuestionData.mediaFile.audioFile.files.name}
                                                            </div>
                                                          }
                                                        </div>
                                                      ) : (
                                                        <React.Fragment>
                                                          <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                          <label htmlFor={`question-audio-file-${questionData.id}`}>
                                                            Click to upload <span>mp3 or wav <br />(max 20mb)</span>
                                                          </label>
                                                          <input type="file" className="form-control d-none" id={`question-audio-file-${questionData.id}`} name="voice-over-audio" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, -1, "audio")} required />
                                                          
                                                        </React.Fragment>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                                {editQuestionData.mediaFile.audioFile.files && <div className="row justify-content-center mt-2">
                                                  <div className="col-auto">
                                                    <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, editQuestionData.mediaFile.audioFile.files, -1, "voice-over-audio", "audio")}>
                                                      <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                    </button>
                                                  </div>
                                                </div>}
                                              </div>

                                              {editQuestionData.type === QuestionType.fill && <div className="col-md-5">
                                                <div className="form-group">
                                                  <h6 className='highlightMediaText'>Complete Answer Voice Over Audio <span className="text-danger">*</span></h6>
                                                  <div className="customImgUpload mb-3">
                                                    <div className="uploadBtn">
                                                      {editQuestionData.mediaFile.completeAudioFile.files ? (
                                                        <div className="w-100">
                                                          <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                            <audio src={editQuestionData.mediaFile.completeAudioFile.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />

                                                          </div>
                                                          {editQuestionData.mediaFile.completeAudioFile.files instanceof File  &&
                                                            <div className="imgName">
                                                              {editQuestionData.mediaFile.completeAudioFile.files.name}
                                                            </div>
                                                          }
                                                        </div>
                                                      ) : (
                                                        <React.Fragment>
                                                          <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                                          <label htmlFor={`question-complete-audio-file-${questionData.id}`}>
                                                            Click to upload <span>mp3 or wav <br />(max 20mb)</span>
                                                          </label>
                                                          <input type="file" className="form-control d-none" id={`question-complete-audio-file-${questionData.id}`} name="complete-voice-over-audio" accept=".mp3, .wav" onChange={(e) => handleOptionMedia(editQuestionData.type, e, -1, "complete-audio")} required />
                                                          
                                                        </React.Fragment>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                                {editQuestionData.mediaFile.completeAudioFile.files && <div className="row justify-content-center mt-2">
                                                  <div className="col-auto">
                                                    <button type="button" className="btn btnBorder mb-3 justify-content-start my-auto" style={{ padding: "6px 12px", width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992" }} onClick={() => handleOptionDelete(editQuestionData.type, editQuestionData.mediaFile.completeAudioFile.files, -1, "complete-voice-over-audio", "audio")}>
                                                      <img src="./../assets/images/trash1.svg" className='d-block' alt="Delete" style={{ marginRight: "12px" }} />Delete
                                                    </button>
                                                  </div>
                                                </div>}
                                              </div>}
                                            </div>
                                          ) : (
                                            <div className="row">
                                              {questionData.mediaFile.audioFile.files && (
                                                <div className="col-md-5">
                                                  <div className="form-group">
                                                    <h6 className='highlightMediaText'>Voice Over Audio <span className="text-danger">*</span></h6>
                                                    <div className="customImgUpload  mb-3">
                                                      <div className="uploadBtn">
                                                        <div className="w-100">
                                                          <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                            <div className="imagesPrev" style={{ margin: "0 auto", textAlign: "center" }}>
                                                              {editQuestionData.id === questionData.id ? null : (
                                                                <div className="w-100">
                                                                  <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                    <audio src={questionData.mediaFile.audioFile.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />
                                                                  </div>
                                                                  {questionData.mediaFile.audioFile.files instanceof File  && (
                                                                    <div className="imgName">
                                                                      {questionData.mediaFile.audioFile.files.name}
                                                                    </div>
                                                                  )}
                                                                </div>
                                                              )}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}

                                              {questionData.type === QuestionType.fill && questionData.mediaFile.completeAudioFile.files && (
                                                <div className="col-md-5">
                                                  <div className="form-group">
                                                    <h6 className='highlightMediaText'>Complete Answer Voice Over Audio <span className="text-danger">*</span></h6>
                                                    <div className="customImgUpload  mb-3">
                                                      <div className="uploadBtn">
                                                        <div className="w-100">
                                                          <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                            <div className="imagesPrev" style={{ margin: "0 auto", textAlign: "center" }}>
                                                              {editQuestionData.id === questionData.id ? null : (
                                                                <div className="w-100">
                                                                  <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                                                    <audio src={questionData.mediaFile.completeAudioFile.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />
                                                                  </div>
                                                                </div>
                                                              )}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          )}


                                          {editQuestionData.id === questionData.id &&
                                            <div className="row justify-content-center" style={{ padding: "25px 0" }}>
                                              <div className="col-md-3">
                                                <div className="btn-group w-100">
                                                  <button type="button" className="btn btn-save btnPurple" onClick={validateQuestionData}>Save</button>

                                                </div>
                                              </div>
                                              <div className="col-md-3">
                                                <button type="button" className="btn btn-cancel btnBorder" onClick={handleCancel}>Cancel</button>
                                              </div>
                                            </div>}
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                ))
                                :
                                <p className="text-center mt-5">No Data Found</p>
                              }


                            </React.Fragment>
                          }
                        </React.Fragment>
                      }
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id={`headingFour-${activeDifficultyType}`}>
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseFour-${activeDifficultyType}`} aria-expanded="false" aria-controls={`collapseFour-${activeDifficultyType}`}>
                      Congratulations Screen
                    </button>
                  </h2>
                  <div id={`collapseFour-${activeDifficultyType}`} className="accordion-collapse collapse" aria-labelledby={`headingFour-${activeDifficultyType}`} data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                      <div className="form-group">
                        <div className="row">
                          <div className="col-md-6">
                            <h6 className='highlightMediaText'>Congratulation Badge Icon <span className="text-danger">*</span></h6>
                            <div className="customImgUpload whitebg mb-3">
                              <div className="uploadBtn">
                                {editIntroData.congratulation.congratulationBadgeIcon.files ? (
                                  <div className="w-100">
                                    <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                      <div className='imagesPrev' style={{ margin: "0 auto", textAlign: 'center' }}>

                                        <img src={editIntroData.congratulation.congratulationBadgeIcon.blobPath} alt="Preview" className="img-fluid" style={{ objectFit: "contain", width: "100%", maxWidth: "10vw", maxHeight: "10vh" }}  onClick={() => handleOpenImage(editIntroData.congratulation.congratulationBadgeIcon.files)} />

                                      </div>
                                    </div>
                                    {editIntroData.congratulation.congratulationBadgeIcon.files instanceof File  &&
                                      <div className="imgName">
                                        {editIntroData.congratulation.congratulationBadgeIcon.files.name}
                                      </div>
                                    }
                                  </div>
                                ) : (
                                  <React.Fragment>
                                    <img className="noimage" src="./../assets/images/no-image-icon.png" alt="No content available" />
                                    <label htmlFor={`congratulation-badge-icon-${editIntroData.congratulation.congratulationId}-${activeDifficultyType}`}>
                                      Click to upload  <span>.png, .jpg, .jpeg <br />(max 20mb)</span>
                                    </label>
                                    <input type="file" className="form-control d-none" id={`congratulation-badge-icon-${editIntroData.congratulation.congratulationId}-${activeDifficultyType}`} name="congratulations-badge" accept=".png, .jpg, .jpeg" onChange={(e) => handleCongratsInput(e, e.target.name, "")} required />
                                  </React.Fragment>
                                )}
                              </div>
                            </div>
                            {editIntroData.congratulation.congratulationBadgeIcon.files && (
                              <div className="row justify-content-center pt-3">
                                <div className="col-auto">
                                  <button type="button" className="btn btnBorder mb-3 justify-content-start p-0 my-auto" style={{ width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992", fontSize: "14px", fontWeight: "400" }}>
                                    <label className='m-0 flex' htmlFor={`congratulation-badge-icon-${editIntroData.congratulation.congratulationId}-${activeDifficultyType}`} style={{ padding: "6px 12px", cursor: 'pointer' }}>
                                      <img src="./../assets/images/replace.svg" alt="Replace" style={{ marginRight: "10px" }} />
                                      <input type="file" className="form-control d-none" id={`congratulation-badge-icon-${editIntroData.congratulation.congratulationId}-${activeDifficultyType}`} name="congratulations-badge" accept=".png, .jpg, .jpeg" onChange={(e) => handleCongratsInput(e, e.target.name, "")} required />
                                      Replace
                                    </label>
                                  </button>
                                </div>
                              </div>
                            )}

                          </div>

                          <div className="col-md-6">

                            <h6 className='highlightMediaText'>Congratulations Voice Over <span className="text-danger">*</span></h6>
                            {/* Audio Upload/Preview */}
                            <div className="customImgUpload whitebg mb-3">
                              <div className="uploadBtn">
                                {editIntroData.congratulation.congratulationAudio.files ? (
                                  <div className="w-100">
                                    <div className="prvBtns d-flex align-items-center justify-content-between w-100">
                                      <audio src={editIntroData.congratulation.congratulationAudio.blobPath} className="mx-auto" style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }} controls />
                                    </div>
                                    {editIntroData.congratulation.congratulationAudio.files instanceof File  && (
                                      <div className="imgName">{editIntroData.congratulation.congratulationAudio.files.name}</div>
                                    )}
                                  </div>
                                ) : (
                                  <React.Fragment>
                                    <img className="noimage" src="./../assets/images/audio-icon.svg" alt="audio-icon" />
                                    <label htmlFor={`congratulations-audio-${editIntroData.congratulation.congratulationId}`}>
                                      Click to upload <span>mp3 or wav <br />(max 20mb)</span>
                                    </label>
                                    <input type="file" className="form-control d-none" id={`congratulations-audio-${editIntroData.congratulation.congratulationId}`} name="congratulations-audio" accept=".mp3, .wav" onChange={(e) => handleCongratsInput(e, e.target.name, "")} required />
                                  </React.Fragment>
                                )}
                              </div>
                            </div>

                            {/* Replace Audio */}
                            {editIntroData.congratulation.congratulationAudio.files && (
                              <div className="row justify-content-center mt-2">
                                <div className="col-auto">
                                  <button type="button" className="btn btnBorder mb-3 justify-content-start p-0 my-auto" style={{ width: "100%", height: "auto", border: "1px #737992 solid", borderRadius: "8px", color: "#737992", fontSize: "14px", fontWeight: "400" }}>
                                    <label className='m-0 flex' htmlFor="congratulations-audio" style={{ padding: "6px 12px", cursor: 'pointer' }}>
                                      <img src="./../assets/images/replace.svg" alt="Replace" style={{ marginRight: "10px" }} />
                                      <input type="file" className="form-control d-none" id="congratulations-audio" name="congratulations-audio" accept=".mp3, .wav" onChange={(e) => handleCongratsInput(e, e.target.name, "")} required />
                                      Replace
                                    </label>
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>

                        </div>

                        <div className="mt-3">
                          <h6 className='highlightMediaText'>Congratulations Text <span className="text-danger">*</span></h6>
                          <ReactQuill className='whitebg' onChange={(value) => handleCongratsInput(null, "congratulation-text", value)} value={editIntroData?.congratulation?.congratulationText || ""} style={{ backgroundColor: "#ffffff", borderRadius: "8px", border: "0" }}
                            modules={{
                              toolbar: [
                                [{ header: [3, 4, false] }],
                                ["bold", "italic", "underline", "blockquote"],
                                [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
                                [{ align: [] }]
                              ]
                            }}
                          />
                        </div>

                        {activeDifficultyType === "3" &&
                          <div className="mt-3">
                            <h6 className='highlightMediaText'>Reward for Completion all Sections <span className="text-danger">*</span></h6>
                            <input type="number" name="congratulation-coins" className="form-control" placeholder="Reward" value={editIntroData.congratulation.congratulationCoins > -1 ? editIntroData.congratulation.congratulationCoins : ""} onKeyDown={(e) => {
                              if (e.key === 'e' || e.key === 'E') {
                                e.preventDefault();
                              }
                            }} onChange={(e) => handleCongratsInput(e, e.target.name, e.target.value)} onWheel={(e: any) => e.target.blur()} required />
                          </div>}
                      </div>
                      <div className="d-flex justify-content-end mt-3 mb-3">
                        <button type="button" className="btn btn-save btnPurple" style={{ width: '250px' }} onClick={validateCongratsData}>Save</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>

      </div>

      {loading.submitLoading &&
        <Loader message="Submitting Data..." />}
      {loading.fetchingLoading &&
        <Loader message="Fetching Data..." />}
      {loading.deleteLoading &&
        <Loader message="Deleting Data ..." />}
      {loading.validationLoading &&
        <Loader message="Validating Data ..." />}

      <FullScreenLottieAnimation
        show={showPreview.animationShow}
        animationPath={previewSource}
        onClose={handleClosePreview}
      />
      <FullScreenImagePreview
        show={showPreview.imageShow}
        imagePath={previewSource}
        onClose={handleClosePreview}
      />

      {message.errorMessage.length > 0 &&
        <CustomAlert
          errorCount={message.errorMessage.length}
          messages={message.errorMessage}
          onClose={() => { setMessage({ ...message, errorMessage: [] }) }}
        />
      }
      {show &&
        <ConfirmationPopup
          title={confirmationPopupData.title}
          message={confirmationPopupData.message}
          descriptions={confirmationPopupData.descriptions}
          isBackIterated={true}
          acceptText={confirmationPopupData.acceptText}
          cancelText={confirmationPopupData.cancelText}
          onAccept={confirmationPopupData.onAccept}
          onCancel={confirmationPopupData.onCancel}
          onCrossClick={confirmationPopupData.onCancel}
        />
      }
    </div>
  );
}

export default UnitIntro